// AUTO-GENERATED by packages/builtin-se/generate-registry.mjs — DO NOT EDIT BY HAND.
// Source files: apps/engine/public/builtin/se/<pack>/*.ogg
// Licenses:
//   - ui-audio / interface-sounds / impact-sounds / sci-fi-sounds: Creative Commons CC0 1.0 (Kenney.nl)
//   - pix-studio: 自社著作物 (Digital Cute / PIX STUDIO)
// To regenerate, run: node packages/builtin-se/generate-registry.mjs

export interface BuiltinSeEntry {
  /** プロジェクトを跨いで一意な ID。例: "ui-audio/click1" / "pix-studio/00_小物/.../置く" */
  id: string;
  /** どの組み込みパック由来か */
  pack: "ui-audio" | "interface-sounds" | "impact-sounds" | "sci-fi-sounds" | "pix-studio";
  /**
   * 表示用カテゴリ ID。Kenney は短い英語スラッグ("click" など)、
   * Pix Studio は "pix-studio/<トップディレクトリ名>"。
   */
  category: string;
  /** Pix Studio パック用のカテゴリラベル(Kenney は固定マップから引く) */
  categoryLabel?: string;
  /** 表示用名前 */
  name: string;
  /** 1 行説明(Pix Studio はサブカテゴリのパンくず) */
  description: string;
  /** Engine が解決するパス(必ず "builtin/" で始まる) */
  path: string;
  /** ファイルサイズ(byte) */
  size: number;
  /** 検索用タグ */
  tags: string[];
  /** 成人向け SE(picker のデフォルトで非表示) */
  adult: boolean;
}

export type BuiltinSePack = BuiltinSeEntry["pack"];

export const BUILTIN_SE_PACK_LABEL: Record<BuiltinSePack, string> = {
  "ui-audio": "Kenney UI Audio",
  "interface-sounds": "Kenney Interface Sounds",
  "impact-sounds": "Kenney Impact Sounds",
  "sci-fi-sounds": "Kenney Sci-Fi Sounds",
  "pix-studio": "PIX STUDIO",
};

/** Kenney カテゴリのラベル(category="click" 等の英語スラッグから引く) */
export const KENNEY_SE_CATEGORY_LABEL: Record<string, string> = {
  "click": "クリック",
  "rollover": "ホバー",
  "switch": "スイッチ",
  "confirm": "確認・選択",
  "cancel": "キャンセル",
  "error": "エラー・警告",
  "window": "ウィンドウ",
  "misc-ui": "その他 UI",
  "footstep": "足音",
  "impact": "衝撃",
  "sci-fi": "SF",
  "engine": "エンジン・推進",
  "weapon": "武器・爆発",
  "other": "その他"
};

export const KENNEY_SE_CATEGORY_ORDER: string[] = [
  "click",
  "rollover",
  "switch",
  "confirm",
  "cancel",
  "error",
  "window",
  "misc-ui",
  "footstep",
  "impact",
  "sci-fi",
  "engine",
  "weapon",
  "other"
];

/** Pix Studio カテゴリ(出現順) */
export const PIX_STUDIO_SE_CATEGORY_ORDER: { id: string; label: string }[] = [
  {
    "id": "pix-studio/小物",
    "label": "小物"
  },
  {
    "id": "pix-studio/電話・携帯",
    "label": "電話・携帯"
  },
  {
    "id": "pix-studio/日常生活音",
    "label": "日常生活音"
  },
  {
    "id": "pix-studio/料理・調理",
    "label": "料理・調理"
  },
  {
    "id": "pix-studio/PC・周辺機器・カメラ",
    "label": "PC・周辺機器・カメラ"
  },
  {
    "id": "pix-studio/攻撃",
    "label": "攻撃"
  },
  {
    "id": "pix-studio/人が出す音",
    "label": "人が出す音"
  },
  {
    "id": "pix-studio/学校",
    "label": "学校"
  },
  {
    "id": "pix-studio/アラーム",
    "label": "アラーム"
  },
  {
    "id": "pix-studio/駅",
    "label": "駅"
  },
  {
    "id": "pix-studio/救急・消防",
    "label": "救急・消防"
  },
  {
    "id": "pix-studio/車道",
    "label": "車道"
  },
  {
    "id": "pix-studio/線路",
    "label": "線路"
  },
  {
    "id": "pix-studio/食事関係",
    "label": "食事関係"
  },
  {
    "id": "pix-studio/イベント会場の音",
    "label": "イベント会場の音"
  },
  {
    "id": "pix-studio/スポーツ",
    "label": "スポーツ"
  },
  {
    "id": "pix-studio/花火",
    "label": "花火"
  },
  {
    "id": "pix-studio/風船",
    "label": "風船"
  },
  {
    "id": "pix-studio/遊園地",
    "label": "遊園地"
  },
  {
    "id": "pix-studio/自販機",
    "label": "自販機"
  },
  {
    "id": "pix-studio/店",
    "label": "店"
  },
  {
    "id": "pix-studio/工場",
    "label": "工場"
  },
  {
    "id": "pix-studio/寺・神社",
    "label": "寺・神社"
  },
  {
    "id": "pix-studio/空港・飛行機",
    "label": "空港・飛行機"
  },
  {
    "id": "pix-studio/工具",
    "label": "工具"
  },
  {
    "id": "pix-studio/工事",
    "label": "工事"
  },
  {
    "id": "pix-studio/自然の音",
    "label": "自然の音"
  },
  {
    "id": "pix-studio/天気",
    "label": "天気"
  },
  {
    "id": "pix-studio/屋外の環境音",
    "label": "屋外の環境音"
  },
  {
    "id": "pix-studio/環境音ノイズ",
    "label": "環境音ノイズ"
  },
  {
    "id": "pix-studio/楽器音",
    "label": "楽器音"
  },
  {
    "id": "pix-studio/動物",
    "label": "動物"
  },
  {
    "id": "pix-studio/海外の音",
    "label": "海外の音"
  },
  {
    "id": "pix-studio/その他の場所",
    "label": "その他の場所"
  },
  {
    "id": "pix-studio/RPGの音",
    "label": "RPGの音"
  },
  {
    "id": "pix-studio/モンスターの音",
    "label": "モンスターの音"
  },
  {
    "id": "pix-studio/爆発",
    "label": "爆発"
  },
  {
    "id": "pix-studio/SFの世界観",
    "label": "SFの世界観"
  },
  {
    "id": "pix-studio/重火器・光線",
    "label": "重火器・光線"
  },
  {
    "id": "pix-studio/ホラー",
    "label": "ホラー"
  },
  {
    "id": "pix-studio/ホラー心理系",
    "label": "ホラー心理系"
  },
  {
    "id": "pix-studio/アニメ演出",
    "label": "アニメ演出"
  },
  {
    "id": "pix-studio/システム効果音",
    "label": "システム効果音"
  },
  {
    "id": "pix-studio/エロ効果音",
    "label": "エロ効果音"
  }
];

/** 任意のエントリのカテゴリラベルを取得 */
export function builtinSeCategoryLabel(entry: BuiltinSeEntry): string {
  if (entry.pack === "pix-studio") return entry.categoryLabel ?? entry.category;
  return KENNEY_SE_CATEGORY_LABEL[entry.category] ?? entry.category;
}

export const BUILTIN_SE: BuiltinSeEntry[] = [
  {
    "id": "ui-audio/click1",
    "pack": "ui-audio",
    "category": "click",
    "name": "クリック音 1",
    "description": "短いボタンクリック音",
    "path": "builtin/se/ui-audio/click1.ogg",
    "size": 4983,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/click2",
    "pack": "ui-audio",
    "category": "click",
    "name": "クリック音 2",
    "description": "短いボタンクリック音",
    "path": "builtin/se/ui-audio/click2.ogg",
    "size": 4656,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/click3",
    "pack": "ui-audio",
    "category": "click",
    "name": "クリック音 3",
    "description": "短いボタンクリック音",
    "path": "builtin/se/ui-audio/click3.ogg",
    "size": 4880,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/click4",
    "pack": "ui-audio",
    "category": "click",
    "name": "クリック音 4",
    "description": "短いボタンクリック音",
    "path": "builtin/se/ui-audio/click4.ogg",
    "size": 4558,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/click5",
    "pack": "ui-audio",
    "category": "click",
    "name": "クリック音 5",
    "description": "短いボタンクリック音",
    "path": "builtin/se/ui-audio/click5.ogg",
    "size": 4532,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/mouseclick1",
    "pack": "ui-audio",
    "category": "click",
    "name": "マウスクリック 1",
    "description": "マウスボタン押下音",
    "path": "builtin/se/ui-audio/mouseclick1.ogg",
    "size": 4686,
    "tags": [
      "UI",
      "click",
      "mouse"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/mouserelease1",
    "pack": "ui-audio",
    "category": "click",
    "name": "マウスリリース 1",
    "description": "マウスボタン離し音",
    "path": "builtin/se/ui-audio/mouserelease1.ogg",
    "size": 4775,
    "tags": [
      "UI",
      "click",
      "mouse"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/rollover1",
    "pack": "ui-audio",
    "category": "rollover",
    "name": "ホバー音 1",
    "description": "ボタン上にカーソルを乗せた時の音",
    "path": "builtin/se/ui-audio/rollover1.ogg",
    "size": 5932,
    "tags": [
      "UI",
      "hover"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/rollover2",
    "pack": "ui-audio",
    "category": "rollover",
    "name": "ホバー音 2",
    "description": "ボタン上にカーソルを乗せた時の音",
    "path": "builtin/se/ui-audio/rollover2.ogg",
    "size": 4701,
    "tags": [
      "UI",
      "hover"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/rollover3",
    "pack": "ui-audio",
    "category": "rollover",
    "name": "ホバー音 3",
    "description": "ボタン上にカーソルを乗せた時の音",
    "path": "builtin/se/ui-audio/rollover3.ogg",
    "size": 4778,
    "tags": [
      "UI",
      "hover"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/rollover4",
    "pack": "ui-audio",
    "category": "rollover",
    "name": "ホバー音 4",
    "description": "ボタン上にカーソルを乗せた時の音",
    "path": "builtin/se/ui-audio/rollover4.ogg",
    "size": 5188,
    "tags": [
      "UI",
      "hover"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/rollover5",
    "pack": "ui-audio",
    "category": "rollover",
    "name": "ホバー音 5",
    "description": "ボタン上にカーソルを乗せた時の音",
    "path": "builtin/se/ui-audio/rollover5.ogg",
    "size": 5258,
    "tags": [
      "UI",
      "hover"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/rollover6",
    "pack": "ui-audio",
    "category": "rollover",
    "name": "ホバー音 6",
    "description": "ボタン上にカーソルを乗せた時の音",
    "path": "builtin/se/ui-audio/rollover6.ogg",
    "size": 5385,
    "tags": [
      "UI",
      "hover"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch1",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 1",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch1.ogg",
    "size": 6104,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch2",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 2",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch2.ogg",
    "size": 6042,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch3",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 3",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch3.ogg",
    "size": 6270,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch4",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 4",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch4.ogg",
    "size": 6477,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch5",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 5",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch5.ogg",
    "size": 6181,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch6",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 6",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch6.ogg",
    "size": 6610,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch7",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 7",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch7.ogg",
    "size": 5707,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch8",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 8",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch8.ogg",
    "size": 6253,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch9",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 9",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch9.ogg",
    "size": 6009,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch10",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 10",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch10.ogg",
    "size": 6456,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch11",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 11",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch11.ogg",
    "size": 6248,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch12",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 12",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch12.ogg",
    "size": 4588,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch13",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 13",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch13.ogg",
    "size": 4467,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch14",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 14",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch14.ogg",
    "size": 4522,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch15",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 15",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch15.ogg",
    "size": 6325,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch16",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 16",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch16.ogg",
    "size": 6991,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch17",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 17",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch17.ogg",
    "size": 6686,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch18",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 18",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch18.ogg",
    "size": 7633,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch19",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 19",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch19.ogg",
    "size": 7177,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch20",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 20",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch20.ogg",
    "size": 6965,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch21",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 21",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch21.ogg",
    "size": 7453,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch22",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 22",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch22.ogg",
    "size": 7116,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch23",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 23",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch23.ogg",
    "size": 7177,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch24",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 24",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch24.ogg",
    "size": 6340,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch25",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 25",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch25.ogg",
    "size": 7130,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch26",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 26",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch26.ogg",
    "size": 6031,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch27",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 27",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch27.ogg",
    "size": 6445,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch28",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 28",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch28.ogg",
    "size": 5916,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch29",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 29",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch29.ogg",
    "size": 6769,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch30",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 30",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch30.ogg",
    "size": 7151,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch31",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 31",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch31.ogg",
    "size": 8180,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch32",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 32",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch32.ogg",
    "size": 7868,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch33",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 33",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch33.ogg",
    "size": 8530,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch34",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 34",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch34.ogg",
    "size": 7910,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch35",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 35",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch35.ogg",
    "size": 6935,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch36",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 36",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch36.ogg",
    "size": 6616,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch37",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 37",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch37.ogg",
    "size": 6822,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "ui-audio/switch38",
    "pack": "ui-audio",
    "category": "switch",
    "name": "スイッチ 38",
    "description": "トグル・選択音",
    "path": "builtin/se/ui-audio/switch38.ogg",
    "size": 7303,
    "tags": [
      "UI",
      "switch",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/back_001",
    "pack": "interface-sounds",
    "category": "cancel",
    "name": "戻る 1",
    "description": "前画面に戻る音",
    "path": "builtin/se/interface-sounds/back_001.ogg",
    "size": 6997,
    "tags": [
      "UI",
      "back"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/back_002",
    "pack": "interface-sounds",
    "category": "cancel",
    "name": "戻る 2",
    "description": "前画面に戻る音",
    "path": "builtin/se/interface-sounds/back_002.ogg",
    "size": 7029,
    "tags": [
      "UI",
      "back"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/back_003",
    "pack": "interface-sounds",
    "category": "cancel",
    "name": "戻る 3",
    "description": "前画面に戻る音",
    "path": "builtin/se/interface-sounds/back_003.ogg",
    "size": 7208,
    "tags": [
      "UI",
      "back"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/back_004",
    "pack": "interface-sounds",
    "category": "cancel",
    "name": "戻る 4",
    "description": "前画面に戻る音",
    "path": "builtin/se/interface-sounds/back_004.ogg",
    "size": 6923,
    "tags": [
      "UI",
      "back"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/bong_001",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ボン 1",
    "description": "鈍い通知音",
    "path": "builtin/se/interface-sounds/bong_001.ogg",
    "size": 4848,
    "tags": [
      "UI",
      "notify"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/click_001",
    "pack": "interface-sounds",
    "category": "click",
    "name": "クリック [if] 1",
    "description": "クリック音 (interface 系)",
    "path": "builtin/se/interface-sounds/click_001.ogg",
    "size": 4876,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/click_002",
    "pack": "interface-sounds",
    "category": "click",
    "name": "クリック [if] 2",
    "description": "クリック音 (interface 系)",
    "path": "builtin/se/interface-sounds/click_002.ogg",
    "size": 4275,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/click_003",
    "pack": "interface-sounds",
    "category": "click",
    "name": "クリック [if] 3",
    "description": "クリック音 (interface 系)",
    "path": "builtin/se/interface-sounds/click_003.ogg",
    "size": 4371,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/click_004",
    "pack": "interface-sounds",
    "category": "click",
    "name": "クリック [if] 4",
    "description": "クリック音 (interface 系)",
    "path": "builtin/se/interface-sounds/click_004.ogg",
    "size": 4486,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/click_005",
    "pack": "interface-sounds",
    "category": "click",
    "name": "クリック [if] 5",
    "description": "クリック音 (interface 系)",
    "path": "builtin/se/interface-sounds/click_005.ogg",
    "size": 4410,
    "tags": [
      "UI",
      "click"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/close_001",
    "pack": "interface-sounds",
    "category": "window",
    "name": "閉じる 1",
    "description": "ウィンドウを閉じる音",
    "path": "builtin/se/interface-sounds/close_001.ogg",
    "size": 9915,
    "tags": [
      "UI",
      "window",
      "close"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/close_002",
    "pack": "interface-sounds",
    "category": "window",
    "name": "閉じる 2",
    "description": "ウィンドウを閉じる音",
    "path": "builtin/se/interface-sounds/close_002.ogg",
    "size": 14752,
    "tags": [
      "UI",
      "window",
      "close"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/close_003",
    "pack": "interface-sounds",
    "category": "window",
    "name": "閉じる 3",
    "description": "ウィンドウを閉じる音",
    "path": "builtin/se/interface-sounds/close_003.ogg",
    "size": 15648,
    "tags": [
      "UI",
      "window",
      "close"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/close_004",
    "pack": "interface-sounds",
    "category": "window",
    "name": "閉じる 4",
    "description": "ウィンドウを閉じる音",
    "path": "builtin/se/interface-sounds/close_004.ogg",
    "size": 16263,
    "tags": [
      "UI",
      "window",
      "close"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/confirmation_001",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "確認 1",
    "description": "確認・決定音",
    "path": "builtin/se/interface-sounds/confirmation_001.ogg",
    "size": 8968,
    "tags": [
      "UI",
      "confirm"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/confirmation_002",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "確認 2",
    "description": "確認・決定音",
    "path": "builtin/se/interface-sounds/confirmation_002.ogg",
    "size": 14169,
    "tags": [
      "UI",
      "confirm"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/confirmation_003",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "確認 3",
    "description": "確認・決定音",
    "path": "builtin/se/interface-sounds/confirmation_003.ogg",
    "size": 9535,
    "tags": [
      "UI",
      "confirm"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/confirmation_004",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "確認 4",
    "description": "確認・決定音",
    "path": "builtin/se/interface-sounds/confirmation_004.ogg",
    "size": 12391,
    "tags": [
      "UI",
      "confirm"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/drop_001",
    "pack": "interface-sounds",
    "category": "window",
    "name": "ドロップ 1",
    "description": "アイテムを置く音",
    "path": "builtin/se/interface-sounds/drop_001.ogg",
    "size": 5859,
    "tags": [
      "UI",
      "drop"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/drop_002",
    "pack": "interface-sounds",
    "category": "window",
    "name": "ドロップ 2",
    "description": "アイテムを置く音",
    "path": "builtin/se/interface-sounds/drop_002.ogg",
    "size": 6411,
    "tags": [
      "UI",
      "drop"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/drop_003",
    "pack": "interface-sounds",
    "category": "window",
    "name": "ドロップ 3",
    "description": "アイテムを置く音",
    "path": "builtin/se/interface-sounds/drop_003.ogg",
    "size": 6288,
    "tags": [
      "UI",
      "drop"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/drop_004",
    "pack": "interface-sounds",
    "category": "window",
    "name": "ドロップ 4",
    "description": "アイテムを置く音",
    "path": "builtin/se/interface-sounds/drop_004.ogg",
    "size": 7230,
    "tags": [
      "UI",
      "drop"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/error_001",
    "pack": "interface-sounds",
    "category": "error",
    "name": "エラー 1",
    "description": "操作不可・警告音",
    "path": "builtin/se/interface-sounds/error_001.ogg",
    "size": 7373,
    "tags": [
      "UI",
      "error"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/error_002",
    "pack": "interface-sounds",
    "category": "error",
    "name": "エラー 2",
    "description": "操作不可・警告音",
    "path": "builtin/se/interface-sounds/error_002.ogg",
    "size": 7369,
    "tags": [
      "UI",
      "error"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/error_003",
    "pack": "interface-sounds",
    "category": "error",
    "name": "エラー 3",
    "description": "操作不可・警告音",
    "path": "builtin/se/interface-sounds/error_003.ogg",
    "size": 12256,
    "tags": [
      "UI",
      "error"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/error_004",
    "pack": "interface-sounds",
    "category": "error",
    "name": "エラー 4",
    "description": "操作不可・警告音",
    "path": "builtin/se/interface-sounds/error_004.ogg",
    "size": 6393,
    "tags": [
      "UI",
      "error"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/error_005",
    "pack": "interface-sounds",
    "category": "error",
    "name": "エラー 5",
    "description": "操作不可・警告音",
    "path": "builtin/se/interface-sounds/error_005.ogg",
    "size": 7266,
    "tags": [
      "UI",
      "error"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/error_006",
    "pack": "interface-sounds",
    "category": "error",
    "name": "エラー 6",
    "description": "操作不可・警告音",
    "path": "builtin/se/interface-sounds/error_006.ogg",
    "size": 8288,
    "tags": [
      "UI",
      "error"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/error_007",
    "pack": "interface-sounds",
    "category": "error",
    "name": "エラー 7",
    "description": "操作不可・警告音",
    "path": "builtin/se/interface-sounds/error_007.ogg",
    "size": 10225,
    "tags": [
      "UI",
      "error"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/error_008",
    "pack": "interface-sounds",
    "category": "error",
    "name": "エラー 8",
    "description": "操作不可・警告音",
    "path": "builtin/se/interface-sounds/error_008.ogg",
    "size": 9215,
    "tags": [
      "UI",
      "error"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glass_001",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ガラス UI 1",
    "description": "ガラス的な金属音",
    "path": "builtin/se/interface-sounds/glass_001.ogg",
    "size": 6103,
    "tags": [
      "UI",
      "glass"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glass_002",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ガラス UI 2",
    "description": "ガラス的な金属音",
    "path": "builtin/se/interface-sounds/glass_002.ogg",
    "size": 4917,
    "tags": [
      "UI",
      "glass"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glass_003",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ガラス UI 3",
    "description": "ガラス的な金属音",
    "path": "builtin/se/interface-sounds/glass_003.ogg",
    "size": 5732,
    "tags": [
      "UI",
      "glass"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glass_004",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ガラス UI 4",
    "description": "ガラス的な金属音",
    "path": "builtin/se/interface-sounds/glass_004.ogg",
    "size": 8323,
    "tags": [
      "UI",
      "glass"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glass_005",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ガラス UI 5",
    "description": "ガラス的な金属音",
    "path": "builtin/se/interface-sounds/glass_005.ogg",
    "size": 6206,
    "tags": [
      "UI",
      "glass"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glass_006",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ガラス UI 6",
    "description": "ガラス的な金属音",
    "path": "builtin/se/interface-sounds/glass_006.ogg",
    "size": 6956,
    "tags": [
      "UI",
      "glass"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glitch_001",
    "pack": "interface-sounds",
    "category": "error",
    "name": "グリッチ 1",
    "description": "ノイズ・故障音",
    "path": "builtin/se/interface-sounds/glitch_001.ogg",
    "size": 5121,
    "tags": [
      "UI",
      "glitch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glitch_002",
    "pack": "interface-sounds",
    "category": "error",
    "name": "グリッチ 2",
    "description": "ノイズ・故障音",
    "path": "builtin/se/interface-sounds/glitch_002.ogg",
    "size": 5473,
    "tags": [
      "UI",
      "glitch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glitch_003",
    "pack": "interface-sounds",
    "category": "error",
    "name": "グリッチ 3",
    "description": "ノイズ・故障音",
    "path": "builtin/se/interface-sounds/glitch_003.ogg",
    "size": 4915,
    "tags": [
      "UI",
      "glitch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/glitch_004",
    "pack": "interface-sounds",
    "category": "error",
    "name": "グリッチ 4",
    "description": "ノイズ・故障音",
    "path": "builtin/se/interface-sounds/glitch_004.ogg",
    "size": 5225,
    "tags": [
      "UI",
      "glitch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_001",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 1",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_001.ogg",
    "size": 12111,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_002",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 2",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_002.ogg",
    "size": 9915,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_003",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 3",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_003.ogg",
    "size": 11748,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_004",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 4",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_004.ogg",
    "size": 17723,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_005",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 5",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_005.ogg",
    "size": 20900,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_006",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 6",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_006.ogg",
    "size": 11618,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_007",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 7",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_007.ogg",
    "size": 8097,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_008",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 8",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_008.ogg",
    "size": 9085,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/maximize_009",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最大化 9",
    "description": "ウィンドウ最大化音",
    "path": "builtin/se/interface-sounds/maximize_009.ogg",
    "size": 7650,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_001",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 1",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_001.ogg",
    "size": 11924,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_002",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 2",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_002.ogg",
    "size": 9441,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_003",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 3",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_003.ogg",
    "size": 11739,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_004",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 4",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_004.ogg",
    "size": 17099,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_005",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 5",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_005.ogg",
    "size": 19501,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_006",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 6",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_006.ogg",
    "size": 11292,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_007",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 7",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_007.ogg",
    "size": 7677,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_008",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 8",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_008.ogg",
    "size": 9298,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/minimize_009",
    "pack": "interface-sounds",
    "category": "window",
    "name": "最小化 9",
    "description": "ウィンドウ最小化音",
    "path": "builtin/se/interface-sounds/minimize_009.ogg",
    "size": 7665,
    "tags": [
      "UI",
      "window"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/open_001",
    "pack": "interface-sounds",
    "category": "window",
    "name": "開く 1",
    "description": "ウィンドウを開く音",
    "path": "builtin/se/interface-sounds/open_001.ogg",
    "size": 9834,
    "tags": [
      "UI",
      "window",
      "open"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/open_002",
    "pack": "interface-sounds",
    "category": "window",
    "name": "開く 2",
    "description": "ウィンドウを開く音",
    "path": "builtin/se/interface-sounds/open_002.ogg",
    "size": 14975,
    "tags": [
      "UI",
      "window",
      "open"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/open_003",
    "pack": "interface-sounds",
    "category": "window",
    "name": "開く 3",
    "description": "ウィンドウを開く音",
    "path": "builtin/se/interface-sounds/open_003.ogg",
    "size": 15046,
    "tags": [
      "UI",
      "window",
      "open"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/open_004",
    "pack": "interface-sounds",
    "category": "window",
    "name": "開く 4",
    "description": "ウィンドウを開く音",
    "path": "builtin/se/interface-sounds/open_004.ogg",
    "size": 15879,
    "tags": [
      "UI",
      "window",
      "open"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/pluck_001",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "プラック 1",
    "description": "弦をはじくような音",
    "path": "builtin/se/interface-sounds/pluck_001.ogg",
    "size": 6317,
    "tags": [
      "UI",
      "pluck"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/pluck_002",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "プラック 2",
    "description": "弦をはじくような音",
    "path": "builtin/se/interface-sounds/pluck_002.ogg",
    "size": 6941,
    "tags": [
      "UI",
      "pluck"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/question_001",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "クエスチョン 1",
    "description": "問いかけ・選択肢開始音",
    "path": "builtin/se/interface-sounds/question_001.ogg",
    "size": 11700,
    "tags": [
      "UI",
      "question"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/question_002",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "クエスチョン 2",
    "description": "問いかけ・選択肢開始音",
    "path": "builtin/se/interface-sounds/question_002.ogg",
    "size": 9455,
    "tags": [
      "UI",
      "question"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/question_003",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "クエスチョン 3",
    "description": "問いかけ・選択肢開始音",
    "path": "builtin/se/interface-sounds/question_003.ogg",
    "size": 8233,
    "tags": [
      "UI",
      "question"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/question_004",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "クエスチョン 4",
    "description": "問いかけ・選択肢開始音",
    "path": "builtin/se/interface-sounds/question_004.ogg",
    "size": 9821,
    "tags": [
      "UI",
      "question"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scratch_001",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクラッチ 1",
    "description": "擦るノイズ音",
    "path": "builtin/se/interface-sounds/scratch_001.ogg",
    "size": 8989,
    "tags": [
      "UI",
      "scratch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scratch_002",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクラッチ 2",
    "description": "擦るノイズ音",
    "path": "builtin/se/interface-sounds/scratch_002.ogg",
    "size": 9319,
    "tags": [
      "UI",
      "scratch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scratch_003",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクラッチ 3",
    "description": "擦るノイズ音",
    "path": "builtin/se/interface-sounds/scratch_003.ogg",
    "size": 8849,
    "tags": [
      "UI",
      "scratch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scratch_004",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクラッチ 4",
    "description": "擦るノイズ音",
    "path": "builtin/se/interface-sounds/scratch_004.ogg",
    "size": 16478,
    "tags": [
      "UI",
      "scratch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scratch_005",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクラッチ 5",
    "description": "擦るノイズ音",
    "path": "builtin/se/interface-sounds/scratch_005.ogg",
    "size": 15824,
    "tags": [
      "UI",
      "scratch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scroll_001",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクロール 1",
    "description": "リスト・ページ送り音",
    "path": "builtin/se/interface-sounds/scroll_001.ogg",
    "size": 21633,
    "tags": [
      "UI",
      "scroll"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scroll_002",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクロール 2",
    "description": "リスト・ページ送り音",
    "path": "builtin/se/interface-sounds/scroll_002.ogg",
    "size": 24628,
    "tags": [
      "UI",
      "scroll"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scroll_003",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクロール 3",
    "description": "リスト・ページ送り音",
    "path": "builtin/se/interface-sounds/scroll_003.ogg",
    "size": 29488,
    "tags": [
      "UI",
      "scroll"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scroll_004",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクロール 4",
    "description": "リスト・ページ送り音",
    "path": "builtin/se/interface-sounds/scroll_004.ogg",
    "size": 20348,
    "tags": [
      "UI",
      "scroll"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/scroll_005",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "スクロール 5",
    "description": "リスト・ページ送り音",
    "path": "builtin/se/interface-sounds/scroll_005.ogg",
    "size": 20448,
    "tags": [
      "UI",
      "scroll"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/select_001",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "セレクト 1",
    "description": "項目を選択した音",
    "path": "builtin/se/interface-sounds/select_001.ogg",
    "size": 5468,
    "tags": [
      "UI",
      "select"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/select_002",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "セレクト 2",
    "description": "項目を選択した音",
    "path": "builtin/se/interface-sounds/select_002.ogg",
    "size": 5463,
    "tags": [
      "UI",
      "select"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/select_003",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "セレクト 3",
    "description": "項目を選択した音",
    "path": "builtin/se/interface-sounds/select_003.ogg",
    "size": 6901,
    "tags": [
      "UI",
      "select"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/select_004",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "セレクト 4",
    "description": "項目を選択した音",
    "path": "builtin/se/interface-sounds/select_004.ogg",
    "size": 6909,
    "tags": [
      "UI",
      "select"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/select_005",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "セレクト 5",
    "description": "項目を選択した音",
    "path": "builtin/se/interface-sounds/select_005.ogg",
    "size": 6767,
    "tags": [
      "UI",
      "select"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/select_006",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "セレクト 6",
    "description": "項目を選択した音",
    "path": "builtin/se/interface-sounds/select_006.ogg",
    "size": 8101,
    "tags": [
      "UI",
      "select"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/select_007",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "セレクト 7",
    "description": "項目を選択した音",
    "path": "builtin/se/interface-sounds/select_007.ogg",
    "size": 6580,
    "tags": [
      "UI",
      "select"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/select_008",
    "pack": "interface-sounds",
    "category": "confirm",
    "name": "セレクト 8",
    "description": "項目を選択した音",
    "path": "builtin/se/interface-sounds/select_008.ogg",
    "size": 6339,
    "tags": [
      "UI",
      "select"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/switch_001",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "スイッチ [if] 1",
    "description": "トグル・切り替え音",
    "path": "builtin/se/interface-sounds/switch_001.ogg",
    "size": 6753,
    "tags": [
      "UI",
      "switch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/switch_002",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "スイッチ [if] 2",
    "description": "トグル・切り替え音",
    "path": "builtin/se/interface-sounds/switch_002.ogg",
    "size": 7097,
    "tags": [
      "UI",
      "switch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/switch_003",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "スイッチ [if] 3",
    "description": "トグル・切り替え音",
    "path": "builtin/se/interface-sounds/switch_003.ogg",
    "size": 9653,
    "tags": [
      "UI",
      "switch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/switch_004",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "スイッチ [if] 4",
    "description": "トグル・切り替え音",
    "path": "builtin/se/interface-sounds/switch_004.ogg",
    "size": 7248,
    "tags": [
      "UI",
      "switch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/switch_005",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "スイッチ [if] 5",
    "description": "トグル・切り替え音",
    "path": "builtin/se/interface-sounds/switch_005.ogg",
    "size": 7814,
    "tags": [
      "UI",
      "switch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/switch_006",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "スイッチ [if] 6",
    "description": "トグル・切り替え音",
    "path": "builtin/se/interface-sounds/switch_006.ogg",
    "size": 7873,
    "tags": [
      "UI",
      "switch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/switch_007",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "スイッチ [if] 7",
    "description": "トグル・切り替え音",
    "path": "builtin/se/interface-sounds/switch_007.ogg",
    "size": 7921,
    "tags": [
      "UI",
      "switch"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/tick_001",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ティック 1",
    "description": "短い拍子音 / カウントダウン",
    "path": "builtin/se/interface-sounds/tick_001.ogg",
    "size": 4497,
    "tags": [
      "UI",
      "tick"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/tick_002",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ティック 2",
    "description": "短い拍子音 / カウントダウン",
    "path": "builtin/se/interface-sounds/tick_002.ogg",
    "size": 4514,
    "tags": [
      "UI",
      "tick"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/tick_004",
    "pack": "interface-sounds",
    "category": "misc-ui",
    "name": "ティック 4",
    "description": "短い拍子音 / カウントダウン",
    "path": "builtin/se/interface-sounds/tick_004.ogg",
    "size": 5031,
    "tags": [
      "UI",
      "tick"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/toggle_001",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "トグル 1",
    "description": "オン/オフ切り替え音",
    "path": "builtin/se/interface-sounds/toggle_001.ogg",
    "size": 7369,
    "tags": [
      "UI",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/toggle_002",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "トグル 2",
    "description": "オン/オフ切り替え音",
    "path": "builtin/se/interface-sounds/toggle_002.ogg",
    "size": 8056,
    "tags": [
      "UI",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/toggle_003",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "トグル 3",
    "description": "オン/オフ切り替え音",
    "path": "builtin/se/interface-sounds/toggle_003.ogg",
    "size": 8654,
    "tags": [
      "UI",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "interface-sounds/toggle_004",
    "pack": "interface-sounds",
    "category": "switch",
    "name": "トグル 4",
    "description": "オン/オフ切り替え音",
    "path": "builtin/se/interface-sounds/toggle_004.ogg",
    "size": 6695,
    "tags": [
      "UI",
      "toggle"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_carpet_000",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (カーペット) 0",
    "description": "カーペットを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_carpet_000.ogg",
    "size": 6353,
    "tags": [
      "footstep",
      "carpet"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_carpet_001",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (カーペット) 1",
    "description": "カーペットを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_carpet_001.ogg",
    "size": 6411,
    "tags": [
      "footstep",
      "carpet"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_carpet_002",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (カーペット) 2",
    "description": "カーペットを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_carpet_002.ogg",
    "size": 6411,
    "tags": [
      "footstep",
      "carpet"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_carpet_003",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (カーペット) 3",
    "description": "カーペットを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_carpet_003.ogg",
    "size": 6301,
    "tags": [
      "footstep",
      "carpet"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_carpet_004",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (カーペット) 4",
    "description": "カーペットを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_carpet_004.ogg",
    "size": 6301,
    "tags": [
      "footstep",
      "carpet"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_concrete_000",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (コンクリート) 0",
    "description": "コンクリートを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_concrete_000.ogg",
    "size": 5808,
    "tags": [
      "footstep",
      "concrete"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_concrete_001",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (コンクリート) 1",
    "description": "コンクリートを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_concrete_001.ogg",
    "size": 6308,
    "tags": [
      "footstep",
      "concrete"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_concrete_002",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (コンクリート) 2",
    "description": "コンクリートを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_concrete_002.ogg",
    "size": 6255,
    "tags": [
      "footstep",
      "concrete"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_concrete_003",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (コンクリート) 3",
    "description": "コンクリートを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_concrete_003.ogg",
    "size": 5805,
    "tags": [
      "footstep",
      "concrete"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_concrete_004",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (コンクリート) 4",
    "description": "コンクリートを歩く足音",
    "path": "builtin/se/impact-sounds/footstep_concrete_004.ogg",
    "size": 5912,
    "tags": [
      "footstep",
      "concrete"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_grass_000",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (草地) 0",
    "description": "草地を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_grass_000.ogg",
    "size": 8290,
    "tags": [
      "footstep",
      "grass"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_grass_001",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (草地) 1",
    "description": "草地を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_grass_001.ogg",
    "size": 8313,
    "tags": [
      "footstep",
      "grass"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_grass_002",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (草地) 2",
    "description": "草地を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_grass_002.ogg",
    "size": 8278,
    "tags": [
      "footstep",
      "grass"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_grass_003",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (草地) 3",
    "description": "草地を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_grass_003.ogg",
    "size": 8129,
    "tags": [
      "footstep",
      "grass"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_grass_004",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (草地) 4",
    "description": "草地を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_grass_004.ogg",
    "size": 7800,
    "tags": [
      "footstep",
      "grass"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_snow_000",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (雪) 0",
    "description": "雪を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_snow_000.ogg",
    "size": 7880,
    "tags": [
      "footstep",
      "snow"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_snow_001",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (雪) 1",
    "description": "雪を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_snow_001.ogg",
    "size": 7794,
    "tags": [
      "footstep",
      "snow"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_snow_002",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (雪) 2",
    "description": "雪を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_snow_002.ogg",
    "size": 7694,
    "tags": [
      "footstep",
      "snow"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_snow_003",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (雪) 3",
    "description": "雪を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_snow_003.ogg",
    "size": 7860,
    "tags": [
      "footstep",
      "snow"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_snow_004",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (雪) 4",
    "description": "雪を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_snow_004.ogg",
    "size": 7630,
    "tags": [
      "footstep",
      "snow"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_wood_000",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (木材) 0",
    "description": "木材を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_wood_000.ogg",
    "size": 5949,
    "tags": [
      "footstep",
      "wood"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_wood_001",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (木材) 1",
    "description": "木材を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_wood_001.ogg",
    "size": 5929,
    "tags": [
      "footstep",
      "wood"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_wood_002",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (木材) 2",
    "description": "木材を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_wood_002.ogg",
    "size": 5895,
    "tags": [
      "footstep",
      "wood"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_wood_003",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (木材) 3",
    "description": "木材を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_wood_003.ogg",
    "size": 6207,
    "tags": [
      "footstep",
      "wood"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/footstep_wood_004",
    "pack": "impact-sounds",
    "category": "footstep",
    "name": "足音 (木材) 4",
    "description": "木材を歩く足音",
    "path": "builtin/se/impact-sounds/footstep_wood_004.ogg",
    "size": 5799,
    "tags": [
      "footstep",
      "wood"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactBell_heavy_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ベル (大) 0",
    "description": "ベルへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactBell_heavy_000.ogg",
    "size": 13915,
    "tags": [
      "impact",
      "bell",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactBell_heavy_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ベル (大) 1",
    "description": "ベルへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactBell_heavy_001.ogg",
    "size": 15577,
    "tags": [
      "impact",
      "bell",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactBell_heavy_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ベル (大) 2",
    "description": "ベルへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactBell_heavy_002.ogg",
    "size": 9252,
    "tags": [
      "impact",
      "bell",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactBell_heavy_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ベル (大) 3",
    "description": "ベルへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactBell_heavy_003.ogg",
    "size": 9429,
    "tags": [
      "impact",
      "bell",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactBell_heavy_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ベル (大) 4",
    "description": "ベルへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactBell_heavy_004.ogg",
    "size": 6529,
    "tags": [
      "impact",
      "bell",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGeneric_light_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 汎用 (小) 0",
    "description": "汎用への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGeneric_light_000.ogg",
    "size": 5827,
    "tags": [
      "impact",
      "generic",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGeneric_light_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 汎用 (小) 1",
    "description": "汎用への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGeneric_light_001.ogg",
    "size": 5636,
    "tags": [
      "impact",
      "generic",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGeneric_light_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 汎用 (小) 2",
    "description": "汎用への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGeneric_light_002.ogg",
    "size": 5795,
    "tags": [
      "impact",
      "generic",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGeneric_light_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 汎用 (小) 3",
    "description": "汎用への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGeneric_light_003.ogg",
    "size": 5792,
    "tags": [
      "impact",
      "generic",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGeneric_light_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 汎用 (小) 4",
    "description": "汎用への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGeneric_light_004.ogg",
    "size": 5747,
    "tags": [
      "impact",
      "generic",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_heavy_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (大) 0",
    "description": "ガラスへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactGlass_heavy_000.ogg",
    "size": 7403,
    "tags": [
      "impact",
      "glass",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_heavy_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (大) 1",
    "description": "ガラスへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactGlass_heavy_001.ogg",
    "size": 8946,
    "tags": [
      "impact",
      "glass",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_heavy_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (大) 2",
    "description": "ガラスへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactGlass_heavy_002.ogg",
    "size": 7661,
    "tags": [
      "impact",
      "glass",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_heavy_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (大) 3",
    "description": "ガラスへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactGlass_heavy_003.ogg",
    "size": 6956,
    "tags": [
      "impact",
      "glass",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_heavy_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (大) 4",
    "description": "ガラスへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactGlass_heavy_004.ogg",
    "size": 8300,
    "tags": [
      "impact",
      "glass",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_light_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (小) 0",
    "description": "ガラスへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGlass_light_000.ogg",
    "size": 6526,
    "tags": [
      "impact",
      "glass",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_light_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (小) 1",
    "description": "ガラスへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGlass_light_001.ogg",
    "size": 6544,
    "tags": [
      "impact",
      "glass",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_light_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (小) 2",
    "description": "ガラスへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGlass_light_002.ogg",
    "size": 6562,
    "tags": [
      "impact",
      "glass",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_light_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (小) 3",
    "description": "ガラスへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGlass_light_003.ogg",
    "size": 6618,
    "tags": [
      "impact",
      "glass",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_light_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (小) 4",
    "description": "ガラスへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactGlass_light_004.ogg",
    "size": 6641,
    "tags": [
      "impact",
      "glass",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_medium_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (中) 0",
    "description": "ガラスへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactGlass_medium_000.ogg",
    "size": 8400,
    "tags": [
      "impact",
      "glass",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_medium_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (中) 1",
    "description": "ガラスへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactGlass_medium_001.ogg",
    "size": 8605,
    "tags": [
      "impact",
      "glass",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_medium_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (中) 2",
    "description": "ガラスへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactGlass_medium_002.ogg",
    "size": 8341,
    "tags": [
      "impact",
      "glass",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_medium_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (中) 3",
    "description": "ガラスへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactGlass_medium_003.ogg",
    "size": 8596,
    "tags": [
      "impact",
      "glass",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactGlass_medium_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ガラス (中) 4",
    "description": "ガラスへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactGlass_medium_004.ogg",
    "size": 8397,
    "tags": [
      "impact",
      "glass",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_heavy_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (大) 0",
    "description": "金属への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactMetal_heavy_000.ogg",
    "size": 6110,
    "tags": [
      "impact",
      "metal",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_heavy_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (大) 1",
    "description": "金属への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactMetal_heavy_001.ogg",
    "size": 7279,
    "tags": [
      "impact",
      "metal",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_heavy_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (大) 2",
    "description": "金属への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactMetal_heavy_002.ogg",
    "size": 5634,
    "tags": [
      "impact",
      "metal",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_heavy_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (大) 3",
    "description": "金属への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactMetal_heavy_003.ogg",
    "size": 6209,
    "tags": [
      "impact",
      "metal",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_heavy_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (大) 4",
    "description": "金属への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactMetal_heavy_004.ogg",
    "size": 5788,
    "tags": [
      "impact",
      "metal",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_light_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (小) 0",
    "description": "金属への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactMetal_light_000.ogg",
    "size": 7651,
    "tags": [
      "impact",
      "metal",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_light_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (小) 1",
    "description": "金属への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactMetal_light_001.ogg",
    "size": 6967,
    "tags": [
      "impact",
      "metal",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_light_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (小) 2",
    "description": "金属への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactMetal_light_002.ogg",
    "size": 6804,
    "tags": [
      "impact",
      "metal",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_light_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (小) 3",
    "description": "金属への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactMetal_light_003.ogg",
    "size": 9023,
    "tags": [
      "impact",
      "metal",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_light_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (小) 4",
    "description": "金属への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactMetal_light_004.ogg",
    "size": 6675,
    "tags": [
      "impact",
      "metal",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_medium_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (中) 0",
    "description": "金属への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactMetal_medium_000.ogg",
    "size": 7117,
    "tags": [
      "impact",
      "metal",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_medium_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (中) 1",
    "description": "金属への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactMetal_medium_001.ogg",
    "size": 6151,
    "tags": [
      "impact",
      "metal",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_medium_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (中) 2",
    "description": "金属への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactMetal_medium_002.ogg",
    "size": 5857,
    "tags": [
      "impact",
      "metal",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_medium_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (中) 3",
    "description": "金属への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactMetal_medium_003.ogg",
    "size": 6964,
    "tags": [
      "impact",
      "metal",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMetal_medium_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 金属 (中) 4",
    "description": "金属への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactMetal_medium_004.ogg",
    "size": 5744,
    "tags": [
      "impact",
      "metal",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMining_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 採掘 0",
    "description": "採掘への衝撃音 ",
    "path": "builtin/se/impact-sounds/impactMining_000.ogg",
    "size": 12035,
    "tags": [
      "impact",
      "mining"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMining_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 採掘 1",
    "description": "採掘への衝撃音 ",
    "path": "builtin/se/impact-sounds/impactMining_001.ogg",
    "size": 11481,
    "tags": [
      "impact",
      "mining"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMining_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 採掘 2",
    "description": "採掘への衝撃音 ",
    "path": "builtin/se/impact-sounds/impactMining_002.ogg",
    "size": 11235,
    "tags": [
      "impact",
      "mining"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMining_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 採掘 3",
    "description": "採掘への衝撃音 ",
    "path": "builtin/se/impact-sounds/impactMining_003.ogg",
    "size": 12160,
    "tags": [
      "impact",
      "mining"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactMining_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 採掘 4",
    "description": "採掘への衝撃音 ",
    "path": "builtin/se/impact-sounds/impactMining_004.ogg",
    "size": 11668,
    "tags": [
      "impact",
      "mining"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlank_medium_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 板 (中) 0",
    "description": "板への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlank_medium_000.ogg",
    "size": 12016,
    "tags": [
      "impact",
      "plank",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlank_medium_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 板 (中) 1",
    "description": "板への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlank_medium_001.ogg",
    "size": 12082,
    "tags": [
      "impact",
      "plank",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlank_medium_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 板 (中) 2",
    "description": "板への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlank_medium_002.ogg",
    "size": 12313,
    "tags": [
      "impact",
      "plank",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlank_medium_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 板 (中) 3",
    "description": "板への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlank_medium_003.ogg",
    "size": 12138,
    "tags": [
      "impact",
      "plank",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlank_medium_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 板 (中) 4",
    "description": "板への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlank_medium_004.ogg",
    "size": 12084,
    "tags": [
      "impact",
      "plank",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_heavy_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (大) 0",
    "description": "プレートへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPlate_heavy_000.ogg",
    "size": 10032,
    "tags": [
      "impact",
      "plate",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_heavy_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (大) 1",
    "description": "プレートへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPlate_heavy_001.ogg",
    "size": 8713,
    "tags": [
      "impact",
      "plate",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_heavy_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (大) 2",
    "description": "プレートへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPlate_heavy_002.ogg",
    "size": 10188,
    "tags": [
      "impact",
      "plate",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_heavy_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (大) 3",
    "description": "プレートへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPlate_heavy_003.ogg",
    "size": 8490,
    "tags": [
      "impact",
      "plate",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_heavy_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (大) 4",
    "description": "プレートへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPlate_heavy_004.ogg",
    "size": 11092,
    "tags": [
      "impact",
      "plate",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_light_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (小) 0",
    "description": "プレートへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactPlate_light_000.ogg",
    "size": 10474,
    "tags": [
      "impact",
      "plate",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_light_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (小) 1",
    "description": "プレートへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactPlate_light_001.ogg",
    "size": 11730,
    "tags": [
      "impact",
      "plate",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_light_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (小) 2",
    "description": "プレートへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactPlate_light_002.ogg",
    "size": 9932,
    "tags": [
      "impact",
      "plate",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_light_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (小) 3",
    "description": "プレートへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactPlate_light_003.ogg",
    "size": 10626,
    "tags": [
      "impact",
      "plate",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_light_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (小) 4",
    "description": "プレートへの衝撃音 小",
    "path": "builtin/se/impact-sounds/impactPlate_light_004.ogg",
    "size": 11928,
    "tags": [
      "impact",
      "plate",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_medium_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (中) 0",
    "description": "プレートへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlate_medium_000.ogg",
    "size": 10921,
    "tags": [
      "impact",
      "plate",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_medium_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (中) 1",
    "description": "プレートへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlate_medium_001.ogg",
    "size": 11491,
    "tags": [
      "impact",
      "plate",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_medium_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (中) 2",
    "description": "プレートへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlate_medium_002.ogg",
    "size": 10250,
    "tags": [
      "impact",
      "plate",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_medium_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (中) 3",
    "description": "プレートへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlate_medium_003.ogg",
    "size": 11616,
    "tags": [
      "impact",
      "plate",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPlate_medium_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 プレート (中) 4",
    "description": "プレートへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPlate_medium_004.ogg",
    "size": 10803,
    "tags": [
      "impact",
      "plate",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_heavy_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (大) 0",
    "description": "パンチへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPunch_heavy_000.ogg",
    "size": 11617,
    "tags": [
      "impact",
      "punch",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_heavy_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (大) 1",
    "description": "パンチへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPunch_heavy_001.ogg",
    "size": 10861,
    "tags": [
      "impact",
      "punch",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_heavy_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (大) 2",
    "description": "パンチへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPunch_heavy_002.ogg",
    "size": 9025,
    "tags": [
      "impact",
      "punch",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_heavy_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (大) 3",
    "description": "パンチへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPunch_heavy_003.ogg",
    "size": 10029,
    "tags": [
      "impact",
      "punch",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_heavy_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (大) 4",
    "description": "パンチへの衝撃音 大",
    "path": "builtin/se/impact-sounds/impactPunch_heavy_004.ogg",
    "size": 10452,
    "tags": [
      "impact",
      "punch",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_medium_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (中) 0",
    "description": "パンチへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPunch_medium_000.ogg",
    "size": 8800,
    "tags": [
      "impact",
      "punch",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_medium_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (中) 1",
    "description": "パンチへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPunch_medium_001.ogg",
    "size": 8701,
    "tags": [
      "impact",
      "punch",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_medium_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (中) 2",
    "description": "パンチへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPunch_medium_002.ogg",
    "size": 10399,
    "tags": [
      "impact",
      "punch",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_medium_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (中) 3",
    "description": "パンチへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPunch_medium_003.ogg",
    "size": 9509,
    "tags": [
      "impact",
      "punch",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactPunch_medium_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 パンチ (中) 4",
    "description": "パンチへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactPunch_medium_004.ogg",
    "size": 10032,
    "tags": [
      "impact",
      "punch",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_heavy_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (大) 0",
    "description": "柔への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactSoft_heavy_000.ogg",
    "size": 6570,
    "tags": [
      "impact",
      "soft",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_heavy_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (大) 1",
    "description": "柔への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactSoft_heavy_001.ogg",
    "size": 6689,
    "tags": [
      "impact",
      "soft",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_heavy_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (大) 2",
    "description": "柔への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactSoft_heavy_002.ogg",
    "size": 6749,
    "tags": [
      "impact",
      "soft",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_heavy_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (大) 3",
    "description": "柔への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactSoft_heavy_003.ogg",
    "size": 6665,
    "tags": [
      "impact",
      "soft",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_heavy_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (大) 4",
    "description": "柔への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactSoft_heavy_004.ogg",
    "size": 6478,
    "tags": [
      "impact",
      "soft",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_medium_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (中) 0",
    "description": "柔への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactSoft_medium_000.ogg",
    "size": 5351,
    "tags": [
      "impact",
      "soft",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_medium_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (中) 1",
    "description": "柔への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactSoft_medium_001.ogg",
    "size": 5506,
    "tags": [
      "impact",
      "soft",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_medium_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (中) 2",
    "description": "柔への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactSoft_medium_002.ogg",
    "size": 5358,
    "tags": [
      "impact",
      "soft",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_medium_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (中) 3",
    "description": "柔への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactSoft_medium_003.ogg",
    "size": 5392,
    "tags": [
      "impact",
      "soft",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactSoft_medium_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 柔 (中) 4",
    "description": "柔への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactSoft_medium_004.ogg",
    "size": 5438,
    "tags": [
      "impact",
      "soft",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactTin_medium_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ブリキ (中) 0",
    "description": "ブリキへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactTin_medium_000.ogg",
    "size": 6509,
    "tags": [
      "impact",
      "tin",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactTin_medium_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ブリキ (中) 1",
    "description": "ブリキへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactTin_medium_001.ogg",
    "size": 6603,
    "tags": [
      "impact",
      "tin",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactTin_medium_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ブリキ (中) 2",
    "description": "ブリキへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactTin_medium_002.ogg",
    "size": 6156,
    "tags": [
      "impact",
      "tin",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactTin_medium_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ブリキ (中) 3",
    "description": "ブリキへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactTin_medium_003.ogg",
    "size": 6541,
    "tags": [
      "impact",
      "tin",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactTin_medium_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 ブリキ (中) 4",
    "description": "ブリキへの衝撃音 中",
    "path": "builtin/se/impact-sounds/impactTin_medium_004.ogg",
    "size": 6362,
    "tags": [
      "impact",
      "tin",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_heavy_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (大) 0",
    "description": "木への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactWood_heavy_000.ogg",
    "size": 6233,
    "tags": [
      "impact",
      "wood",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_heavy_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (大) 1",
    "description": "木への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactWood_heavy_001.ogg",
    "size": 6239,
    "tags": [
      "impact",
      "wood",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_heavy_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (大) 2",
    "description": "木への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactWood_heavy_002.ogg",
    "size": 6146,
    "tags": [
      "impact",
      "wood",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_heavy_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (大) 3",
    "description": "木への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactWood_heavy_003.ogg",
    "size": 6181,
    "tags": [
      "impact",
      "wood",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_heavy_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (大) 4",
    "description": "木への衝撃音 大",
    "path": "builtin/se/impact-sounds/impactWood_heavy_004.ogg",
    "size": 6253,
    "tags": [
      "impact",
      "wood",
      "heavy"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_light_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (小) 0",
    "description": "木への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactWood_light_000.ogg",
    "size": 6343,
    "tags": [
      "impact",
      "wood",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_light_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (小) 1",
    "description": "木への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactWood_light_001.ogg",
    "size": 6373,
    "tags": [
      "impact",
      "wood",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_light_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (小) 2",
    "description": "木への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactWood_light_002.ogg",
    "size": 6366,
    "tags": [
      "impact",
      "wood",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_light_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (小) 3",
    "description": "木への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactWood_light_003.ogg",
    "size": 6381,
    "tags": [
      "impact",
      "wood",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_light_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (小) 4",
    "description": "木への衝撃音 小",
    "path": "builtin/se/impact-sounds/impactWood_light_004.ogg",
    "size": 6395,
    "tags": [
      "impact",
      "wood",
      "light"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_medium_000",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (中) 0",
    "description": "木への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactWood_medium_000.ogg",
    "size": 6575,
    "tags": [
      "impact",
      "wood",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_medium_001",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (中) 1",
    "description": "木への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactWood_medium_001.ogg",
    "size": 6555,
    "tags": [
      "impact",
      "wood",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_medium_002",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (中) 2",
    "description": "木への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactWood_medium_002.ogg",
    "size": 6607,
    "tags": [
      "impact",
      "wood",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_medium_003",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (中) 3",
    "description": "木への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactWood_medium_003.ogg",
    "size": 6598,
    "tags": [
      "impact",
      "wood",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "impact-sounds/impactWood_medium_004",
    "pack": "impact-sounds",
    "category": "impact",
    "name": "衝撃 木 (中) 4",
    "description": "木への衝撃音 中",
    "path": "builtin/se/impact-sounds/impactWood_medium_004.ogg",
    "size": 6481,
    "tags": [
      "impact",
      "wood",
      "medium"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/computerNoise_000",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "コンピューターノイズ 0",
    "description": "電子機器の動作音",
    "path": "builtin/se/sci-fi-sounds/computerNoise_000.ogg",
    "size": 119024,
    "tags": [
      "scifi",
      "computer"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/computerNoise_001",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "コンピューターノイズ 1",
    "description": "電子機器の動作音",
    "path": "builtin/se/sci-fi-sounds/computerNoise_001.ogg",
    "size": 120178,
    "tags": [
      "scifi",
      "computer"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/computerNoise_002",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "コンピューターノイズ 2",
    "description": "電子機器の動作音",
    "path": "builtin/se/sci-fi-sounds/computerNoise_002.ogg",
    "size": 130861,
    "tags": [
      "scifi",
      "computer"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/computerNoise_003",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "コンピューターノイズ 3",
    "description": "電子機器の動作音",
    "path": "builtin/se/sci-fi-sounds/computerNoise_003.ogg",
    "size": 123515,
    "tags": [
      "scifi",
      "computer"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/doorClose_000",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "ドアを閉じる (SF) 0",
    "description": "SF 系ドア開閉音",
    "path": "builtin/se/sci-fi-sounds/doorClose_000.ogg",
    "size": 20369,
    "tags": [
      "scifi",
      "door"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/doorClose_001",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "ドアを閉じる (SF) 1",
    "description": "SF 系ドア開閉音",
    "path": "builtin/se/sci-fi-sounds/doorClose_001.ogg",
    "size": 21561,
    "tags": [
      "scifi",
      "door"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/doorClose_002",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "ドアを閉じる (SF) 2",
    "description": "SF 系ドア開閉音",
    "path": "builtin/se/sci-fi-sounds/doorClose_002.ogg",
    "size": 20530,
    "tags": [
      "scifi",
      "door"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/doorOpen_000",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "ドアを開く (SF) 0",
    "description": "SF 系ドア開閉音",
    "path": "builtin/se/sci-fi-sounds/doorOpen_000.ogg",
    "size": 19616,
    "tags": [
      "scifi",
      "door"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/doorOpen_001",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "ドアを開く (SF) 1",
    "description": "SF 系ドア開閉音",
    "path": "builtin/se/sci-fi-sounds/doorOpen_001.ogg",
    "size": 21442,
    "tags": [
      "scifi",
      "door"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/doorOpen_002",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "ドアを開く (SF) 2",
    "description": "SF 系ドア開閉音",
    "path": "builtin/se/sci-fi-sounds/doorOpen_002.ogg",
    "size": 19864,
    "tags": [
      "scifi",
      "door"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/engineCircular_000",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "循環エンジン 0",
    "description": "回転式エンジン音",
    "path": "builtin/se/sci-fi-sounds/engineCircular_000.ogg",
    "size": 177470,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/engineCircular_001",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "循環エンジン 1",
    "description": "回転式エンジン音",
    "path": "builtin/se/sci-fi-sounds/engineCircular_001.ogg",
    "size": 199100,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/engineCircular_002",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "循環エンジン 2",
    "description": "回転式エンジン音",
    "path": "builtin/se/sci-fi-sounds/engineCircular_002.ogg",
    "size": 188542,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/engineCircular_003",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "循環エンジン 3",
    "description": "回転式エンジン音",
    "path": "builtin/se/sci-fi-sounds/engineCircular_003.ogg",
    "size": 184193,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/engineCircular_004",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "循環エンジン 4",
    "description": "回転式エンジン音",
    "path": "builtin/se/sci-fi-sounds/engineCircular_004.ogg",
    "size": 180870,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/explosionCrunch_000",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "爆発 (粉砕) 0",
    "description": "粉砕する爆発音",
    "path": "builtin/se/sci-fi-sounds/explosionCrunch_000.ogg",
    "size": 28274,
    "tags": [
      "scifi",
      "explosion"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/explosionCrunch_001",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "爆発 (粉砕) 1",
    "description": "粉砕する爆発音",
    "path": "builtin/se/sci-fi-sounds/explosionCrunch_001.ogg",
    "size": 47916,
    "tags": [
      "scifi",
      "explosion"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/explosionCrunch_002",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "爆発 (粉砕) 2",
    "description": "粉砕する爆発音",
    "path": "builtin/se/sci-fi-sounds/explosionCrunch_002.ogg",
    "size": 47907,
    "tags": [
      "scifi",
      "explosion"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/explosionCrunch_003",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "爆発 (粉砕) 3",
    "description": "粉砕する爆発音",
    "path": "builtin/se/sci-fi-sounds/explosionCrunch_003.ogg",
    "size": 54824,
    "tags": [
      "scifi",
      "explosion"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/explosionCrunch_004",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "爆発 (粉砕) 4",
    "description": "粉砕する爆発音",
    "path": "builtin/se/sci-fi-sounds/explosionCrunch_004.ogg",
    "size": 79250,
    "tags": [
      "scifi",
      "explosion"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/forceField_000",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "フォースフィールド 0",
    "description": "シールド・バリア音",
    "path": "builtin/se/sci-fi-sounds/forceField_000.ogg",
    "size": 25672,
    "tags": [
      "scifi",
      "shield"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/forceField_001",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "フォースフィールド 1",
    "description": "シールド・バリア音",
    "path": "builtin/se/sci-fi-sounds/forceField_001.ogg",
    "size": 28947,
    "tags": [
      "scifi",
      "shield"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/forceField_002",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "フォースフィールド 2",
    "description": "シールド・バリア音",
    "path": "builtin/se/sci-fi-sounds/forceField_002.ogg",
    "size": 27647,
    "tags": [
      "scifi",
      "shield"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/forceField_003",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "フォースフィールド 3",
    "description": "シールド・バリア音",
    "path": "builtin/se/sci-fi-sounds/forceField_003.ogg",
    "size": 23938,
    "tags": [
      "scifi",
      "shield"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/forceField_004",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "フォースフィールド 4",
    "description": "シールド・バリア音",
    "path": "builtin/se/sci-fi-sounds/forceField_004.ogg",
    "size": 26885,
    "tags": [
      "scifi",
      "shield"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/impactMetal_000",
    "pack": "sci-fi-sounds",
    "category": "impact",
    "name": "金属衝撃 (SF) 0",
    "description": "SF 系金属衝撃",
    "path": "builtin/se/sci-fi-sounds/impactMetal_000.ogg",
    "size": 15491,
    "tags": [
      "scifi",
      "metal",
      "impact"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/impactMetal_001",
    "pack": "sci-fi-sounds",
    "category": "impact",
    "name": "金属衝撃 (SF) 1",
    "description": "SF 系金属衝撃",
    "path": "builtin/se/sci-fi-sounds/impactMetal_001.ogg",
    "size": 15305,
    "tags": [
      "scifi",
      "metal",
      "impact"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/impactMetal_002",
    "pack": "sci-fi-sounds",
    "category": "impact",
    "name": "金属衝撃 (SF) 2",
    "description": "SF 系金属衝撃",
    "path": "builtin/se/sci-fi-sounds/impactMetal_002.ogg",
    "size": 12708,
    "tags": [
      "scifi",
      "metal",
      "impact"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/impactMetal_003",
    "pack": "sci-fi-sounds",
    "category": "impact",
    "name": "金属衝撃 (SF) 3",
    "description": "SF 系金属衝撃",
    "path": "builtin/se/sci-fi-sounds/impactMetal_003.ogg",
    "size": 17303,
    "tags": [
      "scifi",
      "metal",
      "impact"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/impactMetal_004",
    "pack": "sci-fi-sounds",
    "category": "impact",
    "name": "金属衝撃 (SF) 4",
    "description": "SF 系金属衝撃",
    "path": "builtin/se/sci-fi-sounds/impactMetal_004.ogg",
    "size": 11290,
    "tags": [
      "scifi",
      "metal",
      "impact"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserLarge_000",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (大) 0",
    "description": "大型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserLarge_000.ogg",
    "size": 25566,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserLarge_001",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (大) 1",
    "description": "大型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserLarge_001.ogg",
    "size": 26220,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserLarge_002",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (大) 2",
    "description": "大型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserLarge_002.ogg",
    "size": 27440,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserLarge_003",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (大) 3",
    "description": "大型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserLarge_003.ogg",
    "size": 26104,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserLarge_004",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (大) 4",
    "description": "大型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserLarge_004.ogg",
    "size": 26283,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserRetro_000",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (レトロ) 0",
    "description": "8bit 風レーザー音",
    "path": "builtin/se/sci-fi-sounds/laserRetro_000.ogg",
    "size": 12588,
    "tags": [
      "scifi",
      "laser",
      "retro"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserRetro_001",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (レトロ) 1",
    "description": "8bit 風レーザー音",
    "path": "builtin/se/sci-fi-sounds/laserRetro_001.ogg",
    "size": 12732,
    "tags": [
      "scifi",
      "laser",
      "retro"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserRetro_002",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (レトロ) 2",
    "description": "8bit 風レーザー音",
    "path": "builtin/se/sci-fi-sounds/laserRetro_002.ogg",
    "size": 13130,
    "tags": [
      "scifi",
      "laser",
      "retro"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserRetro_003",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (レトロ) 3",
    "description": "8bit 風レーザー音",
    "path": "builtin/se/sci-fi-sounds/laserRetro_003.ogg",
    "size": 14271,
    "tags": [
      "scifi",
      "laser",
      "retro"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserRetro_004",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (レトロ) 4",
    "description": "8bit 風レーザー音",
    "path": "builtin/se/sci-fi-sounds/laserRetro_004.ogg",
    "size": 12701,
    "tags": [
      "scifi",
      "laser",
      "retro"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserSmall_000",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (小) 0",
    "description": "小型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserSmall_000.ogg",
    "size": 7286,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserSmall_001",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (小) 1",
    "description": "小型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserSmall_001.ogg",
    "size": 7448,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserSmall_002",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (小) 2",
    "description": "小型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserSmall_002.ogg",
    "size": 8973,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserSmall_003",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (小) 3",
    "description": "小型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserSmall_003.ogg",
    "size": 8179,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/laserSmall_004",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "レーザー (小) 4",
    "description": "小型レーザー射撃音",
    "path": "builtin/se/sci-fi-sounds/laserSmall_004.ogg",
    "size": 8632,
    "tags": [
      "scifi",
      "laser"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/lowFrequency_explosion_000",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "低周波爆発 0",
    "description": "重低音の爆発音",
    "path": "builtin/se/sci-fi-sounds/lowFrequency_explosion_000.ogg",
    "size": 14317,
    "tags": [
      "scifi",
      "explosion"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/lowFrequency_explosion_001",
    "pack": "sci-fi-sounds",
    "category": "weapon",
    "name": "低周波爆発 1",
    "description": "重低音の爆発音",
    "path": "builtin/se/sci-fi-sounds/lowFrequency_explosion_001.ogg",
    "size": 9408,
    "tags": [
      "scifi",
      "explosion"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/slime_000",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "スライム 0",
    "description": "ぬめり・粘液音",
    "path": "builtin/se/sci-fi-sounds/slime_000.ogg",
    "size": 20870,
    "tags": [
      "scifi",
      "slime"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/slime_001",
    "pack": "sci-fi-sounds",
    "category": "sci-fi",
    "name": "スライム 1",
    "description": "ぬめり・粘液音",
    "path": "builtin/se/sci-fi-sounds/slime_001.ogg",
    "size": 159177,
    "tags": [
      "scifi",
      "slime"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngine_000",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン 0",
    "description": "宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngine_000.ogg",
    "size": 109059,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngine_001",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン 1",
    "description": "宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngine_001.ogg",
    "size": 121385,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngine_002",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン 2",
    "description": "宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngine_002.ogg",
    "size": 111072,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngine_003",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン 3",
    "description": "宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngine_003.ogg",
    "size": 67503,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLarge_000",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (大) 0",
    "description": "大型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLarge_000.ogg",
    "size": 189900,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLarge_001",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (大) 1",
    "description": "大型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLarge_001.ogg",
    "size": 212818,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLarge_002",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (大) 2",
    "description": "大型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLarge_002.ogg",
    "size": 214424,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLarge_003",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (大) 3",
    "description": "大型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLarge_003.ogg",
    "size": 214580,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLarge_004",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (大) 4",
    "description": "大型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLarge_004.ogg",
    "size": 210809,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLow_000",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (低) 0",
    "description": "低音域の宇宙船推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLow_000.ogg",
    "size": 99760,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLow_001",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (低) 1",
    "description": "低音域の宇宙船推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLow_001.ogg",
    "size": 99120,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLow_002",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (低) 2",
    "description": "低音域の宇宙船推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLow_002.ogg",
    "size": 72688,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLow_003",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (低) 3",
    "description": "低音域の宇宙船推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLow_003.ogg",
    "size": 85760,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineLow_004",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (低) 4",
    "description": "低音域の宇宙船推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineLow_004.ogg",
    "size": 100444,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineSmall_000",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (小) 0",
    "description": "小型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineSmall_000.ogg",
    "size": 116880,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineSmall_001",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (小) 1",
    "description": "小型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineSmall_001.ogg",
    "size": 133181,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineSmall_002",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (小) 2",
    "description": "小型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineSmall_002.ogg",
    "size": 120467,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineSmall_003",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (小) 3",
    "description": "小型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineSmall_003.ogg",
    "size": 129935,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/spaceEngineSmall_004",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "宇宙船エンジン (小) 4",
    "description": "小型宇宙船の推進音",
    "path": "builtin/se/sci-fi-sounds/spaceEngineSmall_004.ogg",
    "size": 130520,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/thrusterFire_000",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "スラスター 0",
    "description": "推進機の点火音",
    "path": "builtin/se/sci-fi-sounds/thrusterFire_000.ogg",
    "size": 201216,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/thrusterFire_001",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "スラスター 1",
    "description": "推進機の点火音",
    "path": "builtin/se/sci-fi-sounds/thrusterFire_001.ogg",
    "size": 204218,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/thrusterFire_002",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "スラスター 2",
    "description": "推進機の点火音",
    "path": "builtin/se/sci-fi-sounds/thrusterFire_002.ogg",
    "size": 205657,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/thrusterFire_003",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "スラスター 3",
    "description": "推進機の点火音",
    "path": "builtin/se/sci-fi-sounds/thrusterFire_003.ogg",
    "size": 196273,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "sci-fi-sounds/thrusterFire_004",
    "pack": "sci-fi-sounds",
    "category": "engine",
    "name": "スラスター 4",
    "description": "推進機の点火音",
    "path": "builtin/se/sci-fi-sounds/thrusterFire_004.ogg",
    "size": 209339,
    "tags": [
      "scifi",
      "engine"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/CD・DVD/ＣＤケース開ける",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ＣＤケース開ける",
    "description": "CD・DVD",
    "path": "builtin/se/pix-studio/00_小物/CD・DVD/ＣＤケース開ける.ogg",
    "size": 10310,
    "tags": [
      "小物",
      "CD・DVD"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/CD・DVD/ＣＤケース閉める",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ＣＤケース閉める",
    "description": "CD・DVD",
    "path": "builtin/se/pix-studio/00_小物/CD・DVD/ＣＤケース閉める.ogg",
    "size": 14021,
    "tags": [
      "小物",
      "CD・DVD"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/CD・DVD/ＤＶＤトールケース開ける",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ＤＶＤトールケース開ける",
    "description": "CD・DVD",
    "path": "builtin/se/pix-studio/00_小物/CD・DVD/ＤＶＤトールケース開ける.ogg",
    "size": 11939,
    "tags": [
      "小物",
      "CD・DVD"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/CD・DVD/ＤＶＤトールケース閉める",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ＤＶＤトールケース閉める",
    "description": "CD・DVD",
    "path": "builtin/se/pix-studio/00_小物/CD・DVD/ＤＶＤトールケース閉める.ogg",
    "size": 7949,
    "tags": [
      "小物",
      "CD・DVD"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/お菓子の箱を振る",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "お菓子の箱を振る",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/お菓子の箱を振る.ogg",
    "size": 20863,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/お金/硬貨コロコロ",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "硬貨コロコロ",
    "description": "お金",
    "path": "builtin/se/pix-studio/00_小物/お金/硬貨コロコロ.ogg",
    "size": 29468,
    "tags": [
      "小物",
      "お金"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/お金/小銭(ﾁｬﾗﾁｬﾗ)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "小銭(ﾁｬﾗﾁｬﾗ)",
    "description": "お金",
    "path": "builtin/se/pix-studio/00_小物/お金/小銭(ﾁｬﾗﾁｬﾗ).ogg",
    "size": 33123,
    "tags": [
      "小物",
      "お金"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/お金/貯金箱に小銭",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "貯金箱に小銭",
    "description": "お金",
    "path": "builtin/se/pix-studio/00_小物/お金/貯金箱に小銭.ogg",
    "size": 13658,
    "tags": [
      "小物",
      "お金"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/お金/貯金箱を振る",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "貯金箱を振る",
    "description": "お金",
    "path": "builtin/se/pix-studio/00_小物/お金/貯金箱を振る.ogg",
    "size": 30273,
    "tags": [
      "小物",
      "お金"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/カレンダーを捲る",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "カレンダーを捲る",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/カレンダーを捲る.ogg",
    "size": 26847,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/スプレー/スプレー",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "スプレー",
    "description": "スプレー",
    "path": "builtin/se/pix-studio/00_小物/スプレー/スプレー.ogg",
    "size": 90120,
    "tags": [
      "小物",
      "スプレー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/スプレー/スプレー缶にキャップ",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "スプレー缶にキャップ",
    "description": "スプレー",
    "path": "builtin/se/pix-studio/00_小物/スプレー/スプレー缶にキャップ.ogg",
    "size": 22216,
    "tags": [
      "小物",
      "スプレー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/スプレー/スプレー缶のキャップを外す",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "スプレー缶のキャップを外す",
    "description": "スプレー",
    "path": "builtin/se/pix-studio/00_小物/スプレー/スプレー缶のキャップを外す.ogg",
    "size": 10113,
    "tags": [
      "小物",
      "スプレー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/スプレー/霧吹き1回",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "霧吹き1回",
    "description": "スプレー",
    "path": "builtin/se/pix-studio/00_小物/スプレー/霧吹き1回.ogg",
    "size": 11333,
    "tags": [
      "小物",
      "スプレー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/スプレー/霧吹き2回",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "霧吹き2回",
    "description": "スプレー",
    "path": "builtin/se/pix-studio/00_小物/スプレー/霧吹き2回.ogg",
    "size": 17376,
    "tags": [
      "小物",
      "スプレー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/ティッシュ",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ティッシュ",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/ティッシュ.ogg",
    "size": 11504,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/ビニール(ｶﾞｻｶﾞｻ)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ビニール(ｶﾞｻｶﾞｻ)",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/ビニール(ｶﾞｻｶﾞｻ).ogg",
    "size": 203831,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/ビニル袋に物を入れる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ビニル袋に物を入れる",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/ビニル袋に物を入れる.ogg",
    "size": 269783,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/ビニール傘で雨を受けている",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ビニール傘で雨を受けている",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/ビニール傘で雨を受けている.ogg",
    "size": 327897,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/ビニール傘開く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ビニール傘開く",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/ビニール傘開く.ogg",
    "size": 21156,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/ビニール傘閉じる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ビニール傘閉じる",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/ビニール傘閉じる.ogg",
    "size": 31563,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/雨の中で傘を差す01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "雨の中で傘を差す01",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/雨の中で傘を差す01.ogg",
    "size": 554242,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/雨の中で傘を差す02(ビニール)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "雨の中で傘を差す02(ビニール)",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/雨の中で傘を差す02(ビニール).ogg",
    "size": 451378,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/屋根に入って傘を閉じる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "屋根に入って傘を閉じる",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/屋根に入って傘を閉じる.ogg",
    "size": 141309,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/傘の水滴を切る",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "傘の水滴を切る",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/傘の水滴を切る.ogg",
    "size": 54811,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/傘を開く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "傘を開く",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/傘を開く.ogg",
    "size": 23233,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/雨具/傘を閉じる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "傘を閉じる",
    "description": "雨具",
    "path": "builtin/se/pix-studio/00_小物/雨具/傘を閉じる.ogg",
    "size": 27143,
    "tags": [
      "小物",
      "雨具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/空き缶が転がる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "空き缶が転がる",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/空き缶が転がる.ogg",
    "size": 32757,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/空のグラスが転がる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "空のグラスが転がる",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/空のグラスが転がる.ogg",
    "size": 44185,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/鍵/スイッチ・鍵(ｶﾁｯ)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "スイッチ・鍵(ｶﾁｯ)",
    "description": "鍵",
    "path": "builtin/se/pix-studio/00_小物/鍵/スイッチ・鍵(ｶﾁｯ).ogg",
    "size": 7024,
    "tags": [
      "小物",
      "鍵"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/鍵/鍵をチャラチャラ",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鍵をチャラチャラ",
    "description": "鍵",
    "path": "builtin/se/pix-studio/00_小物/鍵/鍵をチャラチャラ.ogg",
    "size": 32268,
    "tags": [
      "小物",
      "鍵"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/鍵/鍵を回す",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鍵を回す",
    "description": "鍵",
    "path": "builtin/se/pix-studio/00_小物/鍵/鍵を回す.ogg",
    "size": 9961,
    "tags": [
      "小物",
      "鍵"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/鍵/鍵を差して回す",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鍵を差して回す",
    "description": "鍵",
    "path": "builtin/se/pix-studio/00_小物/鍵/鍵を差して回す.ogg",
    "size": 34176,
    "tags": [
      "小物",
      "鍵"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/鍵/鍵を抜く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鍵を抜く",
    "description": "鍵",
    "path": "builtin/se/pix-studio/00_小物/鍵/鍵を抜く.ogg",
    "size": 14983,
    "tags": [
      "小物",
      "鍵"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/鍵/鍵束を持ち上げる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鍵束を持ち上げる",
    "description": "鍵",
    "path": "builtin/se/pix-studio/00_小物/鍵/鍵束を持ち上げる.ogg",
    "size": 31288,
    "tags": [
      "小物",
      "鍵"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/鍵/鍵束を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鍵束を置く",
    "description": "鍵",
    "path": "builtin/se/pix-studio/00_小物/鍵/鍵束を置く.ogg",
    "size": 21422,
    "tags": [
      "小物",
      "鍵"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/錠剤を振る01(ケース)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "錠剤を振る01(ケース)",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/錠剤を振る01(ケース).ogg",
    "size": 23103,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/錠剤を振る02(瓶)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "錠剤を振る02(瓶)",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/錠剤を振る02(瓶).ogg",
    "size": 23685,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/お盆を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "お盆を置く",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/お盆を置く.ogg",
    "size": 27185,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/グラスが砕ける",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "グラスが砕ける",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/グラスが砕ける.ogg",
    "size": 38540,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/グラスを置く(空)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "グラスを置く(空)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/グラスを置く(空).ogg",
    "size": 10045,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/グラスを置く(水入り)01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "グラスを置く(水入り)01",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/グラスを置く(水入り)01.ogg",
    "size": 15129,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/グラスを置く(水入り)02",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "グラスを置く(水入り)02",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/グラスを置く(水入り)02.ogg",
    "size": 11763,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/コップが割れる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "コップが割れる",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/コップが割れる.ogg",
    "size": 32688,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/コップを置く(プラスチック)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "コップを置く(プラスチック)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/コップを置く(プラスチック).ogg",
    "size": 9494,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/コップを置く(空)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "コップを置く(空)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/コップを置く(空).ogg",
    "size": 14541,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/フライパンを置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "フライパンを置く",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/フライパンを置く.ogg",
    "size": 12367,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/やかんを置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "やかんを置く",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/やかんを置く.ogg",
    "size": 39126,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/小皿を置く(空)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "小皿を置く(空)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/小皿を置く(空).ogg",
    "size": 15901,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/小瓶を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "小瓶を置く",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/小瓶を置く.ogg",
    "size": 8502,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/食器が割れる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "食器が割れる",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/食器が割れる.ogg",
    "size": 17832,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/食器を洗う",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "食器を洗う",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/食器を洗う.ogg",
    "size": 1082568,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/湯飲みを置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "湯飲みを置く",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/湯飲みを置く.ogg",
    "size": 8150,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/瓶を置く01(空瓶)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "瓶を置く01(空瓶)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/瓶を置く01(空瓶).ogg",
    "size": 14686,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/瓶を置く02(満タン)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "瓶を置く02(満タン)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/瓶を置く02(満タン).ogg",
    "size": 17802,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/片付け01(瓶)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "片付け01(瓶)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/片付け01(瓶).ogg",
    "size": 296148,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/片付け02(茶碗)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "片付け02(茶碗)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/片付け02(茶碗).ogg",
    "size": 255740,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/片付け03(食器)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "片付け03(食器)",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/片付け03(食器).ogg",
    "size": 108052,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/食器/壺を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "壺を置く",
    "description": "食器",
    "path": "builtin/se/pix-studio/00_小物/食器/壺を置く.ogg",
    "size": 20947,
    "tags": [
      "小物",
      "食器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/石を打つ",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "石を打つ",
    "description": "",
    "path": "builtin/se/pix-studio/00_小物/石を打つ.ogg",
    "size": 8898,
    "tags": [
      "小物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/CDケースを置く01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "CDケースを置く01",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/CDケースを置く01.ogg",
    "size": 15004,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/CDケースを置く02",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "CDケースを置く02",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/CDケースを置く02.ogg",
    "size": 9417,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/DVDケースを置く01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "DVDケースを置く01",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/DVDケースを置く01.ogg",
    "size": 9628,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/DVDケースを置く02",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "DVDケースを置く02",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/DVDケースを置く02.ogg",
    "size": 11064,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/カッターナイフを置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "カッターナイフを置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/カッターナイフを置く.ogg",
    "size": 12358,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/カバンを持ち上げる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "カバンを持ち上げる",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/カバンを持ち上げる.ogg",
    "size": 11793,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/カバンを置く01(大きいサイズ)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "カバンを置く01(大きいサイズ)",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/カバンを置く01(大きいサイズ).ogg",
    "size": 14655,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/カバンを置く02(乱暴に)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "カバンを置く02(乱暴に)",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/カバンを置く02(乱暴に).ogg",
    "size": 10293,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/ビニル袋を持ち上げる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ビニル袋を持ち上げる",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/ビニル袋を持ち上げる.ogg",
    "size": 36001,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/ビニル袋を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ビニル袋を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/ビニル袋を置く.ogg",
    "size": 23373,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/ボールペンを置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ボールペンを置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/ボールペンを置く.ogg",
    "size": 9469,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/鉛筆を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鉛筆を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/鉛筆を置く.ogg",
    "size": 11461,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/靴を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "靴を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/靴を置く.ogg",
    "size": 17653,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/携帯電話を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "携帯電話を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/携帯電話を置く.ogg",
    "size": 12665,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/軽い物を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "軽い物を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/軽い物を置く.ogg",
    "size": 9944,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/車の座席に荷物を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "車の座席に荷物を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/車の座席に荷物を置く.ogg",
    "size": 17324,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/段ボール(重)を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "段ボール(重)を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/段ボール(重)を置く.ogg",
    "size": 15945,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/段ボール箱を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "段ボール箱を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/段ボール箱を置く.ogg",
    "size": 14785,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/鉄製品(ハサミ等)を置く",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鉄製品(ハサミ等)を置く",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/鉄製品(ハサミ等)を置く.ogg",
    "size": 10393,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/本を置く01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "本を置く01",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/本を置く01.ogg",
    "size": 19421,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/置く・持ち上げる/本を置く02",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "本を置く02",
    "description": "置く・持ち上げる",
    "path": "builtin/se/pix-studio/00_小物/置く・持ち上げる/本を置く02.ogg",
    "size": 14022,
    "tags": [
      "小物",
      "置く・持ち上げる"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/着火/100円ライター",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "100円ライター",
    "description": "着火",
    "path": "builtin/se/pix-studio/00_小物/着火/100円ライター.ogg",
    "size": 13772,
    "tags": [
      "小物",
      "着火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/着火/マッチを擦る",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "マッチを擦る",
    "description": "着火",
    "path": "builtin/se/pix-studio/00_小物/着火/マッチを擦る.ogg",
    "size": 54274,
    "tags": [
      "小物",
      "着火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/着火/マッチを箱から取り出す",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "マッチを箱から取り出す",
    "description": "着火",
    "path": "builtin/se/pix-studio/00_小物/着火/マッチを箱から取り出す.ogg",
    "size": 79671,
    "tags": [
      "小物",
      "着火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/着火/マッチ箱から取り出し火をつける",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "マッチ箱から取り出し火をつける",
    "description": "着火",
    "path": "builtin/se/pix-studio/00_小物/着火/マッチ箱から取り出し火をつける.ogg",
    "size": 101606,
    "tags": [
      "小物",
      "着火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/カッター01(刃を出す)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "カッター01(刃を出す)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/カッター01(刃を出す).ogg",
    "size": 18132,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/カッター02(紙を切る)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "カッター02(紙を切る)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/カッター02(紙を切る).ogg",
    "size": 21336,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/シャープペン01(1回)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "シャープペン01(1回)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/シャープペン01(1回).ogg",
    "size": 8319,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/シャープペン02(2回)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "シャープペン02(2回)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/シャープペン02(2回).ogg",
    "size": 17175,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/シャープペン03(連続)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "シャープペン03(連続)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/シャープペン03(連続).ogg",
    "size": 72313,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/セロハンテープ01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "セロハンテープ01",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/セロハンテープ01.ogg",
    "size": 32132,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/セロハンテープ02(剥がす)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "セロハンテープ02(剥がす)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/セロハンテープ02(剥がす).ogg",
    "size": 9402,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/はさみ01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "はさみ01",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/はさみ01.ogg",
    "size": 13050,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/はさみ02",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "はさみ02",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/はさみ02.ogg",
    "size": 28958,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/はさみ03",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "はさみ03",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/はさみ03.ogg",
    "size": 9028,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/はさみ04(早く連続)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "はさみ04(早く連続)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/はさみ04(早く連続).ogg",
    "size": 52283,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/はさみ05(紙を切る)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "はさみ05(紙を切る)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/はさみ05(紙を切る).ogg",
    "size": 77001,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/ページをめくる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ページをめくる",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/ページをめくる.ogg",
    "size": 5745,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/ペンキャップ01(はめる)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ペンキャップ01(はめる)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/ペンキャップ01(はめる).ogg",
    "size": 15291,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/ペンキャップ02(外す)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ペンキャップ02(外す)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/ペンキャップ02(外す).ogg",
    "size": 10129,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/ペンを取り出す(ケース)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ペンを取り出す(ケース)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/ペンを取り出す(ケース).ogg",
    "size": 50497,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/ホッチキス",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "ホッチキス",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/ホッチキス.ogg",
    "size": 12806,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/鉛筆が転がる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "鉛筆が転がる",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/鉛筆が転がる.ogg",
    "size": 38408,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/絵を描く(マジック)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "絵を描く(マジック)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/絵を描く(マジック).ogg",
    "size": 488278,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/雑誌をめくる01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "雑誌をめくる01",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/雑誌をめくる01.ogg",
    "size": 19943,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/雑誌をめくる02",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "雑誌をめくる02",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/雑誌をめくる02.ogg",
    "size": 75596,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/紙をあさる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "紙をあさる",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/紙をあさる.ogg",
    "size": 104643,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/紙を丸める01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "紙を丸める01",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/紙を丸める01.ogg",
    "size": 90943,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/紙を丸める02(捨てる)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "紙を丸める02(捨てる)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/紙を丸める02(捨てる).ogg",
    "size": 86016,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/紙を丸める03(ゆっくり)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "紙を丸める03(ゆっくり)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/紙を丸める03(ゆっくり).ogg",
    "size": 174315,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/紙を破く01",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "紙を破く01",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/紙を破く01.ogg",
    "size": 13172,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/紙を破く02",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "紙を破く02",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/紙を破く02.ogg",
    "size": 57221,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/辞書を閉じる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "辞書を閉じる",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/辞書を閉じる.ogg",
    "size": 11083,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/書く01(鉛筆)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "書く01(鉛筆)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/書く01(鉛筆).ogg",
    "size": 356966,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/書く02(ペン)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "書く02(ペン)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/書く02(ペン).ogg",
    "size": 571580,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/書く03(マジック)",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "書く03(マジック)",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/書く03(マジック).ogg",
    "size": 296382,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/新聞をめくる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "新聞をめくる",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/新聞をめくる.ogg",
    "size": 44280,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/本がバサバサ",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "本がバサバサ",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/本がバサバサ.ogg",
    "size": 72907,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_小物/本・文房具/本を閉じる",
    "pack": "pix-studio",
    "category": "pix-studio/小物",
    "categoryLabel": "小物",
    "name": "本を閉じる",
    "description": "本・文房具",
    "path": "builtin/se/pix-studio/00_小物/本・文房具/本を閉じる.ogg",
    "size": 5880,
    "tags": [
      "小物",
      "本・文房具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/バイブレーション01",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "バイブレーション01",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/バイブレーション01.ogg",
    "size": 91723,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/バイブレーション02",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "バイブレーション02",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/バイブレーション02.ogg",
    "size": 76987,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/ポケベル",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "ポケベル",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/ポケベル.ogg",
    "size": 14577,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/携帯を落とす（＋響）",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "携帯を落とす（＋響）",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/携帯を落とす（＋響）.ogg",
    "size": 31179,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/携帯開ける",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "携帯開ける",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/携帯開ける.ogg",
    "size": 9525,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/携帯閉じる",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "携帯閉じる",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/携帯閉じる.ogg",
    "size": 10458,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/受話器を下ろす",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "受話器を下ろす",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/受話器を下ろす.ogg",
    "size": 15084,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/受話器を上げる",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "受話器を上げる",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/受話器を上げる.ogg",
    "size": 14245,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/通話前音",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "通話前音",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/通話前音.ogg",
    "size": 92042,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/電話の呼び出し音",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "電話の呼び出し音",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/電話の呼び出し音.ogg",
    "size": 149319,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/電話を掛ける01",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "電話を掛ける01",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/電話を掛ける01.ogg",
    "size": 17632,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/電話を掛ける02(高速)",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "電話を掛ける02(高速)",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/電話を掛ける02(高速).ogg",
    "size": 13422,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/電話を掛ける03(＋呼出音)",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "電話を掛ける03(＋呼出音)",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/電話を掛ける03(＋呼出音).ogg",
    "size": 192580,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/電話不通",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "電話不通",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/電話不通.ogg",
    "size": 93984,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_電話・携帯/落ちた携帯蹴る",
    "pack": "pix-studio",
    "category": "pix-studio/電話・携帯",
    "categoryLabel": "電話・携帯",
    "name": "落ちた携帯蹴る",
    "description": "",
    "path": "builtin/se/pix-studio/00_電話・携帯/落ちた携帯蹴る.ogg",
    "size": 37761,
    "tags": [
      "電話・携帯"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ジッパー/ジッパー01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ジッパー01",
    "description": "ジッパー",
    "path": "builtin/se/pix-studio/00_日常生活音/ジッパー/ジッパー01.ogg",
    "size": 27188,
    "tags": [
      "日常生活音",
      "ジッパー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ジッパー/ジッパー02",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ジッパー02",
    "description": "ジッパー",
    "path": "builtin/se/pix-studio/00_日常生活音/ジッパー/ジッパー02.ogg",
    "size": 21680,
    "tags": [
      "日常生活音",
      "ジッパー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ジッパー/ジッパー03(小物)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ジッパー03(小物)",
    "description": "ジッパー",
    "path": "builtin/se/pix-studio/00_日常生活音/ジッパー/ジッパー03(小物).ogg",
    "size": 18592,
    "tags": [
      "日常生活音",
      "ジッパー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ジッパー/ジッパー下げる１",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ジッパー下げる１",
    "description": "ジッパー",
    "path": "builtin/se/pix-studio/00_日常生活音/ジッパー/ジッパー下げる１.ogg",
    "size": 5713,
    "tags": [
      "日常生活音",
      "ジッパー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ジッパー/ジッパー下げる２",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ジッパー下げる２",
    "description": "ジッパー",
    "path": "builtin/se/pix-studio/00_日常生活音/ジッパー/ジッパー下げる２.ogg",
    "size": 8787,
    "tags": [
      "日常生活音",
      "ジッパー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ジッパー/ジッパー上げる１",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ジッパー上げる１",
    "description": "ジッパー",
    "path": "builtin/se/pix-studio/00_日常生活音/ジッパー/ジッパー上げる１.ogg",
    "size": 5008,
    "tags": [
      "日常生活音",
      "ジッパー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ジッパー/ジッパー上げる２",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ジッパー上げる２",
    "description": "ジッパー",
    "path": "builtin/se/pix-studio/00_日常生活音/ジッパー/ジッパー上げる２.ogg",
    "size": 8562,
    "tags": [
      "日常生活音",
      "ジッパー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ジッパー/マジックテープ",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "マジックテープ",
    "description": "ジッパー",
    "path": "builtin/se/pix-studio/00_日常生活音/ジッパー/マジックテープ.ogg",
    "size": 12302,
    "tags": [
      "日常生活音",
      "ジッパー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/アルミドア（風呂）開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "アルミドア（風呂）開く",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/アルミドア（風呂）開く.ogg",
    "size": 31712,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/アルミドア（風呂）閉め",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "アルミドア（風呂）閉め",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/アルミドア（風呂）閉め.ogg",
    "size": 20702,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/スライド式ドア開（トイレ）",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "スライド式ドア開（トイレ）",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/スライド式ドア開（トイレ）.ogg",
    "size": 51983,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/スライド式ドア閉（トイレ）",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "スライド式ドア閉（トイレ）",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/スライド式ドア閉（トイレ）.ogg",
    "size": 51329,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/ただのドア閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ただのドア閉める",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/ただのドア閉める.ogg",
    "size": 24220,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/ドアノック鉄製01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ドアノック鉄製01",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/ドアノック鉄製01.ogg",
    "size": 54437,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/ドアノック鉄製02",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ドアノック鉄製02",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/ドアノック鉄製02.ogg",
    "size": 38493,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/ドアノック鉄製03",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ドアノック鉄製03",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/ドアノック鉄製03.ogg",
    "size": 28299,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/ドアノック鉄製04",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ドアノック鉄製04",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/ドアノック鉄製04.ogg",
    "size": 33171,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/ドアノック木製01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ドアノック木製01",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/ドアノック木製01.ogg",
    "size": 19710,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/ドアノック木製02",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ドアノック木製02",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/ドアノック木製02.ogg",
    "size": 15433,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/ゆっくりドア閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ゆっくりドア閉める",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/ゆっくりドア閉める.ogg",
    "size": 32615,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/鍵を差しドア開01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "鍵を差しドア開01",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/鍵を差しドア開01.ogg",
    "size": 51428,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/鍵を差しドア開02",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "鍵を差しドア開02",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/鍵を差しドア開02.ogg",
    "size": 76007,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/室内ドア開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "室内ドア開く",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/室内ドア開く.ogg",
    "size": 20988,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/室内ドア閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "室内ドア閉める",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/室内ドア閉める.ogg",
    "size": 24447,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/大きなドアが閉まる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "大きなドアが閉まる",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/大きなドアが閉まる.ogg",
    "size": 23032,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/木製ドアに鍵01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "木製ドアに鍵01",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/木製ドアに鍵01.ogg",
    "size": 14962,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/木製ドアに鍵02",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "木製ドアに鍵02",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/木製ドアに鍵02.ogg",
    "size": 12574,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/ドア/郵便受け",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "郵便受け",
    "description": "ドア",
    "path": "builtin/se/pix-studio/00_日常生活音/ドア/郵便受け.ogg",
    "size": 78513,
    "tags": [
      "日常生活音",
      "ドア"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/襖（ふすま）",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "襖（ふすま）",
    "description": "",
    "path": "builtin/se/pix-studio/00_日常生活音/襖（ふすま）.ogg",
    "size": 34763,
    "tags": [
      "日常生活音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/キャスターチェアを移動",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "キャスターチェアを移動",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/キャスターチェアを移動.ogg",
    "size": 30212,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/パイプ椅子に座る",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "パイプ椅子に座る",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/パイプ椅子に座る.ogg",
    "size": 34433,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/椅子を引く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "椅子を引く",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/椅子を引く.ogg",
    "size": 20138,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/押入れ",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "押入れ",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/押入れ.ogg",
    "size": 42965,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/戸棚を開ける",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "戸棚を開ける",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/戸棚を開ける.ogg",
    "size": 14953,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/戸棚を閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "戸棚を閉める",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/戸棚を閉める.ogg",
    "size": 11205,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/食器棚閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "食器棚閉める",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/食器棚閉める.ogg",
    "size": 17675,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/棚をずらす",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "棚をずらす",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/棚をずらす.ogg",
    "size": 27836,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/本棚倒れる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "本棚倒れる",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/本棚倒れる.ogg",
    "size": 87207,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/木製引き出し開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "木製引き出し開く",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/木製引き出し開く.ogg",
    "size": 20556,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家具/木製引き出し閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "木製引き出し閉める",
    "description": "家具",
    "path": "builtin/se/pix-studio/00_日常生活音/家具/木製引き出し閉める.ogg",
    "size": 23027,
    "tags": [
      "日常生活音",
      "家具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/オーブン",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "オーブン",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/オーブン.ogg",
    "size": 429916,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/キン！（小さい）",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "キン！（小さい）",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/キン！（小さい）.ogg",
    "size": 30661,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/コンセント01(差す)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "コンセント01(差す)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/コンセント01(差す).ogg",
    "size": 23638,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/コンセント02(抜く)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "コンセント02(抜く)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/コンセント02(抜く).ogg",
    "size": 14294,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/テレビ(放送停止音)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "テレビ(放送停止音)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/テレビ(放送停止音).ogg",
    "size": 30270,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/トースター(焼き上がり)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "トースター(焼き上がり)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/トースター(焼き上がり).ogg",
    "size": 24130,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/ブレーカーが落ちる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ブレーカーが落ちる",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/ブレーカーが落ちる.ogg",
    "size": 13472,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/ミシン01(短)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ミシン01(短)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/ミシン01(短).ogg",
    "size": 210976,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/ミシン02(長)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ミシン02(長)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/ミシン02(長).ogg",
    "size": 332494,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/ラジオ(チューニング)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ラジオ(チューニング)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/ラジオ(チューニング).ogg",
    "size": 135857,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/換気扇",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "換気扇",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/換気扇.ogg",
    "size": 433066,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/蛍光灯をつける01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "蛍光灯をつける01",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/蛍光灯をつける01.ogg",
    "size": 15935,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/蛍光灯をつける02",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "蛍光灯をつける02",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/蛍光灯をつける02.ogg",
    "size": 47759,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/蛍光灯を消す",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "蛍光灯を消す",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/蛍光灯を消す.ogg",
    "size": 36421,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/時計",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "時計",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/時計.ogg",
    "size": 69516,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/時計01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "時計01",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/時計01.ogg",
    "size": 162098,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/芝刈り機",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "芝刈り機",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/芝刈り機.ogg",
    "size": 300531,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/炊飯ジャー開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "炊飯ジャー開く",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/炊飯ジャー開く.ogg",
    "size": 21653,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/炊飯ジャー閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "炊飯ジャー閉める",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/炊飯ジャー閉める.ogg",
    "size": 16545,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/扇風機01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "扇風機01",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/扇風機01.ogg",
    "size": 295994,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/扇風機02(回転のみ)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "扇風機02(回転のみ)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/扇風機02(回転のみ).ogg",
    "size": 448279,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/洗濯機",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "洗濯機",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/洗濯機.ogg",
    "size": 299068,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/洗濯機脱水(コインランドリー)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "洗濯機脱水(コインランドリー)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/洗濯機脱水(コインランドリー).ogg",
    "size": 1902105,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/掃除機01(近)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "掃除機01(近)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/掃除機01(近).ogg",
    "size": 213463,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/掃除機02(遠)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "掃除機02(遠)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/掃除機02(遠).ogg",
    "size": 203153,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/電気オーブン開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "電気オーブン開く",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/電気オーブン開く.ogg",
    "size": 30334,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/電気シェーバーで髭剃り",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "電気シェーバーで髭剃り",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/電気シェーバーで髭剃り.ogg",
    "size": 201267,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/電球01(取付)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "電球01(取付)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/電球01(取付).ogg",
    "size": 81824,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/電球02(取外し)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "電球02(取外し)",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/電球02(取外し).ogg",
    "size": 76710,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/電子レンジ",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "電子レンジ",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/電子レンジ.ogg",
    "size": 277896,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/電子レンジ開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "電子レンジ開く",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/電子レンジ開く.ogg",
    "size": 18768,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/電子レンジ閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "電子レンジ閉める",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/電子レンジ閉める.ogg",
    "size": 14992,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/壁スイッチ",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "壁スイッチ",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/壁スイッチ.ogg",
    "size": 9219,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/目覚まし時計",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "目覚まし時計",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/目覚まし時計.ogg",
    "size": 292654,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/冷蔵庫（引き出し式）開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "冷蔵庫（引き出し式）開く",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/冷蔵庫（引き出し式）開く.ogg",
    "size": 25077,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/冷蔵庫（引き出し式）閉",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "冷蔵庫（引き出し式）閉",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/冷蔵庫（引き出し式）閉.ogg",
    "size": 24537,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/冷蔵庫01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "冷蔵庫01",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/冷蔵庫01.ogg",
    "size": 70597,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/冷蔵庫02",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "冷蔵庫02",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/冷蔵庫02.ogg",
    "size": 66973,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/冷蔵庫開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "冷蔵庫開く",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/冷蔵庫開く.ogg",
    "size": 38360,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/家電/冷蔵庫閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "冷蔵庫閉める",
    "description": "家電",
    "path": "builtin/se/pix-studio/00_日常生活音/家電/冷蔵庫閉める.ogg",
    "size": 23845,
    "tags": [
      "日常生活音",
      "家電"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/呼び鈴/ピンポン(アパート)1回",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ピンポン(アパート)1回",
    "description": "呼び鈴",
    "path": "builtin/se/pix-studio/00_日常生活音/呼び鈴/ピンポン(アパート)1回.ogg",
    "size": 19798,
    "tags": [
      "日常生活音",
      "呼び鈴"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/呼び鈴/ピンポン(アパート)2回",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ピンポン(アパート)2回",
    "description": "呼び鈴",
    "path": "builtin/se/pix-studio/00_日常生活音/呼び鈴/ピンポン(アパート)2回.ogg",
    "size": 25924,
    "tags": [
      "日常生活音",
      "呼び鈴"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/呼び鈴/ピンポン(チャイム)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ピンポン(チャイム)",
    "description": "呼び鈴",
    "path": "builtin/se/pix-studio/00_日常生活音/呼び鈴/ピンポン(チャイム).ogg",
    "size": 56822,
    "tags": [
      "日常生活音",
      "呼び鈴"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/呼び鈴/ピンポン(マンション)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ピンポン(マンション)",
    "description": "呼び鈴",
    "path": "builtin/se/pix-studio/00_日常生活音/呼び鈴/ピンポン(マンション).ogg",
    "size": 65599,
    "tags": [
      "日常生活音",
      "呼び鈴"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/呼び鈴/ピンポン連打",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ピンポン連打",
    "description": "呼び鈴",
    "path": "builtin/se/pix-studio/00_日常生活音/呼び鈴/ピンポン連打.ogg",
    "size": 58808,
    "tags": [
      "日常生活音",
      "呼び鈴"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/呼び鈴/鈴１",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "鈴１",
    "description": "呼び鈴",
    "path": "builtin/se/pix-studio/00_日常生活音/呼び鈴/鈴１.ogg",
    "size": 75402,
    "tags": [
      "日常生活音",
      "呼び鈴"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/呼び鈴/鈴２",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "鈴２",
    "description": "呼び鈴",
    "path": "builtin/se/pix-studio/00_日常生活音/呼び鈴/鈴２.ogg",
    "size": 51563,
    "tags": [
      "日常生活音",
      "呼び鈴"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/床ドン１",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "床ドン１",
    "description": "",
    "path": "builtin/se/pix-studio/00_日常生活音/床ドン１.ogg",
    "size": 21977,
    "tags": [
      "日常生活音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/床ドン２",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "床ドン２",
    "description": "",
    "path": "builtin/se/pix-studio/00_日常生活音/床ドン２.ogg",
    "size": 14980,
    "tags": [
      "日常生活音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/ガラス片を袋に入れる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ガラス片を袋に入れる",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/ガラス片を袋に入れる.ogg",
    "size": 47792,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/ゴミ箱に捨てる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ゴミ箱に捨てる",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/ゴミ箱に捨てる.ogg",
    "size": 12047,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/ゴミ箱をあさる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ゴミ箱をあさる",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/ゴミ箱をあさる.ogg",
    "size": 144168,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/ビン・缶ゴミ",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ビン・缶ゴミ",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/ビン・缶ゴミ.ogg",
    "size": 79934,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/雑巾を絞る",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "雑巾を絞る",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/雑巾を絞る.ogg",
    "size": 159663,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/磨く(ｷｭｯｷｭ)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "磨く(ｷｭｯｷｭ)",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/磨く(ｷｭｯｷｭ).ogg",
    "size": 30939,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/箒で掃く01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "箒で掃く01",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/箒で掃く01.ogg",
    "size": 104044,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/箒で掃く02(玄関)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "箒で掃く02(玄関)",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/箒で掃く02(玄関).ogg",
    "size": 198744,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/掃除片付け/掃除/箒で掃く03(ガラス片)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "箒で掃く03(ガラス片)",
    "description": "掃除片付け › 掃除",
    "path": "builtin/se/pix-studio/00_日常生活音/掃除片付け/掃除/箒で掃く03(ガラス片).ogg",
    "size": 229212,
    "tags": [
      "日常生活音",
      "掃除片付け",
      "掃除"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/カーテン・窓開（朝）",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "カーテン・窓開（朝）",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/カーテン・窓開（朝）.ogg",
    "size": 198857,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/カーテン・窓開（夜）",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "カーテン・窓開（夜）",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/カーテン・窓開（夜）.ogg",
    "size": 659937,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/カーテンを引く１",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "カーテンを引く１",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/カーテンを引く１.ogg",
    "size": 19741,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/カーテンを引く２",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "カーテンを引く２",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/カーテンを引く２.ogg",
    "size": 18225,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/ブラインドから覗く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ブラインドから覗く",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/ブラインドから覗く.ogg",
    "size": 13320,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/ブラインド下げる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ブラインド下げる",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/ブラインド下げる.ogg",
    "size": 24008,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/ブラインド上げる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "ブラインド上げる",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/ブラインド上げる.ogg",
    "size": 28932,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/強風時・窓開ける",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "強風時・窓開ける",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/強風時・窓開ける.ogg",
    "size": 101162,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/固い窓開ける",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "固い窓開ける",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/固い窓開ける.ogg",
    "size": 54372,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/固い窓閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "固い窓閉める",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/固い窓閉める.ogg",
    "size": 66263,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/小窓開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "小窓開く",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/小窓開く.ogg",
    "size": 60360,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/小窓閉じる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "小窓閉じる",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/小窓閉じる.ogg",
    "size": 38995,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/大きなブラインド",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "大きなブラインド",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/大きなブラインド.ogg",
    "size": 29452,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/大型ガラス窓開く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "大型ガラス窓開く",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/大型ガラス窓開く.ogg",
    "size": 80761,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/窓/大型ガラス窓閉+鍵",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "大型ガラス窓閉+鍵",
    "description": "窓",
    "path": "builtin/se/pix-studio/00_日常生活音/窓/大型ガラス窓閉+鍵.ogg",
    "size": 92058,
    "tags": [
      "日常生活音",
      "窓"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風鈴",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "風鈴",
    "description": "",
    "path": "builtin/se/pix-studio/00_日常生活音/風鈴.ogg",
    "size": 61956,
    "tags": [
      "日常生活音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/お湯に浸かる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "お湯に浸かる",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/お湯に浸かる.ogg",
    "size": 84288,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/シャワー",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "シャワー",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/シャワー.ogg",
    "size": 235645,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/タオルで手を拭く",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "タオルで手を拭く",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/タオルで手を拭く.ogg",
    "size": 61058,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/トイレットペーパー",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "トイレットペーパー",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/トイレットペーパー.ogg",
    "size": 59325,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/トイレで流す01(内側)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "トイレで流す01(内側)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/トイレで流す01(内側).ogg",
    "size": 240502,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/トイレで流す02(外側)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "トイレで流す02(外側)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/トイレで流す02(外側).ogg",
    "size": 110724,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/トイレの蓋・便座01(上げる)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "トイレの蓋・便座01(上げる)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/トイレの蓋・便座01(上げる).ogg",
    "size": 11623,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/トイレの蓋・便座02(下げる)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "トイレの蓋・便座02(下げる)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/トイレの蓋・便座02(下げる).ogg",
    "size": 16037,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/古い風呂場の扉を閉",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "古い風呂場の扉を閉",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/古い風呂場の扉を閉.ogg",
    "size": 43591,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/最新式水栓トイレ(外)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "最新式水栓トイレ(外)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/最新式水栓トイレ(外).ogg",
    "size": 327934,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/歯磨き",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "歯磨き",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/歯磨き.ogg",
    "size": 102891,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/水音(ﾊﾞﾁｬﾊﾞﾁｬ)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "水音(ﾊﾞﾁｬﾊﾞﾁｬ)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/水音(ﾊﾞﾁｬﾊﾞﾁｬ).ogg",
    "size": 273605,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/水道01(出す)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "水道01(出す)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/水道01(出す).ogg",
    "size": 68662,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/水道02(止める)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "水道02(止める)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/水道02(止める).ogg",
    "size": 86705,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/水道03(出して止める)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "水道03(出して止める)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/水道03(出して止める).ogg",
    "size": 104556,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/水漏れ・滴り",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "水漏れ・滴り",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/水漏れ・滴り.ogg",
    "size": 231534,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/洗面台",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "洗面台",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/洗面台.ogg",
    "size": 118921,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/体を流す01",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "体を流す01",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/体を流す01.ogg",
    "size": 235480,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/体を流す02",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "体を流す02",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/体を流す02.ogg",
    "size": 379122,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/体を流す03(外)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "体を流す03(外)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/体を流す03(外).ogg",
    "size": 225114,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/体重計01(乗る)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "体重計01(乗る)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/体重計01(乗る).ogg",
    "size": 51349,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/体重計02(降りる)",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "体重計02(降りる)",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/体重計02(降りる).ogg",
    "size": 54855,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/溺れる…",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "溺れる…",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/溺れる….ogg",
    "size": 338907,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/倒れる（風呂場）１",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "倒れる（風呂場）１",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/倒れる（風呂場）１.ogg",
    "size": 45587,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/倒れる（風呂場）２",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "倒れる（風呂場）２",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/倒れる（風呂場）２.ogg",
    "size": 67834,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/風呂から上がる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "風呂から上がる",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/風呂から上がる.ogg",
    "size": 140412,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/風呂のフタ開ける",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "風呂のフタ開ける",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/風呂のフタ開ける.ogg",
    "size": 62113,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/風呂のフタ閉める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "風呂のフタ閉める",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/風呂のフタ閉める.ogg",
    "size": 46041,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/風呂の中で暴れる",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "風呂の中で暴れる",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/風呂の中で暴れる.ogg",
    "size": 251328,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/風呂・トイレ/浴槽に水を溜める",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "浴槽に水を溜める",
    "description": "風呂・トイレ",
    "path": "builtin/se/pix-studio/00_日常生活音/風呂・トイレ/浴槽に水を溜める.ogg",
    "size": 392429,
    "tags": [
      "日常生活音",
      "風呂・トイレ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/仏壇でチーン",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "仏壇でチーン",
    "description": "",
    "path": "builtin/se/pix-studio/00_日常生活音/仏壇でチーン.ogg",
    "size": 205440,
    "tags": [
      "日常生活音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_日常生活音/網戸",
    "pack": "pix-studio",
    "category": "pix-studio/日常生活音",
    "categoryLabel": "日常生活音",
    "name": "網戸",
    "description": "",
    "path": "builtin/se/pix-studio/00_日常生活音/網戸.ogg",
    "size": 21299,
    "tags": [
      "日常生活音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/ガスをつける",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "ガスをつける",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/ガスをつける.ogg",
    "size": 43074,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/ガスをつける２",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "ガスをつける２",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/ガスをつける２.ogg",
    "size": 55064,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/やかん01(水を入れる)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "やかん01(水を入れる)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/やかん01(水を入れる).ogg",
    "size": 214785,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/やかん02(沸騰)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "やかん02(沸騰)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/やかん02(沸騰).ogg",
    "size": 486367,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/煮る01",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "煮る01",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/煮る01.ogg",
    "size": 333348,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/煮る02(蓋を取る)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "煮る02(蓋を取る)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/煮る02(蓋を取る).ogg",
    "size": 289753,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/煮る03(蓋をする)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "煮る03(蓋をする)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/煮る03(蓋をする).ogg",
    "size": 270034,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/切る01(白菜)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "切る01(白菜)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/切る01(白菜).ogg",
    "size": 10880,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/切る02(キャベツ)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "切る02(キャベツ)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/切る02(キャベツ).ogg",
    "size": 11284,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/切る03(玉ねぎ)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "切る03(玉ねぎ)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/切る03(玉ねぎ).ogg",
    "size": 11073,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/切る04(野菜)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "切る04(野菜)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/切る04(野菜).ogg",
    "size": 35245,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/切る05(連続)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "切る05(連続)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/切る05(連続).ogg",
    "size": 70624,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/切る06(高速)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "切る06(高速)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/切る06(高速).ogg",
    "size": 66670,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/調味料の蓋を開閉１",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "調味料の蓋を開閉１",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/調味料の蓋を開閉１.ogg",
    "size": 8702,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/調味料の蓋を開閉２",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "調味料の蓋を開閉２",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/調味料の蓋を開閉２.ogg",
    "size": 9751,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/瓶の蓋を開ける",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "瓶の蓋を開ける",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/瓶の蓋を開ける.ogg",
    "size": 44797,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/瓶の蓋を閉める",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "瓶の蓋を閉める",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/瓶の蓋を閉める.ogg",
    "size": 39891,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/沸騰している水",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "沸騰している水",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/沸騰している水.ogg",
    "size": 54659,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/炒める01",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "炒める01",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/炒める01.ogg",
    "size": 669630,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/00_料理・調理/炒める02(野菜)",
    "pack": "pix-studio",
    "category": "pix-studio/料理・調理",
    "categoryLabel": "料理・調理",
    "name": "炒める02(野菜)",
    "description": "",
    "path": "builtin/se/pix-studio/00_料理・調理/炒める02(野菜).ogg",
    "size": 620238,
    "tags": [
      "料理・調理"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/エンターキー",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "エンターキー",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/エンターキー.ogg",
    "size": 7522,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/カメラ撮影01",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "カメラ撮影01",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/カメラ撮影01.ogg",
    "size": 10873,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/カメラ撮影02(巻上)",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "カメラ撮影02(巻上)",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/カメラ撮影02(巻上).ogg",
    "size": 39330,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/カメラ撮影03(連写)",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "カメラ撮影03(連写)",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/カメラ撮影03(連写).ogg",
    "size": 131415,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/キーボード",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "キーボード",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/キーボード.ogg",
    "size": 130655,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/クリック",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "クリック",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/クリック.ogg",
    "size": 8933,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/スキャナー01",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "スキャナー01",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/スキャナー01.ogg",
    "size": 242470,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/スキャナー02",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "スキャナー02",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/スキャナー02.ogg",
    "size": 440602,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/ダブルクリック",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "ダブルクリック",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/ダブルクリック.ogg",
    "size": 13130,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/ディスクをドライブから出１",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "ディスクをドライブから出１",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/ディスクをドライブから出１.ogg",
    "size": 129486,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/ディスクをドライブから出２",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "ディスクをドライブから出２",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/ディスクをドライブから出２.ogg",
    "size": 26496,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/ディスクをドライブに入１",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "ディスクをドライブに入１",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/ディスクをドライブに入１.ogg",
    "size": 345943,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/ディスクをドライブに入２",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "ディスクをドライブに入２",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/ディスクをドライブに入２.ogg",
    "size": 27321,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/プリンター",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "プリンター",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/プリンター.ogg",
    "size": 559368,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/01_PC・周辺機器・カメラ/マイクノイズ",
    "pack": "pix-studio",
    "category": "pix-studio/PC・周辺機器・カメラ",
    "categoryLabel": "PC・周辺機器・カメラ",
    "name": "マイクノイズ",
    "description": "",
    "path": "builtin/se/pix-studio/01_PC・周辺機器・カメラ/マイクノイズ.ogg",
    "size": 55148,
    "tags": [
      "PC・周辺機器・カメラ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/attack1",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "attack1",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/attack1.ogg",
    "size": 12606,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/attack2",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "attack2",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/attack2.ogg",
    "size": 17692,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/damage1",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "damage1",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/damage1.ogg",
    "size": 10317,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/damage2",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "damage2",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/damage2.ogg",
    "size": 10340,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/damage3",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "damage3",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/damage3.ogg",
    "size": 7740,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/damage4",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "damage4",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/damage4.ogg",
    "size": 9101,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/damage5",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "damage5",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/damage5.ogg",
    "size": 10642,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/damage6",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "damage6",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/damage6.ogg",
    "size": 9803,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/damage7",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "damage7",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/damage7.ogg",
    "size": 12595,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/カンフー攻撃１",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "カンフー攻撃１",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/カンフー攻撃１.ogg",
    "size": 9140,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/カンフー攻撃２",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "カンフー攻撃２",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/カンフー攻撃２.ogg",
    "size": 10706,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/カンフー攻撃３",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "カンフー攻撃３",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/カンフー攻撃３.ogg",
    "size": 12291,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/カンフー攻撃４",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "カンフー攻撃４",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/カンフー攻撃４.ogg",
    "size": 13631,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/ぐるぐる振り回す",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "ぐるぐる振り回す",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/ぐるぐる振り回す.ogg",
    "size": 79685,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/ジャブ",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "ジャブ",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/ジャブ.ogg",
    "size": 11625,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/ストレートパンチ",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "ストレートパンチ",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/ストレートパンチ.ogg",
    "size": 14748,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/ブーメラン風攻撃",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "ブーメラン風攻撃",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/ブーメラン風攻撃.ogg",
    "size": 39102,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/フライパンで殴る",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "フライパンで殴る",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/フライパンで殴る.ogg",
    "size": 18951,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/ワンパンチで倒れる",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "ワンパンチで倒れる",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/ワンパンチで倒れる.ogg",
    "size": 28784,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/回し蹴り",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "回し蹴り",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/回し蹴り.ogg",
    "size": 12172,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/軽打１",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "軽打１",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/軽打１.ogg",
    "size": 8503,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/軽打２a",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "軽打２a",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/軽打２a.ogg",
    "size": 11675,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/軽打２b",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "軽打２b",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/軽打２b.ogg",
    "size": 14679,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/軽打２c",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "軽打２c",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/軽打２c.ogg",
    "size": 14852,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/拳を握る",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "拳を握る",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/拳を握る.ogg",
    "size": 36061,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/斬撃",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "斬撃",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/斬撃.ogg",
    "size": 18480,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/侍・うおぉぉぉぉ１",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "侍・うおぉぉぉぉ１",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/侍・うおぉぉぉぉ１.ogg",
    "size": 61247,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/侍・うおぉぉぉぉ２",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "侍・うおぉぉぉぉ２",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/侍・うおぉぉぉぉ２.ogg",
    "size": 84734,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/蹴り（重い打撃）",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "蹴り（重い打撃）",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/蹴り（重い打撃）.ogg",
    "size": 9565,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/素振り１",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "素振り１",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/素振り１.ogg",
    "size": 11733,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/素振り２",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "素振り２",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/素振り２.ogg",
    "size": 13136,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/素振り３",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "素振り３",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/素振り３.ogg",
    "size": 19134,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/打撃でザコ瞬殺１",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "打撃でザコ瞬殺１",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/打撃でザコ瞬殺１.ogg",
    "size": 42356,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/叩きつける",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "叩きつける",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/叩きつける.ogg",
    "size": 10181,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/叩く",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "叩く",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/叩く.ogg",
    "size": 8611,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/中打",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "中打",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/中打.ogg",
    "size": 8199,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/怒りの３１連打",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "怒りの３１連打",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/怒りの３１連打.ogg",
    "size": 70627,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/倒れる（床）１",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "倒れる（床）１",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/倒れる（床）１.ogg",
    "size": 21474,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/倒れる（畳）２",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "倒れる（畳）２",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/倒れる（畳）２.ogg",
    "size": 36977,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/二段蹴り",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "二段蹴り",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/二段蹴り.ogg",
    "size": 12634,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/必殺技１",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "必殺技１",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/必殺技１.ogg",
    "size": 34532,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/風切り１-２",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "風切り１-２",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/風切り１-２.ogg",
    "size": 10785,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/風切り１-３",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "風切り１-３",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/風切り１-３.ogg",
    "size": 11308,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/風切り１",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "風切り１",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/風切り１.ogg",
    "size": 9116,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/風切り２",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "風切り２",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/風切り２.ogg",
    "size": 10974,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/壁を叩く（壁ドン？）",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "壁を叩く（壁ドン？）",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/壁を叩く（壁ドン？）.ogg",
    "size": 11341,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_攻撃/連撃",
    "pack": "pix-studio",
    "category": "pix-studio/攻撃",
    "categoryLabel": "攻撃",
    "name": "連撃",
    "description": "",
    "path": "builtin/se/pix-studio/02_攻撃/連撃.ogg",
    "size": 14548,
    "tags": [
      "攻撃"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/いびき",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "いびき",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/いびき.ogg",
    "size": 67357,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/えい！(女声)",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "えい！(女声)",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/えい！(女声).ogg",
    "size": 7132,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/キス１",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "キス１",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/キス１.ogg",
    "size": 7435,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/キャッ！(女声)",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "キャッ！(女声)",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/キャッ！(女声).ogg",
    "size": 6432,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/くしゃみ",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "くしゃみ",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/くしゃみ.ogg",
    "size": 29220,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/ゲップ",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "ゲップ",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/ゲップ.ogg",
    "size": 8181,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/ゴクンと飲み込む",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "ゴクンと飲み込む",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/ゴクンと飲み込む.ogg",
    "size": 9078,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/しゃっくり",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "しゃっくり",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/しゃっくり.ogg",
    "size": 9323,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/ぼりぼり掻く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "ぼりぼり掻く",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/ぼりぼり掻く.ogg",
    "size": 28801,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/強烈キス２",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "強烈キス２",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/強烈キス２.ogg",
    "size": 30427,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/鼓動（心臓の音）",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "鼓動（心臓の音）",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/鼓動（心臓の音）.ogg",
    "size": 79191,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/口笛（ひやかし）",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "口笛（ひやかし）",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/口笛（ひやかし）.ogg",
    "size": 22507,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/歯軋りっぽい",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "歯軋りっぽい",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/歯軋りっぽい.ogg",
    "size": 66926,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/手音/一人拍手１",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "一人拍手１",
    "description": "手音",
    "path": "builtin/se/pix-studio/02_人が出す音/手音/一人拍手１.ogg",
    "size": 80996,
    "tags": [
      "人が出す音",
      "手音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/手音/一人拍手２",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "一人拍手２",
    "description": "手音",
    "path": "builtin/se/pix-studio/02_人が出す音/手音/一人拍手２.ogg",
    "size": 74410,
    "tags": [
      "人が出す音",
      "手音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/手音/指ぱっちん",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "指ぱっちん",
    "description": "手音",
    "path": "builtin/se/pix-studio/02_人が出す音/手音/指ぱっちん.ogg",
    "size": 7714,
    "tags": [
      "人が出す音",
      "手音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/手音/爪切り",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "爪切り",
    "description": "手音",
    "path": "builtin/se/pix-studio/02_人が出す音/手音/爪切り.ogg",
    "size": 22903,
    "tags": [
      "人が出す音",
      "手音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/手音/二拍手",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "二拍手",
    "description": "手音",
    "path": "builtin/se/pix-studio/02_人が出す音/手音/二拍手.ogg",
    "size": 30815,
    "tags": [
      "人が出す音",
      "手音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/手音/平手打ち（エコー）３",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "平手打ち（エコー）３",
    "description": "手音",
    "path": "builtin/se/pix-studio/02_人が出す音/手音/平手打ち（エコー）３.ogg",
    "size": 55101,
    "tags": [
      "人が出す音",
      "手音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/手音/平手打ち（ビンタ）１",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "平手打ち（ビンタ）１",
    "description": "手音",
    "path": "builtin/se/pix-studio/02_人が出す音/手音/平手打ち（ビンタ）１.ogg",
    "size": 13051,
    "tags": [
      "人が出す音",
      "手音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/手音/平手打ち（強烈）２",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "平手打ち（強烈）２",
    "description": "手音",
    "path": "builtin/se/pix-studio/02_人が出す音/手音/平手打ち（強烈）２.ogg",
    "size": 10261,
    "tags": [
      "人が出す音",
      "手音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/畳の上を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "畳の上を歩く",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/畳の上を歩く.ogg",
    "size": 122992,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/心臓音（病的に速い）",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "心臓音（病的に速い）",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/心臓音（病的に速い）.ogg",
    "size": 38588,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler1",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler1",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler1.ogg",
    "size": 17454,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler10",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler10",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler10.ogg",
    "size": 10407,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler11",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler11",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler11.ogg",
    "size": 6665,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler12",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler12",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler12.ogg",
    "size": 12572,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler13",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler13",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler13.ogg",
    "size": 14087,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler14",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler14",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler14.ogg",
    "size": 7892,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler15",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler15",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler15.ogg",
    "size": 10842,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler16",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler16",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler16.ogg",
    "size": 8575,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler17",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler17",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler17.ogg",
    "size": 12014,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler18",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler18",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler18.ogg",
    "size": 12643,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler19",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler19",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler19.ogg",
    "size": 21826,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler2",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler2",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler2.ogg",
    "size": 11326,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler20",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler20",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler20.ogg",
    "size": 30689,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler21",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler21",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler21.ogg",
    "size": 6907,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler22",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler22",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler22.ogg",
    "size": 5798,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler23",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler23",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler23.ogg",
    "size": 12510,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler24",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler24",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler24.ogg",
    "size": 7977,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler25",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler25",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler25.ogg",
    "size": 8766,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler3",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler3",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler3.ogg",
    "size": 6540,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler4",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler4",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler4.ogg",
    "size": 9170,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler5",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler5",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler5.ogg",
    "size": 31727,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler6",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler6",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler6.ogg",
    "size": 11063,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler7",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler7",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler7.ogg",
    "size": 10791,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler8",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler8",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler8.ogg",
    "size": 9737,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/赤ちゃんの声/chandler9",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "chandler9",
    "description": "赤ちゃんの声",
    "path": "builtin/se/pix-studio/02_人が出す音/赤ちゃんの声/chandler9.ogg",
    "size": 6383,
    "tags": [
      "人が出す音",
      "赤ちゃんの声"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/スリッパで小走り",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "スリッパで小走り",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/スリッパで小走り.ogg",
    "size": 63640,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/ビルの階段下りる",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "ビルの階段下りる",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/ビルの階段下りる.ogg",
    "size": 228681,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/家の階段降りる（緩）",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "家の階段降りる（緩）",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/家の階段降りる（緩）.ogg",
    "size": 174846,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/家の階段上がる（急）２",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "家の階段上がる（急）２",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/家の階段上がる（急）２.ogg",
    "size": 89057,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/家の階段上がる１",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "家の階段上がる１",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/家の階段上がる１.ogg",
    "size": 143887,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/枯葉の上を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "枯葉の上を歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/枯葉の上を歩く.ogg",
    "size": 514510,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/砂利の上を走る",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "砂利の上を走る",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/砂利の上を走る.ogg",
    "size": 43814,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/砂利の上を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "砂利の上を歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/砂利の上を歩く.ogg",
    "size": 120155,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/砂利道（山道）を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "砂利道（山道）を歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/砂利道（山道）を歩く.ogg",
    "size": 1306404,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/取っ組み合い",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "取っ組み合い",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/取っ組み合い.ogg",
    "size": 104132,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/秋夜の山道走る",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "秋夜の山道走る",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/秋夜の山道走る.ogg",
    "size": 213825,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/秋夜の道を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "秋夜の道を歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/秋夜の道を歩く.ogg",
    "size": 463110,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/床をゆっくり歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "床をゆっくり歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/床をゆっくり歩く.ogg",
    "size": 120313,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/床を土足で歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "床を土足で歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/床を土足で歩く.ogg",
    "size": 42887,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/雪の中を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "雪の中を歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/雪の中を歩く.ogg",
    "size": 143846,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/雪の中を歩く＋風",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "雪の中を歩く＋風",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/雪の中を歩く＋風.ogg",
    "size": 300014,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/走る（閉鎖された空間）",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "走る（閉鎖された空間）",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/走る（閉鎖された空間）.ogg",
    "size": 113141,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/走る１",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "走る１",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/走る１.ogg",
    "size": 76349,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/低い山を登る",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "低い山を登る",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/低い山を登る.ogg",
    "size": 713232,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/土の上を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "土の上を歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/土の上を歩く.ogg",
    "size": 119992,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/道路で駆け出す１",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "道路で駆け出す１",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/道路で駆け出す１.ogg",
    "size": 73358,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/木の廊下をスリッパで",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "木の廊下をスリッパで",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/木の廊下をスリッパで.ogg",
    "size": 122385,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/木の廊下を裸足で歩く",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "木の廊下を裸足で歩く",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/木の廊下を裸足で歩く.ogg",
    "size": 35790,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/足音/夜の散歩（ループ）",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "夜の散歩（ループ）",
    "description": "足音",
    "path": "builtin/se/pix-studio/02_人が出す音/足音/夜の散歩（ループ）.ogg",
    "size": 219242,
    "tags": [
      "人が出す音",
      "足音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/大きなオナラ",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "大きなオナラ",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/大きなオナラ.ogg",
    "size": 47054,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/男が咳き込む",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "男が咳き込む",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/男が咳き込む.ogg",
    "size": 116041,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/男のうがい",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "男のうがい",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/男のうがい.ogg",
    "size": 67605,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/鼻をかむ",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "鼻をかむ",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/鼻をかむ.ogg",
    "size": 26741,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/鼻をすする（風邪気味）",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "鼻をすする（風邪気味）",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/鼻をすする（風邪気味）.ogg",
    "size": 16914,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/02_人が出す音/腹が鳴る（お腹空いた）",
    "pack": "pix-studio",
    "category": "pix-studio/人が出す音",
    "categoryLabel": "人が出す音",
    "name": "腹が鳴る（お腹空いた）",
    "description": "",
    "path": "builtin/se/pix-studio/02_人が出す音/腹が鳴る（お腹空いた）.ogg",
    "size": 29347,
    "tags": [
      "人が出す音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/ロッカー開ける",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ロッカー開ける",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/ロッカー開ける.ogg",
    "size": 18499,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/ロッカー閉める",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ロッカー閉める",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/ロッカー閉める.ogg",
    "size": 12436,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/シュート練習",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "シュート練習",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/シュート練習.ogg",
    "size": 170937,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ストップウォッチ１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ストップウォッチ１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ストップウォッチ１.ogg",
    "size": 12582,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ストップウォッチ２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ストップウォッチ２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ストップウォッチ２.ogg",
    "size": 16748,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/スライディング１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "スライディング１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/スライディング１.ogg",
    "size": 34762,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/スライディング２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "スライディング２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/スライディング２.ogg",
    "size": 90945,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ドッジボール",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ドッジボール",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ドッジボール.ogg",
    "size": 12297,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ドリブル練習",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ドリブル練習",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ドリブル練習.ogg",
    "size": 283632,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/バスケ練習１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "バスケ練習１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/バスケ練習１.ogg",
    "size": 1499657,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/バスケ練習２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "バスケ練習２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/バスケ練習２.ogg",
    "size": 1298588,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/バスケ練習３",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "バスケ練習３",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/バスケ練習３.ogg",
    "size": 520311,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/バトミントン練習",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "バトミントン練習",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/バトミントン練習.ogg",
    "size": 412063,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ピンポンパン（校内放送）",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ピンポンパン（校内放送）",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ピンポンパン（校内放送）.ogg",
    "size": 26980,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ブザー１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ブザー１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ブザー１.ogg",
    "size": 31025,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ブザー２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ブザー２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ブザー２.ogg",
    "size": 32469,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ホイッスル１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ホイッスル１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ホイッスル１.ogg",
    "size": 47526,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ホイッスル２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ホイッスル２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ホイッスル２.ogg",
    "size": 53485,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ホイッスル３",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ホイッスル３",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ホイッスル３.ogg",
    "size": 31184,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/ママさんバレー練習",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "ママさんバレー練習",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/ママさんバレー練習.ogg",
    "size": 1820514,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/夏の少年野球１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "夏の少年野球１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/夏の少年野球１.ogg",
    "size": 350253,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/夏の少年野球２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "夏の少年野球２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/夏の少年野球２.ogg",
    "size": 737728,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/金網にぶつかる",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "金網にぶつかる",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/金網にぶつかる.ogg",
    "size": 25941,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/剣道男子声援１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "剣道男子声援１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/剣道男子声援１.ogg",
    "size": 672434,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/剣道男子声援２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "剣道男子声援２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/剣道男子声援２.ogg",
    "size": 414148,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/高校女子バレー１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "高校女子バレー１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/高校女子バレー１.ogg",
    "size": 1604083,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/高校女子バレー２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "高校女子バレー２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/高校女子バレー２.ogg",
    "size": 4056656,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/高校女子剣道大会",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "高校女子剣道大会",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/高校女子剣道大会.ogg",
    "size": 4113755,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/高校男子バレー１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "高校男子バレー１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/高校男子バレー１.ogg",
    "size": 624117,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/高校男子バレー２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "高校男子バレー２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/高校男子バレー２.ogg",
    "size": 1649154,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/高校男子バレー応援",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "高校男子バレー応援",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/高校男子バレー応援.ogg",
    "size": 298094,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/高校男子剣道大会",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "高校男子剣道大会",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/高校男子剣道大会.ogg",
    "size": 1088613,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/市民バトミントン大会",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "市民バトミントン大会",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/市民バトミントン大会.ogg",
    "size": 1960178,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/女子高生の歓声と拍手",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "女子高生の歓声と拍手",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/女子高生の歓声と拍手.ogg",
    "size": 133305,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/壮年・卓球大会",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "壮年・卓球大会",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/壮年・卓球大会.ogg",
    "size": 1346549,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/大学サッカー（応援）",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "大学サッカー（応援）",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/大学サッカー（応援）.ogg",
    "size": 1162524,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/大学柔道男子１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "大学柔道男子１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/大学柔道男子１.ogg",
    "size": 657896,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/大学柔道男子２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "大学柔道男子２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/大学柔道男子２.ogg",
    "size": 905137,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/男子バスケ試合１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "男子バスケ試合１",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/男子バスケ試合１.ogg",
    "size": 1984011,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/男子バスケ試合２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "男子バスケ試合２",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/男子バスケ試合２.ogg",
    "size": 1884954,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/男子バスケ試合３",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "男子バスケ試合３",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/男子バスケ試合３.ogg",
    "size": 1429181,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/運動部の音/男子バレー練習",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "男子バレー練習",
    "description": "運動部の音",
    "path": "builtin/se/pix-studio/03_学校/運動部の音/男子バレー練習.ogg",
    "size": 872508,
    "tags": [
      "学校",
      "運動部の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/学校チャイム",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "学校チャイム",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/学校チャイム.ogg",
    "size": 210729,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/教室の扉開閉１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "教室の扉開閉１",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/教室の扉開閉１.ogg",
    "size": 33394,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/教室の扉開閉２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "教室の扉開閉２",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/教室の扉開閉２.ogg",
    "size": 46845,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/事務用ロッカー開ける",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "事務用ロッカー開ける",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/事務用ロッカー開ける.ogg",
    "size": 39648,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/事務用ロッカー閉める",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "事務用ロッカー閉める",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/事務用ロッカー閉める.ogg",
    "size": 18173,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/小学生遠足１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "小学生遠足１",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/小学生遠足１.ogg",
    "size": 422683,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/小学生遠足２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "小学生遠足２",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/小学生遠足２.ogg",
    "size": 605427,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/体育館がやがや１",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "体育館がやがや１",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/体育館がやがや１.ogg",
    "size": 992454,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/体育館がやがや２",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "体育館がやがや２",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/体育館がやがや２.ogg",
    "size": 414677,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/筆記試験",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "筆記試験",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/筆記試験.ogg",
    "size": 436492,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/03_学校/幼稚園児の遠足",
    "pack": "pix-studio",
    "category": "pix-studio/学校",
    "categoryLabel": "学校",
    "name": "幼稚園児の遠足",
    "description": "",
    "path": "builtin/se/pix-studio/03_学校/幼稚園児の遠足.ogg",
    "size": 1355347,
    "tags": [
      "学校"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_アラーム/アラーム",
    "pack": "pix-studio",
    "category": "pix-studio/アラーム",
    "categoryLabel": "アラーム",
    "name": "アラーム",
    "description": "",
    "path": "builtin/se/pix-studio/04_アラーム/アラーム.ogg",
    "size": 7502,
    "tags": [
      "アラーム"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_アラーム/サイレン",
    "pack": "pix-studio",
    "category": "pix-studio/アラーム",
    "categoryLabel": "アラーム",
    "name": "サイレン",
    "description": "",
    "path": "builtin/se/pix-studio/04_アラーム/サイレン.ogg",
    "size": 27586,
    "tags": [
      "アラーム"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_アラーム/ポリスサイレン",
    "pack": "pix-studio",
    "category": "pix-studio/アラーム",
    "categoryLabel": "アラーム",
    "name": "ポリスサイレン",
    "description": "",
    "path": "builtin/se/pix-studio/04_アラーム/ポリスサイレン.ogg",
    "size": 51877,
    "tags": [
      "アラーム"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/JR構内（改札・夕方）１",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "JR構内（改札・夕方）１",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/JR構内（改札・夕方）１.ogg",
    "size": 428053,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/JR構内（改札・夕方）２",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "JR構内（改札・夕方）２",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/JR構内（改札・夕方）２.ogg",
    "size": 576907,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/JR構内のアナウンス",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "JR構内のアナウンス",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/JR構内のアナウンス.ogg",
    "size": 309825,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/エスカレーター",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "エスカレーター",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/エスカレーター.ogg",
    "size": 279553,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/エレベータで降る",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "エレベータで降る",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/エレベータで降る.ogg",
    "size": 436722,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/エレベータで昇る",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "エレベータで昇る",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/エレベータで昇る.ogg",
    "size": 485630,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/私鉄で券を買う",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "私鉄で券を買う",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/私鉄で券を買う.ogg",
    "size": 280008,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/私鉄の中（夕方）",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "私鉄の中（夕方）",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/私鉄の中（夕方）.ogg",
    "size": 950333,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/私鉄の中２",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "私鉄の中２",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/私鉄の中２.ogg",
    "size": 1515119,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/私鉄ホーム",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "私鉄ホーム",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/私鉄ホーム.ogg",
    "size": 933335,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/私鉄改札",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "私鉄改札",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/私鉄改札.ogg",
    "size": 2056794,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/私鉄発車",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "私鉄発車",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/私鉄発車.ogg",
    "size": 430300,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/新幹線ホーム１",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "新幹線ホーム１",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/新幹線ホーム１.ogg",
    "size": 893758,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/新幹線ホーム２",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "新幹線ホーム２",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/新幹線ホーム２.ogg",
    "size": 2725274,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/新幹線到着",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "新幹線到着",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/新幹線到着.ogg",
    "size": 784847,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/新幹線内１",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "新幹線内１",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/新幹線内１.ogg",
    "size": 211717,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/新幹線内２（自動ドア）",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "新幹線内２（自動ドア）",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/新幹線内２（自動ドア）.ogg",
    "size": 196752,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/新幹線発着サイレン",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "新幹線発着サイレン",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/新幹線発着サイレン.ogg",
    "size": 667982,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/新宿駅地下改札（夜）",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "新宿駅地下改札（夜）",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/新宿駅地下改札（夜）.ogg",
    "size": 1070151,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/地下鉄の出口（改札外）",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "地下鉄の出口（改札外）",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/地下鉄の出口（改札外）.ogg",
    "size": 1135602,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/地下鉄切符買う",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "地下鉄切符買う",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/地下鉄切符買う.ogg",
    "size": 266892,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/地下鉄到着",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "地下鉄到着",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/地下鉄到着.ogg",
    "size": 546091,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/地下鉄発車",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "地下鉄発車",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/地下鉄発車.ogg",
    "size": 693619,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/地下鉄列車内１",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "地下鉄列車内１",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/地下鉄列車内１.ogg",
    "size": 866412,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/地下鉄列車内加速",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "地下鉄列車内加速",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/地下鉄列車内加速.ogg",
    "size": 390529,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_駅/地下鉄列車内減速",
    "pack": "pix-studio",
    "category": "pix-studio/駅",
    "categoryLabel": "駅",
    "name": "地下鉄列車内減速",
    "description": "",
    "path": "builtin/se/pix-studio/04_駅/地下鉄列車内減速.ogg",
    "size": 342874,
    "tags": [
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_救急・消防/救急車LOOP",
    "pack": "pix-studio",
    "category": "pix-studio/救急・消防",
    "categoryLabel": "救急・消防",
    "name": "救急車LOOP",
    "description": "",
    "path": "builtin/se/pix-studio/04_救急・消防/救急車LOOP.ogg",
    "size": 39753,
    "tags": [
      "救急・消防"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_救急・消防/救急車通過",
    "pack": "pix-studio",
    "category": "pix-studio/救急・消防",
    "categoryLabel": "救急・消防",
    "name": "救急車通過",
    "description": "",
    "path": "builtin/se/pix-studio/04_救急・消防/救急車通過.ogg",
    "size": 244829,
    "tags": [
      "救急・消防"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_救急・消防/広域サイレン",
    "pack": "pix-studio",
    "category": "pix-studio/救急・消防",
    "categoryLabel": "救急・消防",
    "name": "広域サイレン",
    "description": "",
    "path": "builtin/se/pix-studio/04_救急・消防/広域サイレン.ogg",
    "size": 506836,
    "tags": [
      "救急・消防"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_救急・消防/消防車たくさん出動",
    "pack": "pix-studio",
    "category": "pix-studio/救急・消防",
    "categoryLabel": "救急・消防",
    "name": "消防車たくさん出動",
    "description": "",
    "path": "builtin/se/pix-studio/04_救急・消防/消防車たくさん出動.ogg",
    "size": 699231,
    "tags": [
      "救急・消防"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_救急・消防/消防車出発",
    "pack": "pix-studio",
    "category": "pix-studio/救急・消防",
    "categoryLabel": "救急・消防",
    "name": "消防車出発",
    "description": "",
    "path": "builtin/se/pix-studio/04_救急・消防/消防車出発.ogg",
    "size": 870648,
    "tags": [
      "救急・消防"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_救急・消防/消防車通過",
    "pack": "pix-studio",
    "category": "pix-studio/救急・消防",
    "categoryLabel": "救急・消防",
    "name": "消防車通過",
    "description": "",
    "path": "builtin/se/pix-studio/04_救急・消防/消防車通過.ogg",
    "size": 581787,
    "tags": [
      "救急・消防"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_救急・消防/黙とうサイレン（1分間）",
    "pack": "pix-studio",
    "category": "pix-studio/救急・消防",
    "categoryLabel": "救急・消防",
    "name": "黙とうサイレン（1分間）",
    "description": "",
    "path": "builtin/se/pix-studio/04_救急・消防/黙とうサイレン（1分間）.ogg",
    "size": 414198,
    "tags": [
      "救急・消防"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/ゴミ回収車",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "ゴミ回収車",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/ゴミ回収車.ogg",
    "size": 1129219,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/トラックがゆっくり通過",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "トラックがゆっくり通過",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/トラックがゆっくり通過.ogg",
    "size": 800447,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/トラックが通り過ぎる",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "トラックが通り過ぎる",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/トラックが通り過ぎる.ogg",
    "size": 194708,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/トラックが目前曲がる",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "トラックが目前曲がる",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/トラックが目前曲がる.ogg",
    "size": 335133,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/トラック通過２（複数）",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "トラック通過２（複数）",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/トラック通過２（複数）.ogg",
    "size": 560602,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/バイクの多い道",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "バイクの多い道",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/バイクの多い道.ogg",
    "size": 507827,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/バイクをふかす音",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "バイクをふかす音",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/バイクをふかす音.ogg",
    "size": 221442,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/バス/バスのエンジン音(停車中)",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "バスのエンジン音(停車中)",
    "description": "バス",
    "path": "builtin/se/pix-studio/04_車道/バス/バスのエンジン音(停車中).ogg",
    "size": 128180,
    "tags": [
      "車道",
      "バス"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/バス/夜行バス",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "夜行バス",
    "description": "バス",
    "path": "builtin/se/pix-studio/04_車道/バス/夜行バス.ogg",
    "size": 322738,
    "tags": [
      "車道",
      "バス"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/バス/路線バスの中１",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "路線バスの中１",
    "description": "バス",
    "path": "builtin/se/pix-studio/04_車道/バス/路線バスの中１.ogg",
    "size": 721516,
    "tags": [
      "車道",
      "バス"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/バス/路線バス発車",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "路線バス発車",
    "description": "バス",
    "path": "builtin/se/pix-studio/04_車道/バス/路線バス発車.ogg",
    "size": 798550,
    "tags": [
      "車道",
      "バス"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/貨物トラック通過１",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "貨物トラック通過１",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/貨物トラック通過１.ogg",
    "size": 161995,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/混んでない車道４",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "混んでない車道４",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/混んでない車道４.ogg",
    "size": 1378996,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/混んでない車道５",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "混んでない車道５",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/混んでない車道５.ogg",
    "size": 516351,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自転車/止めた自転車を動かす",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "止めた自転車を動かす",
    "description": "自転車",
    "path": "builtin/se/pix-studio/04_車道/自転車/止めた自転車を動かす.ogg",
    "size": 37366,
    "tags": [
      "車道",
      "自転車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自転車/自転車チリリン・ベル",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "自転車チリリン・ベル",
    "description": "自転車",
    "path": "builtin/se/pix-studio/04_車道/自転車/自転車チリリン・ベル.ogg",
    "size": 22135,
    "tags": [
      "車道",
      "自転車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自転車/自転車の高速回転",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "自転車の高速回転",
    "description": "自転車",
    "path": "builtin/se/pix-studio/04_車道/自転車/自転車の高速回転.ogg",
    "size": 1396134,
    "tags": [
      "車道",
      "自転車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自転車/自転車止める",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "自転車止める",
    "description": "自転車",
    "path": "builtin/se/pix-studio/04_車道/自転車/自転車止める.ogg",
    "size": 55210,
    "tags": [
      "車道",
      "自転車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/エンジン内側から",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "エンジン内側から",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/エンジン内側から.ogg",
    "size": 293786,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/サイドブレーキを引く",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "サイドブレーキを引く",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/サイドブレーキを引く.ogg",
    "size": 15997,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/スポーツカー発進",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "スポーツカー発進",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/スポーツカー発進.ogg",
    "size": 52622,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/軽自動車のドア開ける",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "軽自動車のドア開ける",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/軽自動車のドア開ける.ogg",
    "size": 20200,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/軽自動車のドア閉める",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "軽自動車のドア閉める",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/軽自動車のドア閉める.ogg",
    "size": 14661,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/軽自動車のトランク開ける",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "軽自動車のトランク開ける",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/軽自動車のトランク開ける.ogg",
    "size": 10469,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/軽自動車のトランク閉める",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "軽自動車のトランク閉める",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/軽自動車のトランク閉める.ogg",
    "size": 32462,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/軽自動車運転（車内）",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "軽自動車運転（車内）",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/軽自動車運転（車内）.ogg",
    "size": 555149,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/軽車エンジン掛ける",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "軽車エンジン掛ける",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/軽車エンジン掛ける.ogg",
    "size": 161677,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/鍵を挿してドア開ける",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "鍵を挿してドア開ける",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/鍵を挿してドア開ける.ogg",
    "size": 76623,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/高速トンネルの中１",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "高速トンネルの中１",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/高速トンネルの中１.ogg",
    "size": 812241,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/高速トンネルの中２",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "高速トンネルの中２",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/高速トンネルの中２.ogg",
    "size": 792429,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/高速トンネル入出",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "高速トンネル入出",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/高速トンネル入出.ogg",
    "size": 1034272,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/高速短いトンネル",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "高速短いトンネル",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/高速短いトンネル.ogg",
    "size": 407285,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/高速道路運転１",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "高速道路運転１",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/高速道路運転１.ogg",
    "size": 432718,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/高速道路運転２",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "高速道路運転２",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/高速道路運転２.ogg",
    "size": 310846,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/車のドア内側から開ける",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車のドア内側から開ける",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/車のドア内側から開ける.ogg",
    "size": 8809,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/車のドア内側から閉める",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車のドア内側から閉める",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/車のドア内側から閉める.ogg",
    "size": 12743,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/自動車/走行停止",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "走行停止",
    "description": "自動車",
    "path": "builtin/se/pix-studio/04_車道/自動車/走行停止.ogg",
    "size": 221658,
    "tags": [
      "車道",
      "自動車"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/車が横を通る",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車が横を通る",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/車が横を通る.ogg",
    "size": 182928,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/車が横を通過（危！）",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車が横を通過（危！）",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/車が横を通過（危！）.ogg",
    "size": 118386,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/車の往来１（夜）",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車の往来１（夜）",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/車の往来１（夜）.ogg",
    "size": 1063292,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/車の往来２（夜）",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車の往来２（夜）",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/車の往来２（夜）.ogg",
    "size": 403994,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/車道１",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車道１",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/車道１.ogg",
    "size": 817359,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/車道２（長）",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車道２（長）",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/車道２（長）.ogg",
    "size": 1566389,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/車道３（激しい）",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "車道３（激しい）",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/車道３（激しい）.ogg",
    "size": 812409,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_車道/夜の車通り（長）",
    "pack": "pix-studio",
    "category": "pix-studio/車道",
    "categoryLabel": "車道",
    "name": "夜の車通り（長）",
    "description": "",
    "path": "builtin/se/pix-studio/04_車道/夜の車通り（長）.ogg",
    "size": 1562262,
    "tags": [
      "車道"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/高架線下１",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "高架線下１",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/高架線下１.ogg",
    "size": 212450,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/高架線下２",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "高架線下２",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/高架線下２.ogg",
    "size": 190172,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/高架線下トンネル車道１",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "高架線下トンネル車道１",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/高架線下トンネル車道１.ogg",
    "size": 1166235,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/高架線下トンネル車道２",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "高架線下トンネル車道２",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/高架線下トンネル車道２.ogg",
    "size": 297869,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/電車通過のみ",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "電車通過のみ",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/電車通過のみ.ogg",
    "size": 208992,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/踏み切りカンカン",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "踏み切りカンカン",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/踏み切りカンカン.ogg",
    "size": 406777,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/踏み切り貨物列車通過",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "踏み切り貨物列車通過",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/踏み切り貨物列車通過.ogg",
    "size": 2128655,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/踏み切り電車１台通過",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "踏み切り電車１台通過",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/踏み切り電車１台通過.ogg",
    "size": 1579125,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/04_線路/踏み切り電車２台通過",
    "pack": "pix-studio",
    "category": "pix-studio/線路",
    "categoryLabel": "線路",
    "name": "踏み切り電車２台通過",
    "description": "",
    "path": "builtin/se/pix-studio/04_線路/踏み切り電車２台通過.ogg",
    "size": 1108746,
    "tags": [
      "線路"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/お菓子の紙箱を開ける01",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "お菓子の紙箱を開ける01",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/お菓子の紙箱を開ける01.ogg",
    "size": 35065,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/お菓子の紙箱を開ける02",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "お菓子の紙箱を開ける02",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/お菓子の紙箱を開ける02.ogg",
    "size": 17187,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/お菓子の袋を開ける01(ポテチ)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "お菓子の袋を開ける01(ポテチ)",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/お菓子の袋を開ける01(ポテチ).ogg",
    "size": 71513,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/お菓子の袋を開ける02",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "お菓子の袋を開ける02",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/お菓子の袋を開ける02.ogg",
    "size": 111166,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/お菓子の袋を開ける03(小袋)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "お菓子の袋を開ける03(小袋)",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/お菓子の袋を開ける03(小袋).ogg",
    "size": 135327,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/すする01(ラーメン)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "すする01(ラーメン)",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/すする01(ラーメン).ogg",
    "size": 66656,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/すする02(汁)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "すする02(汁)",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/すする02(汁).ogg",
    "size": 17807,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/ストローぶくぶく01",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "ストローぶくぶく01",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/ストローぶくぶく01.ogg",
    "size": 353298,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/ストローぶくぶく02",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "ストローぶくぶく02",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/ストローぶくぶく02.ogg",
    "size": 97269,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/ふりかけ1回",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "ふりかけ1回",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/ふりかけ1回.ogg",
    "size": 11816,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/ふりかけ2回",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "ふりかけ2回",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/ふりかけ2回.ogg",
    "size": 13651,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/ふりかけ3回",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "ふりかけ3回",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/ふりかけ3回.ogg",
    "size": 16945,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/ボリボリ食べる01",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "ボリボリ食べる01",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/ボリボリ食べる01.ogg",
    "size": 91626,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/ボリボリ食べる02",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "ボリボリ食べる02",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/ボリボリ食べる02.ogg",
    "size": 284624,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/グラスで乾杯01",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "グラスで乾杯01",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/グラスで乾杯01.ogg",
    "size": 36653,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/グラスで乾杯02",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "グラスで乾杯02",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/グラスで乾杯02.ogg",
    "size": 35404,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/グラスで乾杯03",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "グラスで乾杯03",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/グラスで乾杯03.ogg",
    "size": 32512,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/コーヒーを混ぜる",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "コーヒーを混ぜる",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/コーヒーを混ぜる.ogg",
    "size": 182420,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/急須に蓋をする",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "急須に蓋をする",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/急須に蓋をする.ogg",
    "size": 11212,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/急須の蓋を取る",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "急須の蓋を取る",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/急須の蓋を取る.ogg",
    "size": 12877,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/紅茶を混ぜる",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "紅茶を混ぜる",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/紅茶を混ぜる.ogg",
    "size": 149155,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/栓抜き01",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "栓抜き01",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/栓抜き01.ogg",
    "size": 17108,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/栓抜き02",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "栓抜き02",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/栓抜き02.ogg",
    "size": 10904,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/炭酸缶を開けて注ぐ",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "炭酸缶を開けて注ぐ",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/炭酸缶を開けて注ぐ.ogg",
    "size": 179344,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/炭酸缶を開ける",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "炭酸缶を開ける",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/炭酸缶を開ける.ogg",
    "size": 33091,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/注ぐ01(コップに水)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "注ぐ01(コップに水)",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/注ぐ01(コップに水).ogg",
    "size": 71931,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/注ぐ02(グラス)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "注ぐ02(グラス)",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/注ぐ02(グラス).ogg",
    "size": 96023,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/注ぐ03(なみなみと)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "注ぐ03(なみなみと)",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/注ぐ03(なみなみと).ogg",
    "size": 157901,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/注ぐ04(炭酸)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "注ぐ04(炭酸)",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/注ぐ04(炭酸).ogg",
    "size": 150831,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/注ぐ05(ポット)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "注ぐ05(ポット)",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/注ぐ05(ポット).ogg",
    "size": 155367,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/注ぐ06(沸かしたやかん)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "注ぐ06(沸かしたやかん)",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/注ぐ06(沸かしたやかん).ogg",
    "size": 363516,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/注ぐ07(冷たいお茶)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "注ぐ07(冷たいお茶)",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/注ぐ07(冷たいお茶).ogg",
    "size": 132102,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/注ぐ08(熱いお茶)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "注ぐ08(熱いお茶)",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/注ぐ08(熱いお茶).ogg",
    "size": 118397,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲み物用意/氷入りジュースを混ぜる",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "氷入りジュースを混ぜる",
    "description": "飲み物用意",
    "path": "builtin/se/pix-studio/05_食事関係/飲み物用意/氷入りジュースを混ぜる.ogg",
    "size": 85109,
    "tags": [
      "食事関係",
      "飲み物用意"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲む01(ごくごく)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "飲む01(ごくごく)",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/飲む01(ごくごく).ogg",
    "size": 55737,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲む03(熱い飲み物)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "飲む03(熱い飲み物)",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/飲む03(熱い飲み物).ogg",
    "size": 45495,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/05_食事関係/飲む04(熱い飲み物・飲み込む)",
    "pack": "pix-studio",
    "category": "pix-studio/食事関係",
    "categoryLabel": "食事関係",
    "name": "飲む04(熱い飲み物・飲み込む)",
    "description": "",
    "path": "builtin/se/pix-studio/05_食事関係/飲む04(熱い飲み物・飲み込む).ogg",
    "size": 80649,
    "tags": [
      "食事関係"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/06_拍手/コンサートホール拍手",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "コンサートホール拍手",
    "description": "06_拍手",
    "path": "builtin/se/pix-studio/06_イベント会場の音/06_拍手/コンサートホール拍手.ogg",
    "size": 224699,
    "tags": [
      "イベント会場の音",
      "06_拍手"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/06_拍手/まばらな拍手",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "まばらな拍手",
    "description": "06_拍手",
    "path": "builtin/se/pix-studio/06_イベント会場の音/06_拍手/まばらな拍手.ogg",
    "size": 111637,
    "tags": [
      "イベント会場の音",
      "06_拍手"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/06_拍手/拍手（ブラボー付）",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "拍手（ブラボー付）",
    "description": "06_拍手",
    "path": "builtin/se/pix-studio/06_イベント会場の音/06_拍手/拍手（ブラボー付）.ogg",
    "size": 478811,
    "tags": [
      "イベント会場の音",
      "06_拍手"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/06_拍手/拍手短め",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "拍手短め",
    "description": "06_拍手",
    "path": "builtin/se/pix-studio/06_イベント会場の音/06_拍手/拍手短め.ogg",
    "size": 170948,
    "tags": [
      "イベント会場の音",
      "06_拍手"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/06_拍手/拍手短め２",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "拍手短め２",
    "description": "06_拍手",
    "path": "builtin/se/pix-studio/06_イベント会場の音/06_拍手/拍手短め２.ogg",
    "size": 106758,
    "tags": [
      "イベント会場の音",
      "06_拍手"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/06_拍手/拍手長め",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "拍手長め",
    "description": "06_拍手",
    "path": "builtin/se/pix-studio/06_イベント会場の音/06_拍手/拍手長め.ogg",
    "size": 627616,
    "tags": [
      "イベント会場の音",
      "06_拍手"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/06_拍手/万来の拍手",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "万来の拍手",
    "description": "06_拍手",
    "path": "builtin/se/pix-studio/06_イベント会場の音/06_拍手/万来の拍手.ogg",
    "size": 1024045,
    "tags": [
      "イベント会場の音",
      "06_拍手"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/イベント歓声１",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "イベント歓声１",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/イベント歓声１.ogg",
    "size": 230429,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/イベント歓声２",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "イベント歓声２",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/イベント歓声２.ogg",
    "size": 115536,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/おばちゃんガヤガヤ",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "おばちゃんガヤガヤ",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/おばちゃんガヤガヤ.ogg",
    "size": 218580,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/クラッカー１",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "クラッカー１",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/クラッカー１.ogg",
    "size": 15319,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/クラッカー２",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "クラッカー２",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/クラッカー２.ogg",
    "size": 13814,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/クラッカー３（連発）",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "クラッカー３（連発）",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/クラッカー３（連発）.ogg",
    "size": 62178,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/バザー会場歩く（九州）",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "バザー会場歩く（九州）",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/バザー会場歩く（九州）.ogg",
    "size": 712710,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/ヤフードーム花火",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "ヤフードーム花火",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/ヤフードーム花火.ogg",
    "size": 220573,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/宴会ざわざわ１",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "宴会ざわざわ１",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/宴会ざわざわ１.ogg",
    "size": 292508,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/宴会ざわざわ２",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "宴会ざわざわ２",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/宴会ざわざわ２.ogg",
    "size": 490949,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/夏祭り（九州）公民館内",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "夏祭り（九州）公民館内",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/夏祭り（九州）公民館内.ogg",
    "size": 533755,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/会場内ざわざわ",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "会場内ざわざわ",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/会場内ざわざわ.ogg",
    "size": 412762,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/開始ブザー１",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "開始ブザー１",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/開始ブザー１.ogg",
    "size": 388208,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/開始ブザー２",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "開始ブザー２",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/開始ブザー２.ogg",
    "size": 275127,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/試合（イベント）帰り道",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "試合（イベント）帰り道",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/試合（イベント）帰り道.ogg",
    "size": 1427586,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/親子連れの多い会場１",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "親子連れの多い会場１",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/親子連れの多い会場１.ogg",
    "size": 609487,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/親子連れの多い会場２",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "親子連れの多い会場２",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/親子連れの多い会場２.ogg",
    "size": 623097,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/親子連れの多い会場３",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "親子連れの多い会場３",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/親子連れの多い会場３.ogg",
    "size": 767137,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/待合室ざわざわ",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "待合室ざわざわ",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/待合室ざわざわ.ogg",
    "size": 352074,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/大きなお祭り会場１",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "大きなお祭り会場１",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/大きなお祭り会場１.ogg",
    "size": 1175504,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/町内の夏祭り（九州）１",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "町内の夏祭り（九州）１",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/町内の夏祭り（九州）１.ogg",
    "size": 1745449,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/町内の夏祭り（九州）２",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "町内の夏祭り（九州）２",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/町内の夏祭り（九州）２.ogg",
    "size": 1243856,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_イベント会場の音/万歳三唱",
    "pack": "pix-studio",
    "category": "pix-studio/イベント会場の音",
    "categoryLabel": "イベント会場の音",
    "name": "万歳三唱",
    "description": "",
    "path": "builtin/se/pix-studio/06_イベント会場の音/万歳三唱.ogg",
    "size": 195907,
    "tags": [
      "イベント会場の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/プロ野球/プロ野球歓声１",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "プロ野球歓声１",
    "description": "プロ野球",
    "path": "builtin/se/pix-studio/06_スポーツ/プロ野球/プロ野球歓声１.ogg",
    "size": 150620,
    "tags": [
      "スポーツ",
      "プロ野球"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/プロ野球/プロ野球歓声２",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "プロ野球歓声２",
    "description": "プロ野球",
    "path": "builtin/se/pix-studio/06_スポーツ/プロ野球/プロ野球歓声２.ogg",
    "size": 181925,
    "tags": [
      "スポーツ",
      "プロ野球"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/プロ野球/プロ野球場１",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "プロ野球場１",
    "description": "プロ野球",
    "path": "builtin/se/pix-studio/06_スポーツ/プロ野球/プロ野球場１.ogg",
    "size": 1242387,
    "tags": [
      "スポーツ",
      "プロ野球"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/プロ野球/プロ野球場２",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "プロ野球場２",
    "description": "プロ野球",
    "path": "builtin/se/pix-studio/06_スポーツ/プロ野球/プロ野球場２.ogg",
    "size": 1157262,
    "tags": [
      "スポーツ",
      "プロ野球"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/Sumou1",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "Sumou1",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/Sumou1.ogg",
    "size": 273212,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/Sumou2",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "Sumou2",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/Sumou2.ogg",
    "size": 633776,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/Sumou3",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "Sumou3",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/Sumou3.ogg",
    "size": 372522,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/Sumou4",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "Sumou4",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/Sumou4.ogg",
    "size": 777422,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/Sumou5",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "Sumou5",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/Sumou5.ogg",
    "size": 1452092,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/Sumou6",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "Sumou6",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/Sumou6.ogg",
    "size": 845752,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/Sumou7",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "Sumou7",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/Sumou7.ogg",
    "size": 950094,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/横綱戦（金星）１",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "横綱戦（金星）１",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/横綱戦（金星）１.ogg",
    "size": 1457592,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/横綱戦（結び）２",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "横綱戦（結び）２",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/横綱戦（結び）２.ogg",
    "size": 1311112,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/横綱土俵入り",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "横綱土俵入り",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/横綱土俵入り.ogg",
    "size": 1067657,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/弓取り式",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "弓取り式",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/弓取り式.ogg",
    "size": 626974,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/打ち木",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "打ち木",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/打ち木.ogg",
    "size": 1223203,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_スポーツ/大相撲/大関戦",
    "pack": "pix-studio",
    "category": "pix-studio/スポーツ",
    "categoryLabel": "スポーツ",
    "name": "大関戦",
    "description": "大相撲",
    "path": "builtin/se/pix-studio/06_スポーツ/大相撲/大関戦.ogg",
    "size": 1304043,
    "tags": [
      "スポーツ",
      "大相撲"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/花火観覧中２",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "花火観覧中２",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/花火観覧中２.ogg",
    "size": 819308,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/花火観覧中３（子供と）",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "花火観覧中３（子供と）",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/花火観覧中３（子供と）.ogg",
    "size": 1085263,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/花火大会１",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "花火大会１",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/花火大会１.ogg",
    "size": 4358401,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/花火大会２",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "花火大会２",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/花火大会２.ogg",
    "size": 1551557,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/花火大会スタート１（会場）",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "花火大会スタート１（会場）",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/花火大会スタート１（会場）.ogg",
    "size": 579756,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/手持ち花火１",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "手持ち花火１",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/手持ち花火１.ogg",
    "size": 243700,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/手持ち花火２",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "手持ち花火２",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/手持ち花火２.ogg",
    "size": 398590,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/打ち上げ花火１",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "打ち上げ花火１",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/打ち上げ花火１.ogg",
    "size": 122819,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_花火/打ち上げ花火２",
    "pack": "pix-studio",
    "category": "pix-studio/花火",
    "categoryLabel": "花火",
    "name": "打ち上げ花火２",
    "description": "",
    "path": "builtin/se/pix-studio/06_花火/打ち上げ花火２.ogg",
    "size": 84541,
    "tags": [
      "花火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_風船/風船が跳ねる",
    "pack": "pix-studio",
    "category": "pix-studio/風船",
    "categoryLabel": "風船",
    "name": "風船が跳ねる",
    "description": "",
    "path": "builtin/se/pix-studio/06_風船/風船が跳ねる.ogg",
    "size": 90078,
    "tags": [
      "風船"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_風船/風船を膨らます",
    "pack": "pix-studio",
    "category": "pix-studio/風船",
    "categoryLabel": "風船",
    "name": "風船を膨らます",
    "description": "",
    "path": "builtin/se/pix-studio/06_風船/風船を膨らます.ogg",
    "size": 131684,
    "tags": [
      "風船"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_風船/風船破裂（多い）２",
    "pack": "pix-studio",
    "category": "pix-studio/風船",
    "categoryLabel": "風船",
    "name": "風船破裂（多い）２",
    "description": "",
    "path": "builtin/se/pix-studio/06_風船/風船破裂（多い）２.ogg",
    "size": 83740,
    "tags": [
      "風船"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_風船/風船破裂１",
    "pack": "pix-studio",
    "category": "pix-studio/風船",
    "categoryLabel": "風船",
    "name": "風船破裂１",
    "description": "",
    "path": "builtin/se/pix-studio/06_風船/風船破裂１.ogg",
    "size": 13504,
    "tags": [
      "風船"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_風船/風船飛ばし",
    "pack": "pix-studio",
    "category": "pix-studio/風船",
    "categoryLabel": "風船",
    "name": "風船飛ばし",
    "description": "",
    "path": "builtin/se/pix-studio/06_風船/風船飛ばし.ogg",
    "size": 272858,
    "tags": [
      "風船"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_遊園地/slope_car_starting",
    "pack": "pix-studio",
    "category": "pix-studio/遊園地",
    "categoryLabel": "遊園地",
    "name": "slope_car_starting",
    "description": "",
    "path": "builtin/se/pix-studio/06_遊園地/slope_car_starting.ogg",
    "size": 58844,
    "tags": [
      "遊園地"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_遊園地/slope_car1",
    "pack": "pix-studio",
    "category": "pix-studio/遊園地",
    "categoryLabel": "遊園地",
    "name": "slope_car1",
    "description": "",
    "path": "builtin/se/pix-studio/06_遊園地/slope_car1.ogg",
    "size": 1052007,
    "tags": [
      "遊園地"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/06_遊園地/slope_car2",
    "pack": "pix-studio",
    "category": "pix-studio/遊園地",
    "categoryLabel": "遊園地",
    "name": "slope_car2",
    "description": "",
    "path": "builtin/se/pix-studio/06_遊園地/slope_car2.ogg",
    "size": 862495,
    "tags": [
      "遊園地"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_自販機/古い自販機の電源",
    "pack": "pix-studio",
    "category": "pix-studio/自販機",
    "categoryLabel": "自販機",
    "name": "古い自販機の電源",
    "description": "",
    "path": "builtin/se/pix-studio/07_自販機/古い自販機の電源.ogg",
    "size": 165722,
    "tags": [
      "自販機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_自販機/自販機から缶が出る",
    "pack": "pix-studio",
    "category": "pix-studio/自販機",
    "categoryLabel": "自販機",
    "name": "自販機から缶が出る",
    "description": "",
    "path": "builtin/se/pix-studio/07_自販機/自販機から缶が出る.ogg",
    "size": 59464,
    "tags": [
      "自販機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_自販機/自販機でジュース買う",
    "pack": "pix-studio",
    "category": "pix-studio/自販機",
    "categoryLabel": "自販機",
    "name": "自販機でジュース買う",
    "description": "",
    "path": "builtin/se/pix-studio/07_自販機/自販機でジュース買う.ogg",
    "size": 146163,
    "tags": [
      "自販機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_自販機/自販機に小銭入れる",
    "pack": "pix-studio",
    "category": "pix-studio/自販機",
    "categoryLabel": "自販機",
    "name": "自販機に小銭入れる",
    "description": "",
    "path": "builtin/se/pix-studio/07_自販機/自販機に小銭入れる.ogg",
    "size": 44140,
    "tags": [
      "自販機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/ガヤガヤ１（喫茶店）",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "ガヤガヤ１（喫茶店）",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/ガヤガヤ１（喫茶店）.ogg",
    "size": 587707,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/ゲーセン",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "ゲーセン",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/ゲーセン.ogg",
    "size": 874332,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/コンビニ１",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "コンビニ１",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/コンビニ１.ogg",
    "size": 1010113,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/コンビニの事務所内",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "コンビニの事務所内",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/コンビニの事務所内.ogg",
    "size": 1187155,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/コンビニ入店音",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "コンビニ入店音",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/コンビニ入店音.ogg",
    "size": 19537,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/シャッター開く２",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "シャッター開く２",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/シャッター開く２.ogg",
    "size": 71326,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/シャッター開く３",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "シャッター開く３",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/シャッター開く３.ogg",
    "size": 85558,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/シャッター開閉１",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "シャッター開閉１",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/シャッター開閉１.ogg",
    "size": 64631,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/ショッピングモール１",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "ショッピングモール１",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/ショッピングモール１.ogg",
    "size": 540644,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/スーパーのレジ",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "スーパーのレジ",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/スーパーのレジ.ogg",
    "size": 715953,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/ドアベル",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "ドアベル",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/ドアベル.ogg",
    "size": 86407,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/パチンコ屋",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "パチンコ屋",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/パチンコ屋.ogg",
    "size": 517168,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/レジスター",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "レジスター",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/レジスター.ogg",
    "size": 14548,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/喫茶店レジ",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "喫茶店レジ",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/喫茶店レジ.ogg",
    "size": 398229,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/自動ドア",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "自動ドア",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/自動ドア.ogg",
    "size": 32521,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/倉庫ドア開ける",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "倉庫ドア開ける",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/倉庫ドア開ける.ogg",
    "size": 48044,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/倉庫ドア閉める",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "倉庫ドア閉める",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/倉庫ドア閉める.ogg",
    "size": 37434,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/豆腐屋さん",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "豆腐屋さん",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/豆腐屋さん.ogg",
    "size": 154746,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/07_店/郵便局（役所・銀行付",
    "pack": "pix-studio",
    "category": "pix-studio/店",
    "categoryLabel": "店",
    "name": "郵便局（役所・銀行付",
    "description": "",
    "path": "builtin/se/pix-studio/07_店/郵便局（役所・銀行付.ogg",
    "size": 850155,
    "tags": [
      "店"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/下水溝で水が流れる",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "下水溝で水が流れる",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/下水溝で水が流れる.ogg",
    "size": 336892,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/工場内１",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "工場内１",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/工場内１.ogg",
    "size": 197818,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/高速ファンの傍",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "高速ファンの傍",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/高速ファンの傍.ogg",
    "size": 56480,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/大型機械の機関室",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "大型機械の機関室",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/大型機械の機関室.ogg",
    "size": 343101,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/大型排気口（空調）",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "大型排気口（空調）",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/大型排気口（空調）.ogg",
    "size": 276734,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/鉄製ドア開く",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "鉄製ドア開く",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/鉄製ドア開く.ogg",
    "size": 111636,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/鉄製ドア開く（ゆっくり）",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "鉄製ドア開く（ゆっくり）",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/鉄製ドア開く（ゆっくり）.ogg",
    "size": 34434,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/鉄製ドア閉（ゆっくり）",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "鉄製ドア閉（ゆっくり）",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/鉄製ドア閉（ゆっくり）.ogg",
    "size": 55526,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/排気口（食堂裏）",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "排気口（食堂裏）",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/排気口（食堂裏）.ogg",
    "size": 152926,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/08_工場/発電機か浄水機",
    "pack": "pix-studio",
    "category": "pix-studio/工場",
    "categoryLabel": "工場",
    "name": "発電機か浄水機",
    "description": "",
    "path": "builtin/se/pix-studio/08_工場/発電機か浄水機.ogg",
    "size": 182104,
    "tags": [
      "工場"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/09_寺・神社/お経１（浄土真宗）",
    "pack": "pix-studio",
    "category": "pix-studio/寺・神社",
    "categoryLabel": "寺・神社",
    "name": "お経１（浄土真宗）",
    "description": "",
    "path": "builtin/se/pix-studio/09_寺・神社/お経１（浄土真宗）.ogg",
    "size": 450862,
    "tags": [
      "寺・神社"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/09_寺・神社/お経２（浄土真宗）",
    "pack": "pix-studio",
    "category": "pix-studio/寺・神社",
    "categoryLabel": "寺・神社",
    "name": "お経２（浄土真宗）",
    "description": "",
    "path": "builtin/se/pix-studio/09_寺・神社/お経２（浄土真宗）.ogg",
    "size": 462123,
    "tags": [
      "寺・神社"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/09_寺・神社/お寺の鐘１",
    "pack": "pix-studio",
    "category": "pix-studio/寺・神社",
    "categoryLabel": "寺・神社",
    "name": "お寺の鐘１",
    "description": "",
    "path": "builtin/se/pix-studio/09_寺・神社/お寺の鐘１.ogg",
    "size": 246364,
    "tags": [
      "寺・神社"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/09_寺・神社/お賽銭入れる",
    "pack": "pix-studio",
    "category": "pix-studio/寺・神社",
    "categoryLabel": "寺・神社",
    "name": "お賽銭入れる",
    "description": "",
    "path": "builtin/se/pix-studio/09_寺・神社/お賽銭入れる.ogg",
    "size": 23482,
    "tags": [
      "寺・神社"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/ジェット機（速い）",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "ジェット機（速い）",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/ジェット機（速い）.ogg",
    "size": 214723,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/移動廊下",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "移動廊下",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/移動廊下.ogg",
    "size": 553353,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/機内放送（着陸前）",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "機内放送（着陸前）",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/機内放送（着陸前）.ogg",
    "size": 1537291,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/空港お土産売り場",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "空港お土産売り場",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/空港お土産売り場.ogg",
    "size": 612633,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/空港のカフェ",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "空港のカフェ",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/空港のカフェ.ogg",
    "size": 1286624,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/空港待合い室",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "空港待合い室",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/空港待合い室.ogg",
    "size": 2902509,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/国際線エコノミー席",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "国際線エコノミー席",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/国際線エコノミー席.ogg",
    "size": 1637052,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/国際線飛行機の中",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "国際線飛行機の中",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/国際線飛行機の中.ogg",
    "size": 1254234,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/小型飛行機",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "小型飛行機",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/小型飛行機.ogg",
    "size": 88983,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/上空をヘリが飛行",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "上空をヘリが飛行",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/上空をヘリが飛行.ogg",
    "size": 517209,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/地方空港搭乗口１",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "地方空港搭乗口１",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/地方空港搭乗口１.ogg",
    "size": 1106650,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/地方空港搭乗口２",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "地方空港搭乗口２",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/地方空港搭乗口２.ogg",
    "size": 1199909,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/飛行機が飛んでゆく１",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "飛行機が飛んでゆく１",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/飛行機が飛んでゆく１.ogg",
    "size": 286603,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/飛行機の中（飛ぶ前）",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "飛行機の中（飛ぶ前）",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/飛行機の中（飛ぶ前）.ogg",
    "size": 822585,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/飛行機の中（飛行中）",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "飛行機の中（飛行中）",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/飛行機の中（飛行中）.ogg",
    "size": 785116,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/飛行機激しく揺れる",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "飛行機激しく揺れる",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/飛行機激しく揺れる.ogg",
    "size": 2825636,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/飛行機墜落",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "飛行機墜落",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/飛行機墜落.ogg",
    "size": 279707,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/飛行機内のお知らせ",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "飛行機内のお知らせ",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/飛行機内のお知らせ.ogg",
    "size": 8901,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/10_空港・飛行機/飛行整備場１",
    "pack": "pix-studio",
    "category": "pix-studio/空港・飛行機",
    "categoryLabel": "空港・飛行機",
    "name": "飛行整備場１",
    "description": "",
    "path": "builtin/se/pix-studio/10_空港・飛行機/飛行整備場１.ogg",
    "size": 562260,
    "tags": [
      "空港・飛行機"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/工具箱をあさる",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "工具箱をあさる",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/工具箱をあさる.ogg",
    "size": 375016,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/工具箱開く",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "工具箱開く",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/工具箱開く.ogg",
    "size": 39229,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/工具箱閉める",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "工具箱閉める",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/工具箱閉める.ogg",
    "size": 41505,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/釘を打つ１（室内）",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "釘を打つ１（室内）",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/釘を打つ１（室内）.ogg",
    "size": 126463,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/釘を打つ２（室内）",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "釘を打つ２（室内）",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/釘を打つ２（室内）.ogg",
    "size": 160467,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/釘を打つ３（室内）",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "釘を打つ３（室内）",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/釘を打つ３（室内）.ogg",
    "size": 243719,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/釘を打つ４",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "釘を打つ４",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/釘を打つ４.ogg",
    "size": 35326,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/釘を打つ５",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "釘を打つ５",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/釘を打つ５.ogg",
    "size": 64043,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/鉄製の箱開ける",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "鉄製の箱開ける",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/鉄製の箱開ける.ogg",
    "size": 13955,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/鉄製の箱閉める",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "鉄製の箱閉める",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/鉄製の箱閉める.ogg",
    "size": 18210,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/電気回転カッター１",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "電気回転カッター１",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/電気回転カッター１.ogg",
    "size": 240661,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/電気回転カッター２",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "電気回転カッター２",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/電気回転カッター２.ogg",
    "size": 375138,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/電動ドリル",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "電動ドリル",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/電動ドリル.ogg",
    "size": 247112,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/電動ドリル１",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "電動ドリル１",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/電動ドリル１.ogg",
    "size": 253219,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/電動ドリル２",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "電動ドリル２",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/電動ドリル２.ogg",
    "size": 173993,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/電動釘打ち機１",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "電動釘打ち機１",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/電動釘打ち機１.ogg",
    "size": 15040,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工具/電動釘打ち機２（連続）",
    "pack": "pix-studio",
    "category": "pix-studio/工具",
    "categoryLabel": "工具",
    "name": "電動釘打ち機２（連続）",
    "description": "",
    "path": "builtin/se/pix-studio/11_工具/電動釘打ち機２（連続）.ogg",
    "size": 105822,
    "tags": [
      "工具"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/河川工事/キャタピラ（シャベル）",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "キャタピラ（シャベル）",
    "description": "河川工事",
    "path": "builtin/se/pix-studio/11_工事/河川工事/キャタピラ（シャベル）.ogg",
    "size": 426831,
    "tags": [
      "工事",
      "河川工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/河川工事/河川工事（砕岩）1",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "河川工事（砕岩）1",
    "description": "河川工事",
    "path": "builtin/se/pix-studio/11_工事/河川工事/河川工事（砕岩）1.ogg",
    "size": 932684,
    "tags": [
      "工事",
      "河川工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/河川工事/河川工事（砕岩）２",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "河川工事（砕岩）２",
    "description": "河川工事",
    "path": "builtin/se/pix-studio/11_工事/河川工事/河川工事（砕岩）２.ogg",
    "size": 1124185,
    "tags": [
      "工事",
      "河川工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/河川工事/小型船のエンジン音",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "小型船のエンジン音",
    "description": "河川工事",
    "path": "builtin/se/pix-studio/11_工事/河川工事/小型船のエンジン音.ogg",
    "size": 392996,
    "tags": [
      "工事",
      "河川工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/河川工事/土砂の工事現場１",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "土砂の工事現場１",
    "description": "河川工事",
    "path": "builtin/se/pix-studio/11_工事/河川工事/土砂の工事現場１.ogg",
    "size": 1936020,
    "tags": [
      "工事",
      "河川工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/河川工事/土砂の工事現場２",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "土砂の工事現場２",
    "description": "河川工事",
    "path": "builtin/se/pix-studio/11_工事/河川工事/土砂の工事現場２.ogg",
    "size": 1408730,
    "tags": [
      "工事",
      "河川工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/河川工事/土砂の工事現場３",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "土砂の工事現場３",
    "description": "河川工事",
    "path": "builtin/se/pix-studio/11_工事/河川工事/土砂の工事現場３.ogg",
    "size": 1636858,
    "tags": [
      "工事",
      "河川工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/シャベルカーの動作",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "シャベルカーの動作",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/シャベルカーの動作.ogg",
    "size": 638807,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/シャベルの動作音",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "シャベルの動作音",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/シャベルの動作音.ogg",
    "size": 875888,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/チェーンソー",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "チェーンソー",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/チェーンソー.ogg",
    "size": 117631,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/何かの工事１",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "何かの工事１",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/何かの工事１.ogg",
    "size": 490118,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/何かの工事２（長）",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "何かの工事２（長）",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/何かの工事２（長）.ogg",
    "size": 2385875,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/工事のドリル",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "工事のドリル",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/工事のドリル.ogg",
    "size": 547481,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/廃屋の解体１",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "廃屋の解体１",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/廃屋の解体１.ogg",
    "size": 1021635,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/廃屋の解体２",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "廃屋の解体２",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/廃屋の解体２.ogg",
    "size": 1047855,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/廃屋の解体３",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "廃屋の解体３",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/廃屋の解体３.ogg",
    "size": 468138,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/解体/廃屋の解体４",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "廃屋の解体４",
    "description": "解体",
    "path": "builtin/se/pix-studio/11_工事/解体/廃屋の解体４.ogg",
    "size": 722106,
    "tags": [
      "工事",
      "解体"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/アスファルト工事２",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "アスファルト工事２",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/アスファルト工事２.ogg",
    "size": 203456,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/アスファルト工事３",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "アスファルト工事３",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/アスファルト工事３.ogg",
    "size": 527890,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/リフォーム工事１",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "リフォーム工事１",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/リフォーム工事１.ogg",
    "size": 250862,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/リフォーム工事２",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "リフォーム工事２",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/リフォーム工事２.ogg",
    "size": 858921,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/夏の建築・改装現場",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "夏の建築・改装現場",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/夏の建築・改装現場.ogg",
    "size": 338773,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/家の改築",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "家の改築",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/家の改築.ogg",
    "size": 1322429,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/家の建築",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "家の建築",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/家の建築.ogg",
    "size": 528387,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/工事現場１",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "工事現場１",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/工事現場１.ogg",
    "size": 512240,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/11_工事/建築工事/道路工事１",
    "pack": "pix-studio",
    "category": "pix-studio/工事",
    "categoryLabel": "工事",
    "name": "道路工事１",
    "description": "建築工事",
    "path": "builtin/se/pix-studio/11_工事/建築工事/道路工事１.ogg",
    "size": 1112230,
    "tags": [
      "工事",
      "建築工事"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/クマゼミ（裏通り）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "クマゼミ（裏通り）",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/クマゼミ（裏通り）.ogg",
    "size": 1193448,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/コオロギ",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "コオロギ",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/コオロギ.ogg",
    "size": 1147744,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/陰鬱な雨",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "陰鬱な雨",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/陰鬱な雨.ogg",
    "size": 916720,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/雨と車",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "雨と車",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/雨と車.ogg",
    "size": 360963,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/軒先の雨",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "軒先の雨",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/軒先の雨.ogg",
    "size": 603251,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/軒先の雨（静か）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "軒先の雨（静か）",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/軒先の雨（静か）.ogg",
    "size": 546533,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/小雨と雷１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "小雨と雷１",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/小雨と雷１.ogg",
    "size": 874301,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/小雨と雷２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "小雨と雷２",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/小雨と雷２.ogg",
    "size": 1060203,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/窓から雨を眺める",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "窓から雨を眺める",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/窓から雨を眺める.ogg",
    "size": 1416130,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/窓に雨風当たる（長）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "窓に雨風当たる（長）",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/窓に雨風当たる（長）.ogg",
    "size": 1899395,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/窓に雨風当たる１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "窓に雨風当たる１",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/窓に雨風当たる１.ogg",
    "size": 1015914,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/窓に雨風当たる２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "窓に雨風当たる２",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/窓に雨風当たる２.ogg",
    "size": 997636,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/窓に雨風当たる３",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "窓に雨風当たる３",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/窓に雨風当たる３.ogg",
    "size": 507270,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/窓に雨風当たる４",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "窓に雨風当たる４",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/窓に雨風当たる４.ogg",
    "size": 1050294,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/窓に強風当たる",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "窓に強風当たる",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/窓に強風当たる.ogg",
    "size": 830644,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/大雨・滝",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "大雨・滝",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/大雨・滝.ogg",
    "size": 221470,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/中雨",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "中雨",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/中雨.ogg",
    "size": 137124,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/中雨（車通）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "中雨（車通）",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/中雨（車通）.ogg",
    "size": 715835,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/嵐の到来（雨）１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "嵐の到来（雨）１",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/嵐の到来（雨）１.ogg",
    "size": 427262,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雨/嵐の到来（雨）２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "嵐の到来（雨）２",
    "description": "雨",
    "path": "builtin/se/pix-studio/12_自然の音/雨/嵐の到来（雨）２.ogg",
    "size": 588023,
    "tags": [
      "自然の音",
      "雨"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/火/炎３",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "炎３",
    "description": "火",
    "path": "builtin/se/pix-studio/12_自然の音/火/炎３.ogg",
    "size": 39526,
    "tags": [
      "自然の音",
      "火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/火/炎４",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "炎４",
    "description": "火",
    "path": "builtin/se/pix-studio/12_自然の音/火/炎４.ogg",
    "size": 46616,
    "tags": [
      "自然の音",
      "火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/火/火・炎１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "火・炎１",
    "description": "火",
    "path": "builtin/se/pix-studio/12_自然の音/火/火・炎１.ogg",
    "size": 79623,
    "tags": [
      "自然の音",
      "火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/火/火・炎２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "火・炎２",
    "description": "火",
    "path": "builtin/se/pix-studio/12_自然の音/火/火・炎２.ogg",
    "size": 60394,
    "tags": [
      "自然の音",
      "火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/火/火事パチパチ１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "火事パチパチ１",
    "description": "火",
    "path": "builtin/se/pix-studio/12_自然の音/火/火事パチパチ１.ogg",
    "size": 581872,
    "tags": [
      "自然の音",
      "火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/火/業火",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "業火",
    "description": "火",
    "path": "builtin/se/pix-studio/12_自然の音/火/業火.ogg",
    "size": 203054,
    "tags": [
      "自然の音",
      "火"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/海/夏の海岸１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の海岸１",
    "description": "海",
    "path": "builtin/se/pix-studio/12_自然の音/海/夏の海岸１.ogg",
    "size": 1073495,
    "tags": [
      "自然の音",
      "海"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/海/夏の海岸２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の海岸２",
    "description": "海",
    "path": "builtin/se/pix-studio/12_自然の音/海/夏の海岸２.ogg",
    "size": 452466,
    "tags": [
      "自然の音",
      "海"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/海/海水浴場１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "海水浴場１",
    "description": "海",
    "path": "builtin/se/pix-studio/12_自然の音/海/海水浴場１.ogg",
    "size": 506043,
    "tags": [
      "自然の音",
      "海"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/海/海水浴場２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "海水浴場２",
    "description": "海",
    "path": "builtin/se/pix-studio/12_自然の音/海/海水浴場２.ogg",
    "size": 428059,
    "tags": [
      "自然の音",
      "海"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/海/小波・砂浜",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "小波・砂浜",
    "description": "海",
    "path": "builtin/se/pix-studio/12_自然の音/海/小波・砂浜.ogg",
    "size": 149740,
    "tags": [
      "自然の音",
      "海"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/蛙",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "蛙",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/蛙.ogg",
    "size": 176036,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/蛙（長め）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "蛙（長め）",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/蛙（長め）.ogg",
    "size": 547363,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/蛙一匹",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "蛙一匹",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/蛙一匹.ogg",
    "size": 31575,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/夏の山（つくつくほうし）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の山（つくつくほうし）",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/夏の山（つくつくほうし）.ogg",
    "size": 371037,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/夏の山の中",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の山の中",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/夏の山の中.ogg",
    "size": 1211345,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/夏の山中３",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の山中３",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/夏の山中３.ogg",
    "size": 1843127,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/夏の山中４（セミ）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の山中４（セミ）",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/夏の山中４（セミ）.ogg",
    "size": 761753,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/夏の山頂の草原１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の山頂の草原１",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/夏の山頂の草原１.ogg",
    "size": 773460,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/夏の山頂の草原２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の山頂の草原２",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/夏の山頂の草原２.ogg",
    "size": 471088,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/夏の山頂の草原３",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の山頂の草原３",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/夏の山頂の草原３.ogg",
    "size": 861975,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/夏の沢の流れ",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夏の沢の流れ",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/夏の沢の流れ.ogg",
    "size": 952960,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/山の湧き水（短）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "山の湧き水（短）",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/山の湧き水（短）.ogg",
    "size": 1607261,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/山の湧き水（長）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "山の湧き水（長）",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/山の湧き水（長）.ogg",
    "size": 3228876,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/山/子供の沢遊び",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "子供の沢遊び",
    "description": "山",
    "path": "builtin/se/pix-studio/12_自然の音/山/子供の沢遊び.ogg",
    "size": 531893,
    "tags": [
      "自然の音",
      "山"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/枝を折る１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "枝を折る１",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/枝を折る１.ogg",
    "size": 15455,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/枝を折る２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "枝を折る２",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/枝を折る２.ogg",
    "size": 46474,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/秋の川辺の明け方（朝）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "秋の川辺の明け方（朝）",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/秋の川辺の明け方（朝）.ogg",
    "size": 807607,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/秋の夜の川辺１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "秋の夜の川辺１",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/秋の夜の川辺１.ogg",
    "size": 707380,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/秋の夜の川辺２（長）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "秋の夜の川辺２（長）",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/秋の夜の川辺２（長）.ogg",
    "size": 1978450,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/初秋の虫の音１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "初秋の虫の音１",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/初秋の虫の音１.ogg",
    "size": 1748023,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/初秋の虫の音２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "初秋の虫の音２",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/初秋の虫の音２.ogg",
    "size": 1030980,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/初秋の虫の音３",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "初秋の虫の音３",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/初秋の虫の音３.ogg",
    "size": 1729926,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/初秋の虫の音４",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "初秋の虫の音４",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/初秋の虫の音４.ogg",
    "size": 2118960,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/初秋の虫の音５",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "初秋の虫の音５",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/初秋の虫の音５.ogg",
    "size": 935121,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/鍾乳洞１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "鍾乳洞１",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/鍾乳洞１.ogg",
    "size": 791921,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/鍾乳洞２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "鍾乳洞２",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/鍾乳洞２.ogg",
    "size": 1018664,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/水に潜る",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "水に潜る",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/水に潜る.ogg",
    "size": 41692,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/川/小川・湧き水",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "小川・湧き水",
    "description": "川",
    "path": "builtin/se/pix-studio/12_自然の音/川/小川・湧き水.ogg",
    "size": 242123,
    "tags": [
      "自然の音",
      "川"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/川/小川の流れ（直近）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "小川の流れ（直近）",
    "description": "川",
    "path": "builtin/se/pix-studio/12_自然の音/川/小川の流れ（直近）.ogg",
    "size": 1592778,
    "tags": [
      "自然の音",
      "川"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/川/小川の流れ１a",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "小川の流れ１a",
    "description": "川",
    "path": "builtin/se/pix-studio/12_自然の音/川/小川の流れ１a.ogg",
    "size": 840855,
    "tags": [
      "自然の音",
      "川"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/川/小川の流れ１b（長）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "小川の流れ１b（長）",
    "description": "川",
    "path": "builtin/se/pix-studio/12_自然の音/川/小川の流れ１b（長）.ogg",
    "size": 4186589,
    "tags": [
      "自然の音",
      "川"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/川/増水河川",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "増水河川",
    "description": "川",
    "path": "builtin/se/pix-studio/12_自然の音/川/増水河川.ogg",
    "size": 939289,
    "tags": [
      "自然の音",
      "川"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/川/洞窟の中の川",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "洞窟の中の川",
    "description": "川",
    "path": "builtin/se/pix-studio/12_自然の音/川/洞窟の中の川.ogg",
    "size": 225641,
    "tags": [
      "自然の音",
      "川"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/地鳴り",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "地鳴り",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/地鳴り.ogg",
    "size": 156508,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/土砂",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "土砂",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/土砂.ogg",
    "size": 64939,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/氷カラン１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "氷カラン１",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/氷カラン１.ogg",
    "size": 17445,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/氷カラン２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "氷カラン２",
    "description": "",
    "path": "builtin/se/pix-studio/12_自然の音/氷カラン２.ogg",
    "size": 14171,
    "tags": [
      "自然の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/風/すきま風",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "すきま風",
    "description": "風",
    "path": "builtin/se/pix-studio/12_自然の音/風/すきま風.ogg",
    "size": 183361,
    "tags": [
      "自然の音",
      "風"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/風/強い風１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "強い風１",
    "description": "風",
    "path": "builtin/se/pix-studio/12_自然の音/風/強い風１.ogg",
    "size": 394920,
    "tags": [
      "自然の音",
      "風"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/風/強い風２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "強い風２",
    "description": "風",
    "path": "builtin/se/pix-studio/12_自然の音/風/強い風２.ogg",
    "size": 139375,
    "tags": [
      "自然の音",
      "風"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/風/風の大地（吹雪）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "風の大地（吹雪）",
    "description": "風",
    "path": "builtin/se/pix-studio/12_自然の音/風/風の大地（吹雪）.ogg",
    "size": 327152,
    "tags": [
      "自然の音",
      "風"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/風/夜の風",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "夜の風",
    "description": "風",
    "path": "builtin/se/pix-studio/12_自然の音/風/夜の風.ogg",
    "size": 428350,
    "tags": [
      "自然の音",
      "風"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/風/嵐の到来（風のみ・短）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "嵐の到来（風のみ・短）",
    "description": "風",
    "path": "builtin/se/pix-studio/12_自然の音/風/嵐の到来（風のみ・短）.ogg",
    "size": 543363,
    "tags": [
      "自然の音",
      "風"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/風/嵐の到来（風のみ・長）",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "嵐の到来（風のみ・長）",
    "description": "風",
    "path": "builtin/se/pix-studio/12_自然の音/風/嵐の到来（風のみ・長）.ogg",
    "size": 1672670,
    "tags": [
      "自然の音",
      "風"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雷/稲妻（近距離）１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "稲妻（近距離）１",
    "description": "雷",
    "path": "builtin/se/pix-studio/12_自然の音/雷/稲妻（近距離）１.ogg",
    "size": 504302,
    "tags": [
      "自然の音",
      "雷"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雷/稲妻（近距離）２",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "稲妻（近距離）２",
    "description": "雷",
    "path": "builtin/se/pix-studio/12_自然の音/雷/稲妻（近距離）２.ogg",
    "size": 166099,
    "tags": [
      "自然の音",
      "雷"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雷/稲妻（近距離）３",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "稲妻（近距離）３",
    "description": "雷",
    "path": "builtin/se/pix-studio/12_自然の音/雷/稲妻（近距離）３.ogg",
    "size": 366249,
    "tags": [
      "自然の音",
      "雷"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_自然の音/雷/雷１",
    "pack": "pix-studio",
    "category": "pix-studio/自然の音",
    "categoryLabel": "自然の音",
    "name": "雷１",
    "description": "雷",
    "path": "builtin/se/pix-studio/12_自然の音/雷/雷１.ogg",
    "size": 361303,
    "tags": [
      "自然の音",
      "雷"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_天気/rain",
    "pack": "pix-studio",
    "category": "pix-studio/天気",
    "categoryLabel": "天気",
    "name": "rain",
    "description": "",
    "path": "builtin/se/pix-studio/12_天気/rain.ogg",
    "size": 101263,
    "tags": [
      "天気"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_天気/thunder",
    "pack": "pix-studio",
    "category": "pix-studio/天気",
    "categoryLabel": "天気",
    "name": "thunder",
    "description": "",
    "path": "builtin/se/pix-studio/12_天気/thunder.ogg",
    "size": 62083,
    "tags": [
      "天気"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/12_天気/wind",
    "pack": "pix-studio",
    "category": "pix-studio/天気",
    "categoryLabel": "天気",
    "name": "wind",
    "description": "",
    "path": "builtin/se/pix-studio/12_天気/wind.ogg",
    "size": 71644,
    "tags": [
      "天気"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/ただの車道１",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "ただの車道１",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/ただの車道１.ogg",
    "size": 1259104,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/雨と車",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "雨と車",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/雨と車.ogg",
    "size": 360963,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/夏の車道",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "夏の車道",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/夏の車道.ogg",
    "size": 522211,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/夏の車道（クマゼミ）",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "夏の車道（クマゼミ）",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/夏の車道（クマゼミ）.ogg",
    "size": 1224491,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/夏の車道（つくつくほーし）",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "夏の車道（つくつくほーし）",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/夏の車道（つくつくほーし）.ogg",
    "size": 1516649,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/夏の都会",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "夏の都会",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/夏の都会.ogg",
    "size": 2407266,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/夏の歩道",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "夏の歩道",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/夏の歩道.ogg",
    "size": 583172,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/街の裏路地（車通過）",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "街の裏路地（車通過）",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/街の裏路地（車通過）.ogg",
    "size": 481996,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/港１",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "港１",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/港１.ogg",
    "size": 470342,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/秋の車道１",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "秋の車道１",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/秋の車道１.ogg",
    "size": 1268331,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/朝の雑踏",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "朝の雑踏",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/朝の雑踏.ogg",
    "size": 1006635,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/都会の交差点（夕方）",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "都会の交差点（夕方）",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/都会の交差点（夕方）.ogg",
    "size": 2679247,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/都会の昼",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "都会の昼",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/都会の昼.ogg",
    "size": 837539,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/都会の昼間の車道",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "都会の昼間の車道",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/都会の昼間の車道.ogg",
    "size": 731266,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/都会の朝",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "都会の朝",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/都会の朝.ogg",
    "size": 242681,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/波止場（港の荷卸し場）",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "波止場（港の荷卸し場）",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/波止場（港の荷卸し場）.ogg",
    "size": 934563,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_屋外の環境音/夜の繁華街を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/屋外の環境音",
    "categoryLabel": "屋外の環境音",
    "name": "夜の繁華街を歩く",
    "description": "",
    "path": "builtin/se/pix-studio/13_屋外の環境音/夜の繁華街を歩く.ogg",
    "size": 595903,
    "tags": [
      "屋外の環境音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/radio1",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "radio1",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/radio1.ogg",
    "size": 39271,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/radio2",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "radio2",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/radio2.ogg",
    "size": 37386,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/radio3",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "radio3",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/radio3.ogg",
    "size": 37903,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/radio4",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "radio4",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/radio4.ogg",
    "size": 35734,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/テレビ１",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "テレビ１",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/テレビ１.ogg",
    "size": 36343,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/テレビ２",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "テレビ２",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/テレビ２.ogg",
    "size": 48169,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/テレビ３",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "テレビ３",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/テレビ３.ogg",
    "size": 37450,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/テレビ４",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "テレビ４",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/テレビ４.ogg",
    "size": 38526,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/プツプツ１",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "プツプツ１",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/プツプツ１.ogg",
    "size": 58887,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/プツプツ２",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "プツプツ２",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/プツプツ２.ogg",
    "size": 42263,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/プツプツ３",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "プツプツ３",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/プツプツ３.ogg",
    "size": 43079,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/プツプツジジジ",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "プツプツジジジ",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/プツプツジジジ.ogg",
    "size": 41654,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/環境１",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "環境１",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/環境１.ogg",
    "size": 38795,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/環境２",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "環境２",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/環境２.ogg",
    "size": 34207,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/環境３",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "環境３",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/環境３.ogg",
    "size": 37903,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/環境４",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "環境４",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/環境４.ogg",
    "size": 37256,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/環境５",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "環境５",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/環境５.ogg",
    "size": 35750,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/環境６",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "環境６",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/環境６.ogg",
    "size": 34715,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/基本的なサー１",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "基本的なサー１",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/基本的なサー１.ogg",
    "size": 51247,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/基本的なサー２",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "基本的なサー２",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/基本的なサー２.ogg",
    "size": 50993,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/空調１",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "空調１",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/空調１.ogg",
    "size": 76782,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/空調２",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "空調２",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/空調２.ogg",
    "size": 50619,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/大気１",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "大気１",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/大気１.ogg",
    "size": 36967,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/大気２",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "大気２",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/大気２.ogg",
    "size": 37028,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/大気３",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "大気３",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/大気３.ogg",
    "size": 36268,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/大気４",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "大気４",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/大気４.ogg",
    "size": 34390,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/冷蔵庫１",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "冷蔵庫１",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/冷蔵庫１.ogg",
    "size": 66011,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/冷蔵庫２",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "冷蔵庫２",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/冷蔵庫２.ogg",
    "size": 62350,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/13_環境音ノイズ/冷蔵庫３",
    "pack": "pix-studio",
    "category": "pix-studio/環境音ノイズ",
    "categoryLabel": "環境音ノイズ",
    "name": "冷蔵庫３",
    "description": "",
    "path": "builtin/se/pix-studio/13_環境音ノイズ/冷蔵庫３.ogg",
    "size": 82569,
    "tags": [
      "環境音ノイズ"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ギター",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ギター",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ギター.ogg",
    "size": 118890,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/キラキラ星",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "キラキラ星",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/キラキラ星.ogg",
    "size": 422961,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ピアノ高音シ",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ピアノ高音シ",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ピアノ高音シ.ogg",
    "size": 53588,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ピアノ高音ソ",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ピアノ高音ソ",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ピアノ高音ソ.ogg",
    "size": 51876,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ピアノ高音ド",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ピアノ高音ド",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ピアノ高音ド.ogg",
    "size": 53659,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ピアノ高音ド＋",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ピアノ高音ド＋",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ピアノ高音ド＋.ogg",
    "size": 49771,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ピアノ高音ファ",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ピアノ高音ファ",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ピアノ高音ファ.ogg",
    "size": 52505,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ピアノ高音ミ",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ピアノ高音ミ",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ピアノ高音ミ.ogg",
    "size": 54185,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ピアノ高音ラ",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ピアノ高音ラ",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ピアノ高音ラ.ogg",
    "size": 51484,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/ピアノ高音レ",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "ピアノ高音レ",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/ピアノ高音レ.ogg",
    "size": 54515,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/小太鼓",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "小太鼓",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/小太鼓.ogg",
    "size": 17209,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/太鼓１",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "太鼓１",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/太鼓１.ogg",
    "size": 34066,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/太鼓２（開始の合図）",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "太鼓２（開始の合図）",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/太鼓２（開始の合図）.ogg",
    "size": 73056,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/太鼓の拍子",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "太鼓の拍子",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/太鼓の拍子.ogg",
    "size": 307028,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/大太鼓",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "大太鼓",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/大太鼓.ogg",
    "size": 35076,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/和太鼓風１",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "和太鼓風１",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/和太鼓風１.ogg",
    "size": 24418,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/14_楽器音/和太鼓風２（開始の合図）",
    "pack": "pix-studio",
    "category": "pix-studio/楽器音",
    "categoryLabel": "楽器音",
    "name": "和太鼓風２（開始の合図）",
    "description": "",
    "path": "builtin/se/pix-studio/14_楽器音/和太鼓風２（開始の合図）.ogg",
    "size": 75693,
    "tags": [
      "楽器音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/ウーワンワン！ウワン！a",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "ウーワンワン！ウワン！a",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/ウーワンワン！ウワン！a.ogg",
    "size": 38393,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/カイツブリの喧嘩",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "カイツブリの喧嘩",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/カイツブリの喧嘩.ogg",
    "size": 123770,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/カラス１",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "カラス１",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/カラス１.ogg",
    "size": 55174,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/カラス２",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "カラス２",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/カラス２.ogg",
    "size": 34528,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/カラスa",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "カラスa",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/カラスa.ogg",
    "size": 6393,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/カラスb",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "カラスb",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/カラスb.ogg",
    "size": 6390,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/カラスがカア",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "カラスがカア",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/カラスがカア.ogg",
    "size": 32367,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/カラスの大群",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "カラスの大群",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/カラスの大群.ogg",
    "size": 249008,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/サギ（鷺）の鳴き声",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "サギ（鷺）の鳴き声",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/サギ（鷺）の鳴き声.ogg",
    "size": 18127,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/サギ（鷺）の鳴き声２",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "サギ（鷺）の鳴き声２",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/サギ（鷺）の鳴き声２.ogg",
    "size": 14442,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/ヒヨコがたくさん",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "ヒヨコがたくさん",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/ヒヨコがたくさん.ogg",
    "size": 94154,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/ヒヨコっぽい",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "ヒヨコっぽい",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/ヒヨコっぽい.ogg",
    "size": 15057,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/ふくろう",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "ふくろう",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/ふくろう.ogg",
    "size": 60629,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/ワン！b",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "ワン！b",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/ワン！b.ogg",
    "size": 12475,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/ワンワン！a",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "ワンワン！a",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/ワンワン！a.ogg",
    "size": 18375,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/ワンワンワン！a",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "ワンワンワン！a",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/ワンワンワン！a.ogg",
    "size": 27012,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/ワンワンワンワン！b",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "ワンワンワンワン！b",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/ワンワンワンワン！b.ogg",
    "size": 19576,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/羽ばたき１",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "羽ばたき１",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/羽ばたき１.ogg",
    "size": 30930,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/鴨の警戒鳴き声",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "鴨の警戒鳴き声",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/鴨の警戒鳴き声.ogg",
    "size": 33443,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/鶏（コケコケ）",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "鶏（コケコケ）",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/鶏（コケコケ）.ogg",
    "size": 29613,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/犬がやたら吠えてる",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "犬がやたら吠えてる",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/犬がやたら吠えてる.ogg",
    "size": 572476,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/犬が何か喋っている",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "犬が何か喋っている",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/犬が何か喋っている.ogg",
    "size": 72861,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/犬の遠吠え",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "犬の遠吠え",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/犬の遠吠え.ogg",
    "size": 68751,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/犬の警戒鳴き声",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "犬の警戒鳴き声",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/犬の警戒鳴き声.ogg",
    "size": 241004,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/蛇（シュー）",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "蛇（シュー）",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/蛇（シュー）.ogg",
    "size": 41360,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/小型犬（室内）",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "小型犬（室内）",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/小型犬（室内）.ogg",
    "size": 59614,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/小犬に吼えられる",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "小犬に吼えられる",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/小犬に吼えられる.ogg",
    "size": 88528,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/川沿いの小鳥",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "川沿いの小鳥",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/川沿いの小鳥.ogg",
    "size": 57509,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/朝のスズメ",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "朝のスズメ",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/朝のスズメ.ogg",
    "size": 195558,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/南の島の鳥１",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "南の島の鳥１",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/南の島の鳥１.ogg",
    "size": 20911,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/南の島の鳥２",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "南の島の鳥２",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/南の島の鳥２.ogg",
    "size": 13809,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/南の島の鳥３",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "南の島の鳥３",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/南の島の鳥３.ogg",
    "size": 17615,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/猫（とても悲しげに）４",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "猫（とても悲しげに）４",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/猫（とても悲しげに）４.ogg",
    "size": 370705,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/猫（ねえ～）３a",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "猫（ねえ～）３a",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/猫（ねえ～）３a.ogg",
    "size": 30233,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/猫（ねえ～）３b",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "猫（ねえ～）３b",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/猫（ねえ～）３b.ogg",
    "size": 22376,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/猫（遊んで～）２",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "猫（遊んで～）２",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/猫（遊んで～）２.ogg",
    "size": 58521,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/猫がニャーン１a",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "猫がニャーン１a",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/猫がニャーン１a.ogg",
    "size": 25925,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/猫がニャーン１b",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "猫がニャーン１b",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/猫がニャーン１b.ogg",
    "size": 20830,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/猫の喧嘩１",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "猫の喧嘩１",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/猫の喧嘩１.ogg",
    "size": 1004921,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/猫科が喉を鳴らす",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "猫科が喉を鳴らす",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/猫科が喉を鳴らす.ogg",
    "size": 89235,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/馬（ヒヒーン）",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "馬（ヒヒーン）",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/馬（ヒヒーン）.ogg",
    "size": 18212,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/羊（メ～）",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "羊（メ～）",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/羊（メ～）.ogg",
    "size": 10990,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/15_動物/狼たちの遠吠え",
    "pack": "pix-studio",
    "category": "pix-studio/動物",
    "categoryLabel": "動物",
    "name": "狼たちの遠吠え",
    "description": "",
    "path": "builtin/se/pix-studio/15_動物/狼たちの遠吠え.ogg",
    "size": 48209,
    "tags": [
      "動物"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/アメリカAMラジオ合せる",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "アメリカAMラジオ合せる",
    "description": "",
    "path": "builtin/se/pix-studio/16_海外の音/アメリカAMラジオ合せる.ogg",
    "size": 52627,
    "tags": [
      "海外の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/アメリカFMラジオ合せる",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "アメリカFMラジオ合せる",
    "description": "",
    "path": "builtin/se/pix-studio/16_海外の音/アメリカFMラジオ合せる.ogg",
    "size": 150450,
    "tags": [
      "海外の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/サイレン/ホテル14階から１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "ホテル14階から１",
    "description": "サイレン",
    "path": "builtin/se/pix-studio/16_海外の音/サイレン/ホテル14階から１.ogg",
    "size": 1995435,
    "tags": [
      "海外の音",
      "サイレン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/サイレン/ホテル14階から２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "ホテル14階から２",
    "description": "サイレン",
    "path": "builtin/se/pix-studio/16_海外の音/サイレン/ホテル14階から２.ogg",
    "size": 1302480,
    "tags": [
      "海外の音",
      "サイレン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/サイレン/救急（警察？）車通過２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "救急（警察？）車通過２",
    "description": "サイレン",
    "path": "builtin/se/pix-studio/16_海外の音/サイレン/救急（警察？）車通過２.ogg",
    "size": 2639191,
    "tags": [
      "海外の音",
      "サイレン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/サイレン/救急車通過１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "救急車通過１",
    "description": "サイレン",
    "path": "builtin/se/pix-studio/16_海外の音/サイレン/救急車通過１.ogg",
    "size": 879935,
    "tags": [
      "海外の音",
      "サイレン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/サイレン/緊急事態の夜１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "緊急事態の夜１",
    "description": "サイレン",
    "path": "builtin/se/pix-studio/16_海外の音/サイレン/緊急事態の夜１.ogg",
    "size": 824414,
    "tags": [
      "海外の音",
      "サイレン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/サイレン/緊急事態の夜２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "緊急事態の夜２",
    "description": "サイレン",
    "path": "builtin/se/pix-studio/16_海外の音/サイレン/緊急事態の夜２.ogg",
    "size": 833584,
    "tags": [
      "海外の音",
      "サイレン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/サイレン/消防車通過",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "消防車通過",
    "description": "サイレン",
    "path": "builtin/se/pix-studio/16_海外の音/サイレン/消防車通過.ogg",
    "size": 510661,
    "tags": [
      "海外の音",
      "サイレン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/エレベータに乗る",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "エレベータに乗る",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/エレベータに乗る.ogg",
    "size": 483830,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/キーロック解除",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "キーロック解除",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/キーロック解除.ogg",
    "size": 31443,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/ドアを音を立てて閉める",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "ドアを音を立てて閉める",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/ドアを音を立てて閉める.ogg",
    "size": 21403,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/トイレ流す",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "トイレ流す",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/トイレ流す.ogg",
    "size": 103895,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/外からホテルに入る",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "外からホテルに入る",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/外からホテルに入る.ogg",
    "size": 1149829,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/古い暖房１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "古い暖房１",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/古い暖房１.ogg",
    "size": 125921,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/古い暖房２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "古い暖房２",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/古い暖房２.ogg",
    "size": 293013,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/厚手のシャワーカーテン",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "厚手のシャワーカーテン",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/厚手のシャワーカーテン.ogg",
    "size": 43366,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/混雑してるロビー１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "混雑してるロビー１",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/混雑してるロビー１.ogg",
    "size": 1373803,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/混雑してるロビー２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "混雑してるロビー２",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/混雑してるロビー２.ogg",
    "size": 1976978,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/洗面所で水を出す",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "洗面所で水を出す",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/洗面所で水を出す.ogg",
    "size": 155120,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/卓上ライト回転スイッチ１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "卓上ライト回転スイッチ１",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/卓上ライト回転スイッチ１.ogg",
    "size": 8975,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/卓上ライト回転スイッチ２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "卓上ライト回転スイッチ２",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/卓上ライト回転スイッチ２.ogg",
    "size": 11925,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/部屋から廊下に出る",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "部屋から廊下に出る",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/部屋から廊下に出る.ogg",
    "size": 193742,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/洋風机の引き出し開１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "洋風机の引き出し開１",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/洋風机の引き出し開１.ogg",
    "size": 24433,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/洋風机の引き出し開２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "洋風机の引き出し開２",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/洋風机の引き出し開２.ogg",
    "size": 21920,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/洋風机の引き出し閉１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "洋風机の引き出し閉１",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/洋風机の引き出し閉１.ogg",
    "size": 35934,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/洋風机の引き出し閉２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "洋風机の引き出し閉２",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/洋風机の引き出し閉２.ogg",
    "size": 45453,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/浴槽照明スイッチ消す",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "浴槽照明スイッチ消す",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/浴槽照明スイッチ消す.ogg",
    "size": 10788,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/浴槽照明スイッチ付ける",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "浴槽照明スイッチ付ける",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/浴槽照明スイッチ付ける.ogg",
    "size": 9691,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/ホテル/廊下から部屋に入る",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "廊下から部屋に入る",
    "description": "ホテル",
    "path": "builtin/se/pix-studio/16_海外の音/ホテル/廊下から部屋に入る.ogg",
    "size": 232121,
    "tags": [
      "海外の音",
      "ホテル"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/ペン駅の入口近く",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "ペン駅の入口近く",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/ペン駅の入口近く.ogg",
    "size": 4313166,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/マンハッタンの朝１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "マンハッタンの朝１",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/マンハッタンの朝１.ogg",
    "size": 2120850,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/マンハッタンの朝２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "マンハッタンの朝２",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/マンハッタンの朝２.ogg",
    "size": 1482901,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/マンハッタンを歩く１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "マンハッタンを歩く１",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/マンハッタンを歩く１.ogg",
    "size": 4774596,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/マンハッタンを歩く２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "マンハッタンを歩く２",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/マンハッタンを歩く２.ogg",
    "size": 2304490,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/街角１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "街角１",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/街角１.ogg",
    "size": 1387613,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/街角２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "街角２",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/街角２.ogg",
    "size": 2591013,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/街角３（長め・小雨）",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "街角３（長め・小雨）",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/街角３（長め・小雨）.ogg",
    "size": 4224400,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/街角４（小雨）",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "街角４（小雨）",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/街角４（小雨）.ogg",
    "size": 2867084,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/交差点周辺１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "交差点周辺１",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/交差点周辺１.ogg",
    "size": 1437125,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/交差点周辺２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "交差点周辺２",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/交差点周辺２.ogg",
    "size": 1975171,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/地下鉄駅近くの夜道",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "地下鉄駅近くの夜道",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/地下鉄駅近くの夜道.ogg",
    "size": 912576,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/昼の住宅街",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "昼の住宅街",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/昼の住宅街.ogg",
    "size": 4543766,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/昼間の街中",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "昼間の街中",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/昼間の街中.ogg",
    "size": 2616541,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/夜で駅前の交差点",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "夜で駅前の交差点",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/夜で駅前の交差点.ogg",
    "size": 2540037,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/夜の通り１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "夜の通り１",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/夜の通り１.ogg",
    "size": 3796355,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/夜の通り２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "夜の通り２",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/夜の通り２.ogg",
    "size": 3169726,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/マンハッタン/夜の通り３",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "夜の通り３",
    "description": "マンハッタン",
    "path": "builtin/se/pix-studio/16_海外の音/マンハッタン/夜の通り３.ogg",
    "size": 3051578,
    "tags": [
      "海外の音",
      "マンハッタン"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/レストランがやがや（英語）",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "レストランがやがや（英語）",
    "description": "",
    "path": "builtin/se/pix-studio/16_海外の音/レストランがやがや（英語）.ogg",
    "size": 170426,
    "tags": [
      "海外の音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/エスカーレータ",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "エスカーレータ",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/エスカーレータ.ogg",
    "size": 680723,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/チケット売り場前１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "チケット売り場前１",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/チケット売り場前１.ogg",
    "size": 869371,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/チケット売り場前２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "チケット売り場前２",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/チケット売り場前２.ogg",
    "size": 2728766,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/ペン駅構内放送",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "ペン駅構内放送",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/ペン駅構内放送.ogg",
    "size": 1340105,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/駅構内１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "駅構内１",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/駅構内１.ogg",
    "size": 980656,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/駅構内２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "駅構内２",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/駅構内２.ogg",
    "size": 727042,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/急行（長距離移動）",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "急行（長距離移動）",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/急行（長距離移動）.ogg",
    "size": 5360169,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/地下通路を歩く",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "地下通路を歩く",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/地下通路を歩く.ogg",
    "size": 823876,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/地下鉄ホーム１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "地下鉄ホーム１",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/地下鉄ホーム１.ogg",
    "size": 3885097,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/地下鉄ホーム２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "地下鉄ホーム２",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/地下鉄ホーム２.ogg",
    "size": 2902598,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/地下鉄改札近く",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "地下鉄改札近く",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/地下鉄改札近く.ogg",
    "size": 1221030,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/地下鉄乗り降り",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "地下鉄乗り降り",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/地下鉄乗り降り.ogg",
    "size": 3787789,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/駅/通勤ラッシュ時",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "通勤ラッシュ時",
    "description": "駅",
    "path": "builtin/se/pix-studio/16_海外の音/駅/通勤ラッシュ時.ogg",
    "size": 1205063,
    "tags": [
      "海外の音",
      "駅"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/のどかで鳥の多い村",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "のどかで鳥の多い村",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/のどかで鳥の多い村.ogg",
    "size": 3793157,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/蛙のいる沼",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "蛙のいる沼",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/蛙のいる沼.ogg",
    "size": 687525,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/山の中の川の流れ",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "山の中の川の流れ",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/山の中の川の流れ.ogg",
    "size": 515103,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/森の中の小川の傍",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "森の中の小川の傍",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/森の中の小川の傍.ogg",
    "size": 641256,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/鳥のいる郊外１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "鳥のいる郊外１",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/鳥のいる郊外１.ogg",
    "size": 879725,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/鳥のいる郊外２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "鳥のいる郊外２",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/鳥のいる郊外２.ogg",
    "size": 1632756,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/鳥のいる農村の朝",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "鳥のいる農村の朝",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/鳥のいる農村の朝.ogg",
    "size": 723425,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/田舎の情景",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "田舎の情景",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/田舎の情景.ogg",
    "size": 787251,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/風の強い山中",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "風の強い山中",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/風の強い山中.ogg",
    "size": 1395881,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/羊のいる農村の朝１",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "羊のいる農村の朝１",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/羊のいる農村の朝１.ogg",
    "size": 1163019,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/16_海外の音/田舎/羊のいる農村の朝２",
    "pack": "pix-studio",
    "category": "pix-studio/海外の音",
    "categoryLabel": "海外の音",
    "name": "羊のいる農村の朝２",
    "description": "田舎",
    "path": "builtin/se/pix-studio/16_海外の音/田舎/羊のいる農村の朝２.ogg",
    "size": 1531195,
    "tags": [
      "海外の音",
      "田舎"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/17_その他の場所/レースカー通過",
    "pack": "pix-studio",
    "category": "pix-studio/その他の場所",
    "categoryLabel": "その他の場所",
    "name": "レースカー通過",
    "description": "",
    "path": "builtin/se/pix-studio/17_その他の場所/レースカー通過.ogg",
    "size": 84136,
    "tags": [
      "その他の場所"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/17_その他の場所/競艇場",
    "pack": "pix-studio",
    "category": "pix-studio/その他の場所",
    "categoryLabel": "その他の場所",
    "name": "競艇場",
    "description": "",
    "path": "builtin/se/pix-studio/17_その他の場所/競艇場.ogg",
    "size": 2318056,
    "tags": [
      "その他の場所"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/17_その他の場所/教会の鐘",
    "pack": "pix-studio",
    "category": "pix-studio/その他の場所",
    "categoryLabel": "その他の場所",
    "name": "教会の鐘",
    "description": "",
    "path": "builtin/se/pix-studio/17_その他の場所/教会の鐘.ogg",
    "size": 39167,
    "tags": [
      "その他の場所"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/17_その他の場所/鉱山で石を掘る",
    "pack": "pix-studio",
    "category": "pix-studio/その他の場所",
    "categoryLabel": "その他の場所",
    "name": "鉱山で石を掘る",
    "description": "",
    "path": "builtin/se/pix-studio/17_その他の場所/鉱山で石を掘る.ogg",
    "size": 102587,
    "tags": [
      "その他の場所"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/ＲＰＧの階段１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "ＲＰＧの階段１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/ＲＰＧの階段１.ogg",
    "size": 9828,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/モンスター出現",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "モンスター出現",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/モンスター出現.ogg",
    "size": 22810,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/ワープ１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "ワープ１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/ワープ１.ogg",
    "size": 24844,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/稲妻",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "稲妻",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/稲妻.ogg",
    "size": 291012,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/音波",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "音波",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/音波.ogg",
    "size": 24307,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/火・炎１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "火・炎１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/火・炎１.ogg",
    "size": 79623,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/火・炎２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "火・炎２",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/火・炎２.ogg",
    "size": 60394,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/火・炎３",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "火・炎３",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/火・炎３.ogg",
    "size": 39526,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/火・炎４",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "火・炎４",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/火・炎４.ogg",
    "size": 46616,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/海底マグマ",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "海底マグマ",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/海底マグマ.ogg",
    "size": 446715,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/金属音１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "金属音１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/金属音１.ogg",
    "size": 34637,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/金属音２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "金属音２",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/金属音２.ogg",
    "size": 34957,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/金属音３",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "金属音３",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/金属音３.ogg",
    "size": 45069,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/呼び笛（時代劇風）",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "呼び笛（時代劇風）",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/呼び笛（時代劇風）.ogg",
    "size": 70855,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/光の声",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "光の声",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/光の声.ogg",
    "size": 16250,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/混乱光線",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "混乱光線",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/混乱光線.ogg",
    "size": 67515,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/財宝じゃらじゃら",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "財宝じゃらじゃら",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/財宝じゃらじゃら.ogg",
    "size": 153048,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/姿をくらます１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "姿をくらます１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/姿をくらます１.ogg",
    "size": 77712,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/姿をくらます２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "姿をくらます２",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/姿をくらます２.ogg",
    "size": 67809,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/消滅１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "消滅１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/消滅１.ogg",
    "size": 51394,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/消滅２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "消滅２",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/消滅２.ogg",
    "size": 66365,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/水の国",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "水の国",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/水の国.ogg",
    "size": 403198,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/地鳴り",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "地鳴り",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/地鳴り.ogg",
    "size": 156508,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/敵襲（鐘の音）",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "敵襲（鐘の音）",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/敵襲（鐘の音）.ogg",
    "size": 199899,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/天使の叫び",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "天使の叫び",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/天使の叫び.ogg",
    "size": 120237,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/天使の合唱１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "天使の合唱１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/天使の合唱１.ogg",
    "size": 55934,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/天使の合唱２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "天使の合唱２",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/天使の合唱２.ogg",
    "size": 47932,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/天使の合唱３",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "天使の合唱３",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/天使の合唱３.ogg",
    "size": 136620,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/天使の合唱４",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "天使の合唱４",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/天使の合唱４.ogg",
    "size": 130535,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/反射",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "反射",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/反射.ogg",
    "size": 15248,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/不思議ちゃん光線",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "不思議ちゃん光線",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/不思議ちゃん光線.ogg",
    "size": 38624,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/不思議なキーン",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "不思議なキーン",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/不思議なキーン.ogg",
    "size": 82721,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/ズバッと斬る１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "ズバッと斬る１",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/ズバッと斬る１.ogg",
    "size": 15965,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/ズバッと斬る２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "ズバッと斬る２",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/ズバッと斬る２.ogg",
    "size": 19878,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/ズバッと斬る３（高速）",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "ズバッと斬る３（高速）",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/ズバッと斬る３（高速）.ogg",
    "size": 16641,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/ナイフを抜く",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "ナイフを抜く",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/ナイフを抜く.ogg",
    "size": 11974,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/軽く刺す",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "軽く刺す",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/軽く刺す.ogg",
    "size": 7297,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/剣の戦い",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "剣の戦い",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/剣の戦い.ogg",
    "size": 52426,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/剣を抜く",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "剣を抜く",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/剣を抜く.ogg",
    "size": 20164,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/剣戟１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "剣戟１",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/剣戟１.ogg",
    "size": 12909,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/剣戟２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "剣戟２",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/剣戟２.ogg",
    "size": 15097,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/手裏剣１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "手裏剣１",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/手裏剣１.ogg",
    "size": 10696,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/手裏剣２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "手裏剣２",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/手裏剣２.ogg",
    "size": 15085,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/手裏剣３",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "手裏剣３",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/手裏剣３.ogg",
    "size": 18837,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/神の剣１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "神の剣１",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/神の剣１.ogg",
    "size": 49414,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/中国っぽい剣１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "中国っぽい剣１",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/中国っぽい剣１.ogg",
    "size": 27179,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/中国っぽい剣２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "中国っぽい剣２",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/中国っぽい剣２.ogg",
    "size": 29281,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/武器/刀１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "刀１",
    "description": "武器",
    "path": "builtin/se/pix-studio/20_RPGの音/武器/刀１.ogg",
    "size": 25560,
    "tags": [
      "RPGの音",
      "武器"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/変な生き物の鳴声１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "変な生き物の鳴声１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/変な生き物の鳴声１.ogg",
    "size": 12204,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/変な生き物の鳴声２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "変な生き物の鳴声２",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/変な生き物の鳴声２.ogg",
    "size": 12126,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/変な生き物の鳴声３",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "変な生き物の鳴声３",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/変な生き物の鳴声３.ogg",
    "size": 12507,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔導エレベーター",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔導エレベーター",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/魔導エレベーター.ogg",
    "size": 28478,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法１",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法１.ogg",
    "size": 17428,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法２",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法２.ogg",
    "size": 24008,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法３",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法３",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法３.ogg",
    "size": 13782,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法４",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法４",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法４.ogg",
    "size": 24294,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法５（コミカル）",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法５（コミカル）",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法５（コミカル）.ogg",
    "size": 18244,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法６",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法６",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法６.ogg",
    "size": 25261,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法７",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法７",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法７.ogg",
    "size": 22780,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法の波動１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法の波動１",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法の波動１.ogg",
    "size": 21663,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法の波動２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法の波動２",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法の波動２.ogg",
    "size": 19580,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法の波動３",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法の波動３",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法の波動３.ogg",
    "size": 17112,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/魔法/魔法の波動４",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "魔法の波動４",
    "description": "魔法",
    "path": "builtin/se/pix-studio/20_RPGの音/魔法/魔法の波動４.ogg",
    "size": 20553,
    "tags": [
      "RPGの音",
      "魔法"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/妖精の遊び１",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "妖精の遊び１",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/妖精の遊び１.ogg",
    "size": 161663,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_RPGの音/妖精の遊び２",
    "pack": "pix-studio",
    "category": "pix-studio/RPGの音",
    "categoryLabel": "RPGの音",
    "name": "妖精の遊び２",
    "description": "",
    "path": "builtin/se/pix-studio/20_RPGの音/妖精の遊び２.ogg",
    "size": 76599,
    "tags": [
      "RPGの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/デビルびびり１",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "デビルびびり１",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/デビルびびり１.ogg",
    "size": 29124,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/デビルびびり２",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "デビルびびり２",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/デビルびびり２.ogg",
    "size": 28559,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/デビル笑い１",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "デビル笑い１",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/デビル笑い１.ogg",
    "size": 125905,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/デビル笑い２",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "デビル笑い２",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/デビル笑い２.ogg",
    "size": 128421,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/デビル笑い３",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "デビル笑い３",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/デビル笑い３.ogg",
    "size": 96434,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/デビル呻き１",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "デビル呻き１",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/デビル呻き１.ogg",
    "size": 51562,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/デビル呻き２",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "デビル呻き２",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/デビル呻き２.ogg",
    "size": 21056,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/デビル呻き３",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "デビル呻き３",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/デビル呻き３.ogg",
    "size": 102972,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/ドラゴンブレス",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "ドラゴンブレス",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/ドラゴンブレス.ogg",
    "size": 67512,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/ドラゴンブレス２",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "ドラゴンブレス２",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/ドラゴンブレス２.ogg",
    "size": 69381,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/悪魔が遠くで呼ぶ声",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "悪魔が遠くで呼ぶ声",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/悪魔が遠くで呼ぶ声.ogg",
    "size": 78523,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/宇宙動物園",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "宇宙動物園",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/宇宙動物園.ogg",
    "size": 709533,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/化け物のいびき",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "化け物のいびき",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/化け物のいびき.ogg",
    "size": 108749,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/化け物の嘆き",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "化け物の嘆き",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/化け物の嘆き.ogg",
    "size": 105627,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/怪物の鼓動１",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "怪物の鼓動１",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/怪物の鼓動１.ogg",
    "size": 82181,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/怪物の鼓動２",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "怪物の鼓動２",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/怪物の鼓動２.ogg",
    "size": 67077,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/怪物の鼓動３",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "怪物の鼓動３",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/怪物の鼓動３.ogg",
    "size": 39301,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/牛魔王の鳴き声",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "牛魔王の鳴き声",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/牛魔王の鳴き声.ogg",
    "size": 98891,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/巨人の足音",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "巨人の足音",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/巨人の足音.ogg",
    "size": 37110,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/巨人の歩き",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "巨人の歩き",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/巨人の歩き.ogg",
    "size": 134526,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/小化け物の威嚇",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "小化け物の威嚇",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/小化け物の威嚇.ogg",
    "size": 20443,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/粗野な笑い",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "粗野な笑い",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/粗野な笑い.ogg",
    "size": 91448,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/風魔人の攻撃１",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "風魔人の攻撃１",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/風魔人の攻撃１.ogg",
    "size": 104889,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/風魔人の攻撃２",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "風魔人の攻撃２",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/風魔人の攻撃２.ogg",
    "size": 140170,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/魔獣の呻り１",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "魔獣の呻り１",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/魔獣の呻り１.ogg",
    "size": 135957,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/魔獣の呻り２",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "魔獣の呻り２",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/魔獣の呻り２.ogg",
    "size": 52202,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/魔獣の呻り３",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "魔獣の呻り３",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/魔獣の呻り３.ogg",
    "size": 71616,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/魔人の吸い込み",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "魔人の吸い込み",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/魔人の吸い込み.ogg",
    "size": 35869,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/未知の生物の鳴声",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "未知の生物の鳴声",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/未知の生物の鳴声.ogg",
    "size": 45753,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/龍のうなり",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "龍のうなり",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/龍のうなり.ogg",
    "size": 48866,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_モンスターの音/龍のため息",
    "pack": "pix-studio",
    "category": "pix-studio/モンスターの音",
    "categoryLabel": "モンスターの音",
    "name": "龍のため息",
    "description": "",
    "path": "builtin/se/pix-studio/20_モンスターの音/龍のため息.ogg",
    "size": 23628,
    "tags": [
      "モンスターの音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/bomb",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "bomb",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/bomb.ogg",
    "size": 13931,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/遠くで爆発",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "遠くで爆発",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/遠くで爆発.ogg",
    "size": 42583,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/核爆発",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "核爆発",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/核爆発.ogg",
    "size": 482578,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/小破裂",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "小破裂",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/小破裂.ogg",
    "size": 12678,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/小爆発１",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "小爆発１",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/小爆発１.ogg",
    "size": 21978,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/小爆発２",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "小爆発２",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/小爆発２.ogg",
    "size": 28655,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/大破壊１",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "大破壊１",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/大破壊１.ogg",
    "size": 47603,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/大破壊２",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "大破壊２",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/大破壊２.ogg",
    "size": 38720,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/大爆発（ゲーム風）",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "大爆発（ゲーム風）",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/大爆発（ゲーム風）.ogg",
    "size": 43515,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/爆発（ゲーム風）",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "爆発（ゲーム風）",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/爆発（ゲーム風）.ogg",
    "size": 31267,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/爆発３",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "爆発３",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/爆発３.ogg",
    "size": 48382,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/20_爆発/連鎖爆発",
    "pack": "pix-studio",
    "category": "pix-studio/爆発",
    "categoryLabel": "爆発",
    "name": "連鎖爆発",
    "description": "",
    "path": "builtin/se/pix-studio/20_爆発/連鎖爆発.ogg",
    "size": 107477,
    "tags": [
      "爆発"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/SF風パトカー",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "SF風パトカー",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/SF風パトカー.ogg",
    "size": 90549,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/UFO",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "UFO",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/UFO.ogg",
    "size": 92862,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/UFO着陸",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "UFO着陸",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/UFO着陸.ogg",
    "size": 107013,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/UFO離陸",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "UFO離陸",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/UFO離陸.ogg",
    "size": 107836,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/エイリアン宇宙船１",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "エイリアン宇宙船１",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/エイリアン宇宙船１.ogg",
    "size": 77768,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/エイリアン宇宙船２",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "エイリアン宇宙船２",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/エイリアン宇宙船２.ogg",
    "size": 54912,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/エネルギー注入１",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "エネルギー注入１",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/エネルギー注入１.ogg",
    "size": 39373,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/エネルギー注入２",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "エネルギー注入２",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/エネルギー注入２.ogg",
    "size": 64168,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/サイバーメール",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "サイバーメール",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/サイバーメール.ogg",
    "size": 28315,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ショックビーム",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ショックビーム",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ショックビーム.ogg",
    "size": 59274,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/タイムマシン１",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "タイムマシン１",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/タイムマシン１.ogg",
    "size": 432745,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/タイムマシン２",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "タイムマシン２",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/タイムマシン２.ogg",
    "size": 404320,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ピッ・一定音",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ピッ・一定音",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ピッ・一定音.ogg",
    "size": 114186,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/マシン暴走",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "マシン暴走",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/マシン暴走.ogg",
    "size": 76510,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ライトセーバー風１",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ライトセーバー風１",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ライトセーバー風１.ogg",
    "size": 20615,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ライトセーバー風２",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ライトセーバー風２",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ライトセーバー風２.ogg",
    "size": 15893,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ライトセーバー風３",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ライトセーバー風３",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ライトセーバー風３.ogg",
    "size": 14672,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ラピュタの方角",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ラピュタの方角",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ラピュタの方角.ogg",
    "size": 78300,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ロボットの一撃１",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ロボットの一撃１",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ロボットの一撃１.ogg",
    "size": 35929,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ロボットの一撃２",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ロボットの一撃２",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ロボットの一撃２.ogg",
    "size": 35819,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ロボットの一撃３",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ロボットの一撃３",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ロボットの一撃３.ogg",
    "size": 33579,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/ロボット三連打",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "ロボット三連打",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/ロボット三連打.ogg",
    "size": 52264,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/宇宙からの信号",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "宇宙からの信号",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/宇宙からの信号.ogg",
    "size": 363918,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/宇宙人の会話",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "宇宙人の会話",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/宇宙人の会話.ogg",
    "size": 278045,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/宇宙人ビーム",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "宇宙人ビーム",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/宇宙人ビーム.ogg",
    "size": 55852,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/解析不能",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "解析不能",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/解析不能.ogg",
    "size": 46431,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/感電１",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "感電１",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/感電１.ogg",
    "size": 79251,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/感電２",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "感電２",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/感電２.ogg",
    "size": 77930,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/感電後",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "感電後",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/感電後.ogg",
    "size": 88738,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/機械エンジン",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "機械エンジン",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/機械エンジン.ogg",
    "size": 142980,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/機械の中速回転",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "機械の中速回転",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/機械の中速回転.ogg",
    "size": 488822,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/機械の低速回転",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "機械の低速回転",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/機械の低速回転.ogg",
    "size": 180793,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/機械の非常信号",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "機械の非常信号",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/機械の非常信号.ogg",
    "size": 73263,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/緊急呼び出し",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "緊急呼び出し",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/緊急呼び出し.ogg",
    "size": 128570,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/呼び出し",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "呼び出し",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/呼び出し.ogg",
    "size": 14013,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/呼び出しブザー",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "呼び出しブザー",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/呼び出しブザー.ogg",
    "size": 53317,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/工場サイレン",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "工場サイレン",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/工場サイレン.ogg",
    "size": 106081,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/催眠光線",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "催眠光線",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/催眠光線.ogg",
    "size": 43266,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/重低音振動",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "重低音振動",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/重低音振動.ogg",
    "size": 44569,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/大型ロボット走り",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "大型ロボット走り",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/大型ロボット走り.ogg",
    "size": 84656,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/大型ロボット中速",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "大型ロボット中速",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/大型ロボット中速.ogg",
    "size": 95780,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/大型ロボット歩行",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "大型ロボット歩行",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/大型ロボット歩行.ogg",
    "size": 130259,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/電磁拘束",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "電磁拘束",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/電磁拘束.ogg",
    "size": 20499,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/電波妨害",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "電波妨害",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/電波妨害.ogg",
    "size": 92150,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/反響音",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "反響音",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/反響音.ogg",
    "size": 9625,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/彗星１",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "彗星１",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/彗星１.ogg",
    "size": 62177,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_SFの世界観/彗星２",
    "pack": "pix-studio",
    "category": "pix-studio/SFの世界観",
    "categoryLabel": "SFの世界観",
    "name": "彗星２",
    "description": "",
    "path": "builtin/se/pix-studio/21_SFの世界観/彗星２.ogg",
    "size": 37099,
    "tags": [
      "SFの世界観"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/shoot1",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "shoot1",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/shoot1.ogg",
    "size": 17536,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/shoot2",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "shoot2",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/shoot2.ogg",
    "size": 7518,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ハンドレーザー",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ハンドレーザー",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ハンドレーザー.ogg",
    "size": 16204,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ビーム",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ビーム",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ビーム.ogg",
    "size": 16444,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ビーム１",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ビーム１",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ビーム１.ogg",
    "size": 21016,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ビーム２",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ビーム２",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ビーム２.ogg",
    "size": 21297,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ビーム３",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ビーム３",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ビーム３.ogg",
    "size": 21179,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ビーム４",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ビーム４",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ビーム４.ogg",
    "size": 21589,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ビーム５",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ビーム５",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ビーム５.ogg",
    "size": 22254,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ビーム６",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ビーム６",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ビーム６.ogg",
    "size": 28745,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ピョッ（ミサイル？）",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ピョッ（ミサイル？）",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ピョッ（ミサイル？）.ogg",
    "size": 12058,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ピョヨヨヨョ",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ピョヨヨヨョ",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ピョヨヨヨョ.ogg",
    "size": 35772,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/マシンガン風",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "マシンガン風",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/マシンガン風.ogg",
    "size": 58373,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ミニレーザー",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ミニレーザー",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ミニレーザー.ogg",
    "size": 9435,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/ランチャー連射と着弾",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "ランチャー連射と着弾",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/ランチャー連射と着弾.ogg",
    "size": 221166,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/レーザー１",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "レーザー１",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/レーザー１.ogg",
    "size": 11348,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/レーザー２",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "レーザー２",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/レーザー２.ogg",
    "size": 8781,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/レーザー３",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "レーザー３",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/レーザー３.ogg",
    "size": 12589,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/レーザー４",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "レーザー４",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/レーザー４.ogg",
    "size": 8749,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/レーザー５",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "レーザー５",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/レーザー５.ogg",
    "size": 11359,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/レーザービーム",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "レーザービーム",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/レーザービーム.ogg",
    "size": 27203,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/レーザー乱射",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "レーザー乱射",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/レーザー乱射.ogg",
    "size": 26229,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/回転ロケット",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "回転ロケット",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/回転ロケット.ogg",
    "size": 58014,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/大砲１",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "大砲１",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/大砲１.ogg",
    "size": 34936,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/破壊１",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "破壊１",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/破壊１.ogg",
    "size": 38474,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/発射１",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "発射１",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/発射１.ogg",
    "size": 25138,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/発射２",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "発射２",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/発射２.ogg",
    "size": 30667,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/発射３",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "発射３",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/発射３.ogg",
    "size": 56453,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/発射４",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "発射４",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/発射４.ogg",
    "size": 49101,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/21_重火器・光線/連続発射",
    "pack": "pix-studio",
    "category": "pix-studio/重火器・光線",
    "categoryLabel": "重火器・光線",
    "name": "連続発射",
    "description": "",
    "path": "builtin/se/pix-studio/21_重火器・光線/連続発射.ogg",
    "size": 53293,
    "tags": [
      "重火器・光線"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/したたり",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "したたり",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/したたり.ogg",
    "size": 114079,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/ずるずる引きずる",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "ずるずる引きずる",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/ずるずる引きずる.ogg",
    "size": 115914,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/ずるずる落ちる",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "ずるずる落ちる",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/ずるずる落ちる.ogg",
    "size": 86678,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/ドンドンドンドン（壁叩）",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "ドンドンドンドン（壁叩）",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/ドンドンドンドン（壁叩）.ogg",
    "size": 22444,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/ピー音０．５秒",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "ピー音０．５秒",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/ピー音０．５秒.ogg",
    "size": 4651,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/ピー音１秒",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "ピー音１秒",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/ピー音１秒.ogg",
    "size": 5498,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/ピー音２秒",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "ピー音２秒",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/ピー音２秒.ogg",
    "size": 6959,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/フェンスを揺さぶる",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "フェンスを揺さぶる",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/フェンスを揺さぶる.ogg",
    "size": 55633,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/化け物の食事１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "化け物の食事１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/化け物の食事１.ogg",
    "size": 223343,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/化け物の食事２（骨）",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "化け物の食事２（骨）",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/化け物の食事２（骨）.ogg",
    "size": 259881,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/化け物の食事３（骨）",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "化け物の食事３（骨）",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/化け物の食事３（骨）.ogg",
    "size": 258972,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/化物に飲み込まれる１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "化物に飲み込まれる１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/化物に飲み込まれる１.ogg",
    "size": 65342,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/化物に飲み込まれる２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "化物に飲み込まれる２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/化物に飲み込まれる２.ogg",
    "size": 18722,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー/食器が地震で揺れる",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー",
    "categoryLabel": "ホラー",
    "name": "食器が地震で揺れる",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー/食器が地震で揺れる.ogg",
    "size": 330129,
    "tags": [
      "ホラー"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/1000hz_noise",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "1000hz_noise",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/1000hz_noise.ogg",
    "size": 121873,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/1500hz_noise",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "1500hz_noise",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/1500hz_noise.ogg",
    "size": 114514,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/2400hz_noise",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "2400hz_noise",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/2400hz_noise.ogg",
    "size": 90064,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/300hz_noise",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "300hz_noise",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/300hz_noise.ogg",
    "size": 158764,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/600hz_noise",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "600hz_noise",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/600hz_noise.ogg",
    "size": 134640,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/ガーン（ショック）１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "ガーン（ショック）１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/ガーン（ショック）１.ogg",
    "size": 55148,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/ガーン（ショック）２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "ガーン（ショック）２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/ガーン（ショック）２.ogg",
    "size": 66559,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/ガーン（ショック）３",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "ガーン（ショック）３",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/ガーン（ショック）３.ogg",
    "size": 60106,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/ダメージノイズ",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "ダメージノイズ",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/ダメージノイズ.ogg",
    "size": 54378,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/トランス１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "トランス１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/トランス１.ogg",
    "size": 401075,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/トランス２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "トランス２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/トランス２.ogg",
    "size": 288167,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/ホワイトノイズ１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "ホワイトノイズ１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/ホワイトノイズ１.ogg",
    "size": 51213,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/ホワイトノイズ２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "ホワイトノイズ２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/ホワイトノイズ２.ogg",
    "size": 53054,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/暗い一撃",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "暗い一撃",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/暗い一撃.ogg",
    "size": 78443,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/異世界",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "異世界",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/異世界.ogg",
    "size": 376260,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/異世界の風",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "異世界の風",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/異世界の風.ogg",
    "size": 137349,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/汚いクレーム",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "汚いクレーム",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/汚いクレーム.ogg",
    "size": 67347,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/黄泉の国の鐘",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "黄泉の国の鐘",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/黄泉の国の鐘.ogg",
    "size": 219958,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/何かに呼ばれている",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "何かに呼ばれている",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/何かに呼ばれている.ogg",
    "size": 163815,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/苛める・苛められる",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "苛める・苛められる",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/苛める・苛められる.ogg",
    "size": 302710,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/過去が忍び寄る",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "過去が忍び寄る",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/過去が忍び寄る.ogg",
    "size": 117554,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/疑惑１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "疑惑１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/疑惑１.ogg",
    "size": 41916,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/疑惑２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "疑惑２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/疑惑２.ogg",
    "size": 45731,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/疑惑３",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "疑惑３",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/疑惑３.ogg",
    "size": 40085,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/恐怖の一撃",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "恐怖の一撃",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/恐怖の一撃.ogg",
    "size": 84651,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/時空反転",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "時空反転",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/時空反転.ogg",
    "size": 220652,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/時計カチカチ",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "時計カチカチ",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/時計カチカチ.ogg",
    "size": 174305,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/次元の歪み",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "次元の歪み",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/次元の歪み.ogg",
    "size": 67788,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/耳鳴り1",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "耳鳴り1",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/耳鳴り1.ogg",
    "size": 58977,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/耳鳴り２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "耳鳴り２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/耳鳴り２.ogg",
    "size": 34072,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/耳鳴り３",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "耳鳴り３",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/耳鳴り３.ogg",
    "size": 160532,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/耳鳴り４",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "耳鳴り４",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/耳鳴り４.ogg",
    "size": 26334,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/耳鳴り５",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "耳鳴り５",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/耳鳴り５.ogg",
    "size": 61208,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/重い空気",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "重い空気",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/重い空気.ogg",
    "size": 105642,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/心の息",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "心の息",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/心の息.ogg",
    "size": 481768,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/心理ショック１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "心理ショック１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/心理ショック１.ogg",
    "size": 58959,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/心理ショック２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "心理ショック２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/心理ショック２.ogg",
    "size": 53385,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/心霊現象・心霊地帯１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "心霊現象・心霊地帯１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/心霊現象・心霊地帯１.ogg",
    "size": 570687,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/心霊現象・心霊地帯２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "心霊現象・心霊地帯２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/心霊現象・心霊地帯２.ogg",
    "size": 620091,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/世界の終り１",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "世界の終り１",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/世界の終り１.ogg",
    "size": 355454,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/世界の終り２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "世界の終り２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/世界の終り２.ogg",
    "size": 386643,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/体重が増えた心理音",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "体重が増えた心理音",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/体重が増えた心理音.ogg",
    "size": 110966,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/地獄の歯車",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "地獄の歯車",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/地獄の歯車.ogg",
    "size": 131428,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/倒錯",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "倒錯",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/倒錯.ogg",
    "size": 110034,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/頭の中にハエ",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "頭の中にハエ",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/頭の中にハエ.ogg",
    "size": 110694,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/頭痛",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "頭痛",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/頭痛.ogg",
    "size": 195295,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/迫ってくる感じ",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "迫ってくる感じ",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/迫ってくる感じ.ogg",
    "size": 74667,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/不協和音１（低音）",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "不協和音１（低音）",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/不協和音１（低音）.ogg",
    "size": 106447,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/不協和音３（高音）",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "不協和音３（高音）",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/不協和音３（高音）.ogg",
    "size": 57611,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/不協和音４（エコー）",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "不協和音４（エコー）",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/不協和音４（エコー）.ogg",
    "size": 172860,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/不協和音ピアノ２",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "不協和音ピアノ２",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/不協和音ピアノ２.ogg",
    "size": 81676,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/風の迷い人",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "風の迷い人",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/風の迷い人.ogg",
    "size": 1108970,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/亡者の怨念",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "亡者の怨念",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/亡者の怨念.ogg",
    "size": 475345,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/眠りの中",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "眠りの中",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/眠りの中.ogg",
    "size": 412394,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/夢の中で犬が吠える",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "夢の中で犬が吠える",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/夢の中で犬が吠える.ogg",
    "size": 301856,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/迷路",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "迷路",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/迷路.ogg",
    "size": 264570,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/22_ホラー心理系/嘲笑心理音",
    "pack": "pix-studio",
    "category": "pix-studio/ホラー心理系",
    "categoryLabel": "ホラー心理系",
    "name": "嘲笑心理音",
    "description": "",
    "path": "builtin/se/pix-studio/22_ホラー心理系/嘲笑心理音.ogg",
    "size": 109274,
    "tags": [
      "ホラー心理系"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/お化けがふわふわ",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "お化けがふわふわ",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/お化けがふわふわ.ogg",
    "size": 36646,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ガキ大将登場",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ガキ大将登場",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ガキ大将登場.ogg",
    "size": 152226,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/キラキラ階段",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "キラキラ階段",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/キラキラ階段.ogg",
    "size": 55002,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/クエスチョン",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "クエスチョン",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/クエスチョン.ogg",
    "size": 10718,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ぐにゃぐにゃ～ん",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ぐにゃぐにゃ～ん",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ぐにゃぐにゃ～ん.ogg",
    "size": 54249,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ジャン！驚き",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ジャン！驚き",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ジャン！驚き.ogg",
    "size": 16935,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ズッコケ落ち",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ズッコケ落ち",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ズッコケ落ち.ogg",
    "size": 102017,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ハーモニックノイズ",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ハーモニックノイズ",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ハーモニックノイズ.ogg",
    "size": 131638,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/パクリと食べる",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "パクリと食べる",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/パクリと食べる.ogg",
    "size": 6062,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/バッドエンド",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "バッドエンド",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/バッドエンド.ogg",
    "size": 189272,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ピーン！（閃き）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ピーン！（閃き）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ピーン！（閃き）.ogg",
    "size": 11140,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ひょっこり",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ひょっこり",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ひょっこり.ogg",
    "size": 14400,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ビョビョーン！",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ビョビョーン！",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ビョビョーン！.ogg",
    "size": 35128,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ファンファーレ１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ファンファーレ１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ファンファーレ１.ogg",
    "size": 241687,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ファンファーレ２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ファンファーレ２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ファンファーレ２.ogg",
    "size": 204761,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/フライパンで叩く",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "フライパンで叩く",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/フライパンで叩く.ogg",
    "size": 18951,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ポカ！",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ポカ！",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ポカ！.ogg",
    "size": 10567,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ポヨッ",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ポヨッ",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ポヨッ.ogg",
    "size": 10776,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/ラムちゃん？",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "ラムちゃん？",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/ラムちゃん？.ogg",
    "size": 42935,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/レクイエム（バッハ）１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "レクイエム（バッハ）１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/レクイエム（バッハ）１.ogg",
    "size": 210339,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/レクイエム２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "レクイエム２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/レクイエム２.ogg",
    "size": 171446,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/一休さん？",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "一休さん？",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/一休さん？.ogg",
    "size": 100186,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/開始の合図１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "開始の合図１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/開始の合図１.ogg",
    "size": 128780,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/開始の合図２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "開始の合図２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/開始の合図２.ogg",
    "size": 153311,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/急げ急げ",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "急げ急げ",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/急げ急げ.ogg",
    "size": 190669,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/教会風（復活）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "教会風（復活）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/教会風（復活）.ogg",
    "size": 114468,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/姿をくらます",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "姿をくらます",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/姿をくらます.ogg",
    "size": 40010,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/失われた記憶",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "失われた記憶",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/失われた記憶.ogg",
    "size": 80926,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/小人の足音",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "小人の足音",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/小人の足音.ogg",
    "size": 32855,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１.ogg",
    "size": 136302,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１０（哀愁）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１０（哀愁）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１０（哀愁）.ogg",
    "size": 107954,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１１（奇妙）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１１（奇妙）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１１（奇妙）.ogg",
    "size": 144257,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１２（教会・暗）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１２（教会・暗）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１２（教会・暗）.ogg",
    "size": 237704,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１３（探偵風）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１３（探偵風）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１３（探偵風）.ogg",
    "size": 180407,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１４（ダーク）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１４（ダーク）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１４（ダーク）.ogg",
    "size": 93360,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１５（脱力）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１５（脱力）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１５（脱力）.ogg",
    "size": 45296,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１６（可愛い）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１６（可愛い）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１６（可愛い）.ogg",
    "size": 86499,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換１７（緊迫）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換１７（緊迫）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換１７（緊迫）.ogg",
    "size": 89154,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換２（章の終わり）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換２（章の終わり）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換２（章の終わり）.ogg",
    "size": 164059,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換３（コミカル）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換３（コミカル）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換３（コミカル）.ogg",
    "size": 103803,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換４（明るめ）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換４（明るめ）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換４（明るめ）.ogg",
    "size": 151393,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換５（可愛い）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換５（可愛い）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換５（可愛い）.ogg",
    "size": 40610,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換６（急転）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換６（急転）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換６（急転）.ogg",
    "size": 68634,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換７（暗い）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換７（暗い）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換７（暗い）.ogg",
    "size": 73530,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換８（POP調１）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換８（POP調１）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換８（POP調１）.ogg",
    "size": 154043,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換９（POP調２）",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換９（POP調２）",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換９（POP調２）.ogg",
    "size": 134303,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換アラビア？風１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換アラビア？風１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換アラビア？風１.ogg",
    "size": 65156,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換アラビア？風２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換アラビア？風２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換アラビア？風２.ogg",
    "size": 59366,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換ギリシャ？風１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換ギリシャ？風１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換ギリシャ？風１.ogg",
    "size": 54729,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換ギリシャ？風２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換ギリシャ？風２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換ギリシャ？風２.ogg",
    "size": 65302,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換ピアノ１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換ピアノ１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換ピアノ１.ogg",
    "size": 39193,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/場面転換ピアノ２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "場面転換ピアノ２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/場面転換ピアノ２.ogg",
    "size": 40531,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/静かな終わり",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "静かな終わり",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/静かな終わり.ogg",
    "size": 32417,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/虫の知らせ１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "虫の知らせ１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/虫の知らせ１.ogg",
    "size": 40086,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/虫の知らせ２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "虫の知らせ２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/虫の知らせ２.ogg",
    "size": 26936,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/踏んづける",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "踏んづける",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/踏んづける.ogg",
    "size": 10112,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/冒険への旅立ち",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "冒険への旅立ち",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/冒険への旅立ち.ogg",
    "size": 156227,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/無茶苦茶",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "無茶苦茶",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/無茶苦茶.ogg",
    "size": 131369,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/落下１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "落下１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/落下１.ogg",
    "size": 35329,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/落下２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "落下２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/落下２.ogg",
    "size": 37977,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/落下と衝撃１",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "落下と衝撃１",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/落下と衝撃１.ogg",
    "size": 60488,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/23_アニメ演出/落下と衝撃２",
    "pack": "pix-studio",
    "category": "pix-studio/アニメ演出",
    "categoryLabel": "アニメ演出",
    "name": "落下と衝撃２",
    "description": "",
    "path": "builtin/se/pix-studio/23_アニメ演出/落下と衝撃２.ogg",
    "size": 51640,
    "tags": [
      "アニメ演出"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/cat_like1a",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "cat_like1a",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/cat_like1a.ogg",
    "size": 9515,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/cat_like1b",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "cat_like1b",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/cat_like1b.ogg",
    "size": 15760,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/cat_like2a",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "cat_like2a",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/cat_like2a.ogg",
    "size": 9315,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/cat_like2b",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "cat_like2b",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/cat_like2b.ogg",
    "size": 14639,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/cat_like3a",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "cat_like3a",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/cat_like3a.ogg",
    "size": 8563,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/cat_like3b",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "cat_like3b",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/cat_like3b.ogg",
    "size": 13936,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/cat_like4a",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "cat_like4a",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/cat_like4a.ogg",
    "size": 8667,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/cat_like4b",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "cat_like4b",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/cat_like4b.ogg",
    "size": 12193,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/coin01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "coin01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/coin01.ogg",
    "size": 6779,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/coin02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "coin02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/coin02.ogg",
    "size": 6251,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/coin03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "coin03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/coin03.ogg",
    "size": 5587,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/coin04",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "coin04",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/coin04.ogg",
    "size": 7973,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/coin05",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "coin05",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/coin05.ogg",
    "size": 14011,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/coin06",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "coin06",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/coin06.ogg",
    "size": 15538,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/coin07",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "coin07",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/coin07.ogg",
    "size": 12917,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/coin08",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "coin08",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/coin08.ogg",
    "size": 7195,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/pickup01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "pickup01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/pickup01.ogg",
    "size": 8625,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/pickup02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "pickup02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/pickup02.ogg",
    "size": 7441,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/pickup03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "pickup03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/pickup03.ogg",
    "size": 5696,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/pickup04",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "pickup04",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/pickup04.ogg",
    "size": 6625,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerdown01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerdown01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerdown01.ogg",
    "size": 11290,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerdown02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerdown02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerdown02.ogg",
    "size": 7467,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerdown03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerdown03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerdown03.ogg",
    "size": 23993,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerdown04",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerdown04",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerdown04.ogg",
    "size": 18898,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerdown05",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerdown05",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerdown05.ogg",
    "size": 7677,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerdown06",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerdown06",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerdown06.ogg",
    "size": 12396,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerdown07",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerdown07",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerdown07.ogg",
    "size": 14551,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup01.ogg",
    "size": 8732,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup02.ogg",
    "size": 12558,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup03.ogg",
    "size": 5893,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup04",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup04",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup04.ogg",
    "size": 14338,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup05",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup05",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup05.ogg",
    "size": 13298,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup06",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup06",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup06.ogg",
    "size": 13148,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup07",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup07",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup07.ogg",
    "size": 9371,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup08",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup08",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup08.ogg",
    "size": 12026,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup09",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup09",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup09.ogg",
    "size": 10303,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/powerup10",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "powerup10",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/powerup10.ogg",
    "size": 12461,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select01.ogg",
    "size": 6893,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select02.ogg",
    "size": 6719,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select03.ogg",
    "size": 5983,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select04",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select04",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select04.ogg",
    "size": 6463,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select05",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select05",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select05.ogg",
    "size": 6389,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select06",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select06",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select06.ogg",
    "size": 5985,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select07",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select07",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select07.ogg",
    "size": 6670,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select08",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select08",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select08.ogg",
    "size": 6702,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select09",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select09",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select09.ogg",
    "size": 8780,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/select10",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "select10",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/select10.ogg",
    "size": 7193,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/sh_pickup01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "sh_pickup01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/sh_pickup01.ogg",
    "size": 6486,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/sh_pickup02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "sh_pickup02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/sh_pickup02.ogg",
    "size": 6823,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/sh_pickup03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "sh_pickup03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/sh_pickup03.ogg",
    "size": 6741,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ01.ogg",
    "size": 12149,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ02.ogg",
    "size": 9360,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ03.ogg",
    "size": 12829,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ04",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ04",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ04.ogg",
    "size": 8143,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ05",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ05",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ05.ogg",
    "size": 19827,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ06",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ06",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ06.ogg",
    "size": 6535,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ07",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ07",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ07.ogg",
    "size": 5954,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ08",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ08",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ08.ogg",
    "size": 8736,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ09",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ09",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ09.ogg",
    "size": 11369,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ10",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ10",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ10.ogg",
    "size": 14716,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ11",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ11",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ11.ogg",
    "size": 20245,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ12",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ12",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ12.ogg",
    "size": 9974,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ジャンプ13",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ジャンプ13",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ジャンプ13.ogg",
    "size": 9435,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ビープ01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ビープ01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ビープ01.ogg",
    "size": 10534,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ビープ02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ビープ02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ビープ02.ogg",
    "size": 6593,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ビープ03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ビープ03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ビープ03.ogg",
    "size": 5681,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ビープ04",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ビープ04",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ビープ04.ogg",
    "size": 9594,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ピシャ！ぺ！１",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ピシャ！ぺ！１",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ピシャ！ぺ！１.ogg",
    "size": 4658,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ピシャ！ぺ！２",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ピシャ！ぺ！２",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ピシャ！ぺ！２.ogg",
    "size": 4701,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ピシャ！ぺ！３",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ピシャ！ぺ！３",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ピシャ！ぺ！３.ogg",
    "size": 5498,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ポカッ01",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ポカッ01",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ポカッ01.ogg",
    "size": 4959,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ポカッ02",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ポカッ02",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ポカッ02.ogg",
    "size": 5483,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ポカッ03",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ポカッ03",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ポカッ03.ogg",
    "size": 7142,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン01a",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン01a",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン01a.ogg",
    "size": 6931,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン01b",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン01b",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン01b.ogg",
    "size": 10452,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン02a",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン02a",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン02a.ogg",
    "size": 9113,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン02b",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン02b",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン02b.ogg",
    "size": 12387,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン03a",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン03a",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン03a.ogg",
    "size": 7555,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン03b",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン03b",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン03b.ogg",
    "size": 10955,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン04a",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン04a",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン04a.ogg",
    "size": 7682,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン04b",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン04b",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン04b.ogg",
    "size": 12146,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン05",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン05",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン05.ogg",
    "size": 7107,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/ボタン06",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "ボタン06",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/ボタン06.ogg",
    "size": 6215,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/正解1",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "正解1",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/正解1.ogg",
    "size": 24586,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/正解2",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "正解2",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/正解2.ogg",
    "size": 22996,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/24_システム効果音/正解3",
    "pack": "pix-studio",
    "category": "pix-studio/システム効果音",
    "categoryLabel": "システム効果音",
    "name": "正解3",
    "description": "",
    "path": "builtin/se/pix-studio/24_システム効果音/正解3.ogg",
    "size": 38918,
    "tags": [
      "システム効果音"
    ],
    "adult": false
  },
  {
    "id": "pix-studio/99_エロ効果音/クチュ音短",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "クチュ音短",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/クチュ音短.ogg",
    "size": 19989,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/クチュ音長",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "クチュ音長",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/クチュ音長.ogg",
    "size": 67971,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/バイブ",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "バイブ",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/バイブ.ogg",
    "size": 91723,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/パイプベッドの軋み",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "パイプベッドの軋み",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/パイプベッドの軋み.ogg",
    "size": 34433,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/ピストン強",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "ピストン強",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/ピストン強.ogg",
    "size": 82359,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/ピストン弱",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "ピストン弱",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/ピストン弱.ogg",
    "size": 150050,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/ピストン中",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "ピストン中",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/ピストン中.ogg",
    "size": 114667,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/ローター",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "ローター",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/ローター.ogg",
    "size": 76987,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/衣擦れ",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "衣擦れ",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/衣擦れ.ogg",
    "size": 55179,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/外出し",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "外出し",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/外出し.ogg",
    "size": 13322,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/触手１",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "触手１",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/触手１.ogg",
    "size": 269643,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/挿入１",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "挿入１",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/挿入１.ogg",
    "size": 21217,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/挿入２",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "挿入２",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/挿入２.ogg",
    "size": 25906,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/挿入３",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "挿入３",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/挿入３.ogg",
    "size": 28010,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/中出し3発",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "中出し3発",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/中出し3発.ogg",
    "size": 50281,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/中出し4発",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "中出し4発",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/中出し4発.ogg",
    "size": 61172,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/布を引き裂く１",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "布を引き裂く１",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/布を引き裂く１.ogg",
    "size": 20747,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/布を引き裂く２",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "布を引き裂く２",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/布を引き裂く２.ogg",
    "size": 47354,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/布団に寝る",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "布団に寝る",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/布団に寝る.ogg",
    "size": 27939,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  },
  {
    "id": "pix-studio/99_エロ効果音/布団に寝る２",
    "pack": "pix-studio",
    "category": "pix-studio/エロ効果音",
    "categoryLabel": "エロ効果音",
    "name": "布団に寝る２",
    "description": "",
    "path": "builtin/se/pix-studio/99_エロ効果音/布団に寝る２.ogg",
    "size": 32371,
    "tags": [
      "エロ効果音"
    ],
    "adult": true
  }
];

export const BUILTIN_SE_BY_ID: Record<string, BuiltinSeEntry> = Object.fromEntries(
  BUILTIN_SE.map((e) => [e.id, e]),
);

export const BUILTIN_SE_BY_PATH: Record<string, BuiltinSeEntry> = Object.fromEntries(
  BUILTIN_SE.map((e) => [e.path, e]),
);

export function isBuiltinSePath(path: string): boolean {
  return path.startsWith("builtin/se/");
}
